const fr = {
    'chatAiDevis.qualityIncell': 'InCell',
    'chatAiDevis.qualityOled': 'OLED',
    'chatAiDevis.qualityOriginal': 'Original / OEM',
    'chatAiDevis.qualityCompatible': 'Compatible',
    'chatAiDevis.qualityReconditionné': 'Reconditionné',
    'chatAiDevis.qualityPremium': 'Premium',
    'chatAiDevis.qualityStandard': 'Standard',
    'chatAiDevis.fieldName': 'nom',
    'chatAiDevis.fieldPhone': 'téléphone',
    'chatAiDevis.fieldEmail': 'e-mail',
    'chatAiDevis.familyAccessoryStock': 'Accessoire · stock',
    'chatAiDevis.familyAccessoryCapped': 'Accessoire · ≤49€',
    'chatAiDevis.familyAccessory': 'Accessoire',
    'chatAiDevis.familyPart': 'Pièce',
    'chatAiDevis.familyScreen': 'Écran',
    'chatAiDevis.badgeFallback': 'Prix estimé (fallback)',
    'chatAiDevis.badgeModelScore': 'Score modèle {{score}}',
    'chatAiDevis.badgeModelScoreShort': 'Score modèle',
    'chatAiDevis.badgeNeedsReview': 'À vérifier',
    'chatAiDevis.altOtherParts': 'Autres pièces (tous fournisseurs)',
    'chatAiDevis.altSelected': 'Sélectionnée',
    'chatAiDevis.useBtn': 'Utiliser',
    'chatAiDevis.compareTitle': 'Comparatif Jens / Mobilax / LCD-Phone',
    'chatAiDevis.compareCurrentLabel': 'Actuel :',
    'chatAiDevis.htSuffix': 'HT',
    'chatAiDevis.compareNoneFound': 'Aucune pièce trouvée chez les 3 fournisseurs.',
    'chatAiDevis.colSupplier': 'Fournisseur',
    'chatAiDevis.colPart': 'Pièce',
    'chatAiDevis.colPurchaseHt': 'Achat HT',
    'chatAiDevis.colTtcEst': 'TTC est.',
    'chatAiDevis.colStock': 'Stock',
    'chatAiDevis.colExactModel': 'Modèle exact',
    'chatAiDevis.badgeCheapest': 'moins cher',
    'chatAiDevis.badgeCurrent': 'actuel',
    'chatAiDevis.scoreInline': 'score {{score}}',
    'chatAiDevis.compareNoResultFor': 'Sans résultat : {{suppliers}}',
    'chatAiDevis.cadbotEmptyCache': 'Demande CADBOT — cache fournisseur vide. Saisissez le prix achat HT puis Valider pour envoyer le devis.',
    'chatAiDevis.purchaseMissingZero': 'Prix achat manquant (0 €) — Rafraîchir la pièce ou saisir le prix achat manuellement.',
    'chatAiDevis.supplierPrimary': 'principal',
    'chatAiDevis.supplierAlternate': 'alternate',
    'chatAiDevis.defaultRepair': 'Réparation',
    'chatAiDevis.defaultPart': 'Pièce',
    'chatAiDevis.defaultClient': 'Client',
    'chatAiDevis.identityIncompleteInline': 'Fiche client incomplète ({{fields}}) — obligatoire avant validation',
    'chatAiDevis.willSendTo': 'Enverra le devis à {{email}}',
    'chatAiDevis.phName': 'Nom et prénom *',
    'chatAiDevis.phPhone': 'Téléphone *',
    'chatAiDevis.phEmail': 'E-mail *',
    'chatAiDevis.saveIdentityBtn': 'Enregistrer la fiche client',
    'chatAiDevis.ttcCalcul': 'TTC · /calcul',
    'chatAiDevis.selectedPart': 'Pièce sélectionnée',
    'chatAiDevis.purchasePriceHt': 'Prix achat HT',
    'chatAiDevis.labor': 'Main d\'œuvre',
    'chatAiDevis.recalcTotal': 'Recalculer le total',
    'chatAiDevis.hideCompare': 'Masquer le comparatif',
    'chatAiDevis.compareBtn': 'Comparer Jens / Mobilax / LCD-Phone',
    'chatAiDevis.showAlternatives': 'Voir alternatives (liste)',
    'chatAiDevis.hideAlternatives': 'Masquer alternatives (liste)',
    'chatAiDevis.botStaff': 'Bot staff',
    'chatAiDevis.bestPartAuto': 'Meilleure pièce auto',
    'chatAiDevis.pdf': 'PDF',
    'chatAiDevis.approveSingle': 'Valider seul',
    'chatAiDevis.reject': 'Refuser',
    'chatAiDevis.print': 'Imprimer',
    'chatAiDevis.dirAdminTitle': 'Direction / admin magasin',
    'chatAiDevis.delete': 'Supprimer',
    'chatAiDevis.approvedShort': 'Validé',
    'chatAiDevis.rejectedShort': 'Refusé',
    'chatAiDevis.batchLabel': 'Lot {{count}} devis',
    'chatAiDevis.clientChat': 'Chat client',
    'chatAiDevis.approveAllSend': 'Valider les {{count}} & envoyer',
    'chatAiDevis.deleteBatch': 'Supprimer le lot',
    'chatAiDevis.pageTitle': 'Devis IA — validation',
    'chatAiDevis.pageSubtitle': '4 options par demande écran · InCell · OLED · Reconditionné · Original',
    'chatAiDevis.filterPending': 'En attente',
    'chatAiDevis.filterApproved': 'Validés',
    'chatAiDevis.filterRejected': 'Refusés',
    'chatAiDevis.filterAll': 'Tous',
    'chatAiDevis.infoTitle': 'Chat IA & Auto-Devis — fournisseurs',
    'chatAiDevis.infoJensPrimary': 'est le fournisseur principal (priorité au scoring).',
    'chatAiDevis.infoAnd': 'et',
    'chatAiDevis.infoMobilaxLcd': 'sont consultés si meilleure correspondance ou si Jens n\'a pas la pièce.',
    'chatAiDevis.infoEachRange': 'Chaque gamme (InCell, OLED, etc.) peut provenir d\'un fournisseur différent — vérifiez avant validation.',
    'chatAiDevis.infoCompareExplain': '« Comparer Jens / Mobilax / LCD-Phone » affiche le prix d\'achat HT, le TTC estimé, le stock et le modèle exact chez chaque fournisseur — « Utiliser » bascule le brouillon.',
    'chatAiDevis.infoBadgesLabel': 'Badges :',
    'chatAiDevis.infoBadgesCheck': '— contrôlez la pièce avant validation.',
    'chatAiDevis.infoBotStaffExplain': '(panneau à droite) — décrivez une réparation pour créer les brouillons, ou tapez « comparer » pour voir tous les fournisseurs.',
    'chatAiDevis.loading': 'Chargement…',
    'chatAiDevis.noQuotesPending': 'Aucun devis en attente.',
    'chatAiDevis.noQuotes': 'Aucun devis.',
    'chatAiDevis.emptyHint': 'Utilisez le Bot Auto-Devis à droite pour en créer un (ex. « Écran iPhone 14 »).',
    'chatAiDevis.backToStaff': '← Retour espace staff',
    'chatAiDevis.botAutoDevis': 'Bot Auto-Devis',
    'chatAiDevis.staffSpace': '← Espace staff',
    'chatAiDevis.errPdfPreview': 'Erreur aperçu PDF',
    'chatAiDevis.alertPurchaseMissingPrint': 'Prix achat manquant — saisissez un prix ou rafraîchissez la pièce avant impression.',
    'chatAiDevis.errPrintTicket': 'Erreur impression ticket 80mm',
    'chatAiDevis.errRecalc': 'Erreur recalcul',
    'chatAiDevis.errPartNotFound': 'Pièce introuvable dans le cache fournisseur',
    'chatAiDevis.errCompare': 'Erreur comparaison fournisseurs',
    'chatAiDevis.errAlternatives': 'Erreur chargement alternatives',
    'chatAiDevis.errSaveIdentity': 'Erreur enregistrement fiche client',
    'chatAiDevis.alertIdentityIncomplete': 'Fiche client incomplète : {{fields}}. Nom, téléphone et e-mail sont obligatoires avant de valider et d\'envoyer le devis.',
    'chatAiDevis.mailWillSend': 'Un e-mail avec le PDF sera envoyé à : {{email}}',
    'chatAiDevis.noClientEmail': '(Pas d\'e-mail client — validation chat uniquement)',
    'chatAiDevis.confirmApprove': 'Valider ce devis et l\'envoyer au client ?',
    'chatAiDevis.sumupWarn': 'Attention : le lien de paiement SumUp n\'a pas pu être créé ({{error}}). Le bouton du mail proposera le paiement au clic ; vérifiez la clé API SumUp dans la configuration.',
    'chatAiDevis.sumupUnavailable': 'SumUp indisponible',
    'chatAiDevis.approvedMailSent': 'Devis validé — e-mail envoyé à {{email}}.',
    'chatAiDevis.approvedSent': 'Devis validé et envoyé au client.',
    'chatAiDevis.errApprove': 'Erreur validation',
    'chatAiDevis.confirmApproveBatch': 'Valider les {{count}} devis et envoyer le récapitulatif au client ?',
    'chatAiDevis.batchApproved': '{{count}} devis validés et envoyés au client.',
    'chatAiDevis.errApproveBatch': 'Erreur validation lot',
    'chatAiDevis.promptRejectReason': 'Motif de refus (optionnel) :',
    'chatAiDevis.errGeneric': 'Erreur',
    'chatAiDevis.confirmDeleteDevis': 'Supprimer définitivement le devis {{ref}} ?\n\nAction irréversible.',
    'chatAiDevis.errDelete': 'Erreur suppression',
    'chatAiDevis.confirmDeleteBatch': 'Supprimer définitivement les {{count}} devis du lot ?\n\nAction irréversible.',
    'chatAiDevis.errDeleteBatch': 'Erreur suppression lot',
    'saLayout.nav_dashboard': 'Tableau de bord',
    'saLayout.nav_analytics': 'Analytics',
    'saLayout.nav_companies': 'Entreprises',
    'saLayout.nav_subscriptions': 'Abonnements',
    'saLayout.nav_users': 'Utilisateurs',
    'saLayout.nav_stats': 'Statistiques',
    'saLayout.nav_communications': 'Communications',
    'saLayout.nav_impersonation': 'Mode Support',
    'saLayout.nav_config': 'Configuration',
    'saLayout.nav_integrations': 'Intégrations API',
    'saLayout.nav_security': 'Sécurité (2FA)',
    'saLayout.nav_logs': 'Journal & Audit',
    'saLayout.super_admin': 'Super Admin',
    'saLayout.role_super_admin': 'Super Administrateur',
    'saLayout.logout': 'Déconnexion',
    'saLayout.top_bar_title': 'Panneau Super Admin',
    'saConfig.error': 'Erreur',
    'saConfig.confirmMaintenance': 'Activer le mode maintenance ? Les clients ne pourront plus accéder à la plateforme.',
    'saConfig.title': 'Configuration',
    'saConfig.subtitle': 'Paramètres globaux de la plateforme',
    'saConfig.saved': 'Enregistré',
    'saConfig.saving': 'Enregistrement...',
    'saConfig.save': 'Enregistrer',
    'saConfig.maintenanceTitle': 'Mode Maintenance',
    'saConfig.maintenanceDesc': 'Bloquer temporairement l\'accès aux clients',
    'saConfig.generalSettings': 'Paramètres Généraux',
    'saConfig.platformName': 'Nom de la plateforme',
    'saConfig.gracePeriod': 'Période de grâce (jours)',
    'saConfig.plans': 'Plans Tarifaires',
    'saConfig.planPrice': 'Prix (EUR/mois)',
    'saConfig.maxShops': 'Max boutiques',
    'saConfig.maxUsers': 'Max utilisateurs',
    'saConfig.features': 'Fonctionnalités',
    'saImpersonation.title': 'Mode Support (Impersonation)',
    'saImpersonation.subtitle': 'Accéder temporairement au compte d\'une entreprise',
    'saImpersonation.confirmEnter': 'Entrer en mode support pour cette entreprise ?',
    'saImpersonation.errorGeneric': 'Erreur',
    'saImpersonation.activeBannerTitle': 'Mode Support actif',
    'saImpersonation.connectedAs': 'Connecté en tant que : {{name}}',
    'saImpersonation.stopSupport': 'Quitter le mode support',
    'saImpersonation.warningTitle': 'Attention — Fonction sensible',
    'saImpersonation.warningText': 'L\'impersonation vous donne accès complet au compte client. Toutes vos actions sont journalisées. Le mot de passe du client ne sera jamais modifié.',
    'saImpersonation.searchPlaceholder': 'Rechercher une entreprise...',
    'saImpersonation.emptyList': 'Aucune entreprise trouvée',
    'saImpersonation.companyMeta': '{{email}} - Forfait {{plan}}',
    'saImpersonation.enterBtn': 'Entrer',
    'saPackages.title': 'Gestion des packages',
    'saPackages.subtitle': 'Remplacez directement les ZIP et l\'agent Windows servis en production.',
    'saPackages.refresh': 'Actualiser',
    'saPackages.statAvailable': 'Artifacts disponibles',
    'saPackages.statTotalSize': 'Taille totale',
    'saPackages.statAlert': 'Alerte',
    'saPackages.alertText': 'Les remplacements écrasent le fichier live. Il n\'y a pas de suppression distincte.',
    'saPackages.statusAvailable': 'Disponible',
    'saPackages.statusMissing': 'Manquant',
    'saPackages.download': 'Télécharger',
    'saPackages.activeFile': 'Fichier actif',
    'saPackages.size': 'Taille',
    'saPackages.lastUpdate': 'Dernière mise à jour',
    'saPackages.uploadedBy': 'Mis en ligne par',
    'saPackages.replaceLiveFile': 'Remplacer le fichier live',
    'saPackages.uploading': 'Envoi…',
    'saPackages.replace': 'Remplacer',
    'saPackages.replaceHint': 'Le fichier choisi remplace directement celui servi aux utilisateurs sur remobiles.com.',
    'saPackages.selectedFile': 'Fichier sélectionné : {{name}}',
    'saPackages.errorLoad': 'Erreur de chargement des fichiers',
    'saPackages.downloadLinkUnavailable': 'Lien de téléchargement indisponible',
    'saPackages.downloadFailed': 'Téléchargement impossible',
    'saPackages.selectFileFor': 'Sélectionne un fichier pour {{label}}.',
    'saPackages.confirmReplace': 'Remplacer maintenant {{label}} par {{name}} ?',
    'saPackages.replaceSuccess': '{{label}} remplacé avec succès.',
    'saPackages.errorUpload': 'Erreur pendant l\'upload',
    'saPackages.superAdminOnly': 'Accès super admin uniquement',
    'saPackages.superAdminDesc': 'Cette page permet de mettre à jour les fichiers actuellement servis par remobiles.com. Les liens de téléchargement publics restent pilotés par les routes signées du backend.',
    'saDashboard.title': 'Tableau de bord',
    'saDashboard.subtitle': 'Vue d\'ensemble de la plateforme {{brand}}',
    'saDashboard.companies': 'Entreprises',
    'saDashboard.activeCount': '{{count}} actives',
    'saDashboard.users': 'Utilisateurs',
    'saDashboard.shops': 'Boutiques',
    'saDashboard.mrr': 'MRR',
    'saDashboard.mrrSub': 'Revenu mensuel récurrent',
    'saDashboard.newThisMonth': 'Nouveaux ce mois',
    'saDashboard.expired': 'Expirés',
    'saDashboard.suspended': 'Suspendus',
    'saDashboard.recentCompanies': 'Entreprises récentes',
    'saDashboard.viewAll': 'Voir tout',
    'saDashboard.noCompanies': 'Aucune entreprise encore',
    'saDashboard.recentActivity': 'Activité récente',
    'saDashboard.noActivity': 'Aucune activité récente',
    'saAnalytics.title': 'Analytique de la plateforme',
    'saAnalytics.subtitle': 'KPI globaux et performances par entreprise',
    'saAnalytics.kpiRepairsToday': 'Réparations aujourd\'hui',
    'saAnalytics.kpiActiveRepairs': 'Réparations actives',
    'saAnalytics.kpiRevenueMonth': 'Revenu ce mois',
    'saAnalytics.kpiClientsTotal': 'Total clients',
    'saAnalytics.kpiRepairsWeek': 'Réparations semaine',
    'saAnalytics.kpiRepairsMonth': 'Réparations mois',
    'saAnalytics.kpiRepairsTotal': 'Réparations total',
    'saAnalytics.kpiRevenueTotal': 'Revenu total',
    'saAnalytics.kpiActiveCompanies': 'Entreprises actives',
    'saAnalytics.companyPerformance': 'Performance par entreprise',
    'saAnalytics.companiesCount': '{{count}} entreprises',
    'saAnalytics.emptyCompanies': 'Aucune entreprise active',
    'saAnalytics.colCompany': 'Entreprise',
    'saAnalytics.colPlan': 'Plan',
    'saAnalytics.colRepairs': 'Réparations',
    'saAnalytics.colActive': 'Actives',
    'saAnalytics.colClients': 'Clients',
    'saAnalytics.colStock': 'Stock',
    'saAnalytics.colSales': 'Ventes',
    'saAnalytics.colRevenue': 'Revenu',
    'saAnalytics.colAvgTime': 'Temps moy.',
    'saAnalytics.daysShort': '{{n}}j',
    'saLogs.title': 'Journal & Sécurité',
    'saLogs.subtitle': 'Audit des actions et santé du système',
    'saLogs.systemHealth': 'Santé du Système',
    'saLogs.database': 'Base de données',
    'saLogs.statusOk': 'OK',
    'saLogs.statusError': 'Erreur',
    'saLogs.filterAll': 'Toutes les actions',
    'saLogs.filterCreateCompany': 'Création entreprise',
    'saLogs.filterUpdateCompany': 'Modification entreprise',
    'saLogs.filterSuspend': 'Suspension',
    'saLogs.filterActivate': 'Réactivation',
    'saLogs.filterImpersonate': 'Impersonation',
    'saLogs.filterCreateUser': 'Création utilisateur',
    'saLogs.filterDeleteUser': 'Suppression utilisateur',
    'saLogs.filterResetPassword': 'Reset mot de passe',
    'saLogs.filterUpdateSubscription': 'Modification abo',
    'saLogs.filterUpdateConfig': 'Modification config',
    'saLogs.entriesCount': '{{count}} entrées',
    'saLogs.empty': 'Aucune entrée dans le journal',
    'saLogs.onTarget': 'sur {{target}}',
    'saLogs.byUserAt': 'par {{user}} - {{date}}',
    'saComm.title': 'Communications',
    'saComm.messagesSent': '{{count}} messages envoyés',
    'saComm.newMessage': 'Nouveau message',
    'saComm.emptyList': 'Aucune communication envoyée',
    'saComm.noSubject': 'Sans sujet',
    'saComm.allClients': 'Tous les clients',
    'saComm.companiesCount': '{{count}} entreprise(s)',
    'saComm.modalTitle': 'Envoyer une communication',
    'saComm.typeLabel': 'Type',
    'saComm.typeNotification': 'Notification',
    'saComm.typeMaintenance': 'Maintenance',
    'saComm.typeUpdate': 'Mise à jour',
    'saComm.recipients': 'Destinataires',
    'saComm.targetSelected': 'Sélection',
    'saComm.targetedCompanies': 'Entreprises ciblées',
    'saComm.subjectLabel': 'Sujet *',
    'saComm.messageLabel': 'Message *',
    'saComm.cancel': 'Annuler',
    'saComm.send': 'Envoyer',
    'saComm.errorGeneric': 'Erreur',
    'saSecurity.pageTitle': 'Sécurité du compte',
    'saSecurity.pageSubtitle': '2FA, restriction IP et paramètres de sécurité',
    'saSecurity.errorGeneric': 'Erreur',
    'saSecurity.twoFAEnabledSuccess': '2FA activé avec succès !',
    'saSecurity.invalidCode': 'Code invalide',
    'saSecurity.twoFADisabled': '2FA désactivé',
    'saSecurity.saveError': 'Erreur de sauvegarde',
    'saSecurity.twoFATitle': 'Authentification à deux facteurs (2FA)',
    'saSecurity.statusEnabled': 'Activé',
    'saSecurity.statusDisabled': 'Désactivé',
    'saSecurity.setupBtn': 'Configurer 2FA',
    'saSecurity.scanQrInstruction': 'Scannez ce QR code avec Google Authenticator :',
    'saSecurity.qrCodeAlt': 'QR Code',
    'saSecurity.manualKeyInstruction': 'Ou entrez cette clé manuellement :',
    'saSecurity.verificationCodeLabel': 'Code de vérification',
    'saSecurity.verifyBtn': 'Vérifier',
    'saSecurity.disableInstruction': 'Pour désactiver le 2FA, entrez votre code actuel :',
    'saSecurity.ipRestrictionTitle': 'Restriction IP (optionnel)',
    'saSecurity.ipRestrictionSubtitle': 'Limiter l\'accès super admin à certaines adresses IP',
    'saSecurity.ipPlaceholder': 'Une IP par ligne (ex: 192.168.1.1)',
    'saSecurity.saved': 'Enregistré',
    'saSecurity.save': 'Enregistrer',
    'saStats.title': 'Statistiques Business',
    'saStats.subtitle': 'Analyses et projections financières',
    'saStats.mrrTitle': 'Revenu Mensuel Récurrent (MRR)',
    'saStats.planDistTitle': 'Répartition des Plans',
    'saStats.emptyData': 'Aucune donnée',
    'saStats.churnTitle': 'Taux de Résiliation (Churn)',
    'saStats.cancelledCount': '{{count}} annulé(s)',
    'saStats.growthTitle': 'Croissance - Nouvelles entreprises',
    'repairUi.repairs': 'Réparations',
    'repairUi.repairSheet': 'Fiche réparation',
    'repairUi.edit': 'Modifier',
    'repairUi.print': 'Imprimer',
    'repairUi.backToRepairs': 'Retour aux réparations',
    'repairUi.editRepair': 'Modifier la réparation',
    'repairUi.newDeposit': 'Nouveau dépôt',
    'repairUi.ref': 'Réf',
    'saSubscriptions.title': 'Abonnements',
    'saSubscriptions.count': '{{count}} abonnements',
    'saSubscriptions.filter_all_statuses': 'Tous les statuts',
    'saSubscriptions.filter_all_plans': 'Tous les plans',
    'saSubscriptions.status_active': 'Actif',
    'saSubscriptions.status_suspended': 'Suspendu',
    'saSubscriptions.status_expired': 'Expiré',
    'saSubscriptions.status_overdue': 'En retard',
    'saSubscriptions.status_cancelled': 'Annulé',
    'saSubscriptions.col_company': 'Entreprise',
    'saSubscriptions.col_plan': 'Plan',
    'saSubscriptions.col_price': 'Prix',
    'saSubscriptions.col_status': 'Statut',
    'saSubscriptions.col_next_billing': 'Prochaine facturation',
    'saSubscriptions.col_discount': 'Remise',
    'saSubscriptions.col_actions': 'Actions',
    'saSubscriptions.empty': 'Aucun abonnement',
    'saSubscriptions.action_edit': 'Modifier',
    'saSubscriptions.action_extend': 'Prolonger',
    'saSubscriptions.modal_title': 'Modifier l\'abonnement',
    'saSubscriptions.label_discount': 'Remise (%)',
    'saSubscriptions.plan_option_start': 'Start ({{price}})',
    'saSubscriptions.plan_option_pro': 'Pro ({{price}})',
    'saSubscriptions.plan_option_super': 'Super ({{price}})',
    'saSubscriptions.cancel': 'Annuler',
    'saSubscriptions.save': 'Sauvegarder',
    'saSubscriptions.prompt_extend_days': 'Nombre de jours à ajouter :',
    'saSubscriptions.error': 'Erreur',
    'saUsers.title': 'Utilisateurs',
    'saUsers.totalUsers': '{{count}} utilisateurs',
    'saUsers.newUser': 'Nouvel utilisateur',
    'saUsers.searchPlaceholder': 'Rechercher...',
    'saUsers.filterAllRoles': 'Tous les rôles',
    'saUsers.roleSuperAdmin': 'Super Admin',
    'saUsers.roleAdmin': 'Admin',
    'saUsers.roleUser': 'Employé',
    'saUsers.roleTechnicien': 'Technicien',
    'saUsers.roleClient': 'Client',
    'saUsers.roleB2b': 'B2B',
    'saUsers.emptyState': 'Aucun utilisateur trouvé',
    'saUsers.colUser': 'Utilisateur',
    'saUsers.colRole': 'Rôle',
    'saUsers.colCompany': 'Entreprise',
    'saUsers.colCreatedAt': 'Créé le',
    'saUsers.colActions': 'Actions',
    'saUsers.resetPassword': 'Réinitialiser mot de passe',
    'saUsers.delete': 'Supprimer',
    'saUsers.labelUsername': 'Nom d\'utilisateur',
    'saUsers.labelEmail': 'Email',
    'saUsers.labelPassword': 'Mot de passe',
    'saUsers.companyNone': 'Aucune',
    'saUsers.cancel': 'Annuler',
    'saUsers.create': 'Créer',
    'saUsers.labelNewPassword': 'Nouveau mot de passe',
    'saUsers.reset': 'Réinitialiser',
    'saUsers.error': 'Erreur',
    'saUsers.resetSuccess': 'Mot de passe réinitialisé avec succès',
    'saUsers.confirmDelete': 'Supprimer l\'utilisateur {{username}} ?',
    'saCompanies.status_active': 'Actif',
    'saCompanies.status_suspended': 'Suspendu',
    'saCompanies.status_overdue': 'Retard',
    'saCompanies.status_archived': 'Archivé',
    'saCompanies.error': 'Erreur',
    'saCompanies.confirm_suspend': 'Suspendre cette entreprise ?',
    'saCompanies.suspend_reason_manual': 'Suspendu manuellement',
    'saCompanies.confirm_archive': 'Archiver cette entreprise ? Cette action est irréversible.',
    'saCompanies.reminder_sent': 'E-mail de rappel envoyé',
    'saCompanies.reminder_error': 'Erreur lors de l\'envoi',
    'saCompanies.title': 'Entreprises',
    'saCompanies.total_companies': '{{count}} entreprises au total',
    'saCompanies.new_company': 'Nouvelle entreprise',
    'saCompanies.search_placeholder': 'Rechercher...',
    'saCompanies.filter_all_status': 'Tous les statuts',
    'saCompanies.filter_overdue': 'En retard',
    'saCompanies.filter_all_plans': 'Tous les plans',
    'saCompanies.empty': 'Aucune entreprise trouvée',
    'saCompanies.col_company': 'Entreprise',
    'saCompanies.col_plan': 'Plan',
    'saCompanies.col_status': 'Statut',
    'saCompanies.col_users': 'Utilisateurs',
    'saCompanies.col_registered': 'Inscrit le',
    'saCompanies.col_actions': 'Actions',
    'saCompanies.action_view': 'Voir',
    'saCompanies.action_reminder': 'Envoyer un rappel de paiement',
    'saCompanies.action_suspend': 'Suspendre',
    'saCompanies.action_reactivate': 'Réactiver',
    'saCompanies.action_archive': 'Archiver',
    'saCompanies.field_company_name': 'Nom de l\'entreprise',
    'saCompanies.field_contact': 'Contact principal',
    'saCompanies.field_email': 'Email',
    'saCompanies.field_phone': 'Téléphone',
    'saCompanies.field_address': 'Adresse',
    'saCompanies.field_plan': 'Plan d\'abonnement',
    'saCompanies.plan_option_start': 'Start ({{price}}/mois)',
    'saCompanies.plan_option_pro': 'Pro ({{price}}/mois)',
    'saCompanies.plan_option_super': 'Super ({{price}}/mois)',
    'saCompanies.field_shop_count': 'Nombre de boutiques',
    'saCompanies.admin_account': 'Compte Admin de l\'entreprise',
    'saCompanies.field_admin_email': 'Email admin',
    'saCompanies.field_password': 'Mot de passe',
    'saCompanies.field_notes': 'Notes internes',
    'saCompanies.cancel': 'Annuler',
    'saCompanies.create_company': 'Créer l\'entreprise',
    'saCompanies.users_count': '{{count}} utilisateurs',
    'saCompanies.subscription': 'Abonnement',
    'saCompanies.monthly_price': 'Prix mensuel',
    'saCompanies.next_billing': 'Prochaine facturation',
    'saCompanies.no_users': 'Aucun utilisateur',
    'qrRouter.redirecting': 'Redirection...',
    'subscriptionPages.verifyingPayment': 'Vérification du paiement...',
    'subscriptionPages.successTitle': 'Paiement réussi !',
    'subscriptionPages.successBody': 'Votre abonnement est maintenant actif.',
    'subscriptionPages.goToDashboard': 'Accéder au tableau de bord',
    'subscriptionPages.processingPayment': 'Paiement en cours de traitement...',
    'subscriptionPages.errorTitle': 'Erreur',
    'subscriptionPages.errorBody': 'Impossible de vérifier le paiement.',
    'subscriptionPages.backToDashboard': 'Retour au tableau de bord',
    'subscriptionPages.cancelTitle': 'Paiement annulé',
    'subscriptionPages.cancelBody': 'Le paiement a été annulé. Vous pouvez réessayer à tout moment.',
    'common.error': 'Erreur',
    'notes.uploadError': 'Erreur lors de l\'upload',
    'notes.downloadError': 'Erreur lors du téléchargement',
    'notes.confirmDeleteFile': 'Supprimer ce fichier ?',
    'notes.uploading': 'Upload...',
    'notes.attach': 'Joindre',
    'notes.addedBy': 'Ajouté par {{author}} — {{date}}',
    'notes.sizeBytes': '{{size}} o',
    'notes.sizeKb': '{{size}} Ko',
    'notes.sizeMb': '{{size}} Mo',
    'historique.subtitle': 'Ventes, tickets et acomptes',
    'historique.centreActivite': 'Centre Activité',
    'historique.filtresRecherche': 'Filtres & recherche',
    'historique.rechercher': 'Rechercher',
    'historique.searchPlaceholder': 'Article, référence…',
    'historique.vendeur': 'Vendeur',
    'historique.tous': 'Tous',
    'historique.dateDebut': 'Date début',
    'historique.dateFin': 'Date fin',
    'historique.magasin': 'Magasin',
    'historique.filtrer': 'Filtrer',
    'historique.reinitialiser': 'Réinitialiser',
    'historique.totalVentes': 'Total ventes',
    'historique.totalAcomptes': 'Total acomptes',
    'historique.totalRetraits': 'Total retraits',
    'historique.totalGlobal': 'Total global',
    'historique.commVentes': 'Com. ventes ({{pct}}%)',
    'historique.commReparations': 'Com. réparations ({{pct}}%)',
    'historique.commCommandes': 'Com. commandes ({{pct}}%)',
    'historique.totalCommissions': 'Total commissions',
    'historique.popupsAutoriser': 'Veuillez autoriser les popups pour imprimer.',
    'historique.erreurTelechargement': 'Erreur lors du téléchargement',
    'historique.vendeurDatesRequis': 'Veuillez renseigner vendeur + dates',
    'historique.erreurImpressionRapport': 'Erreur impression rapport',
    'historique.erreurConfirmationSumup': 'Erreur lors de la confirmation SumUp',
    'historique.confirmRefusPaiement': 'Marquer ce paiement comme refusé / annulé ?',
    'historique.erreurRefusSumup': 'Erreur lors du refus SumUp',
    'dash.forceOpen': 'Forcer ouverture',
    'dash.force': 'Forcer',
    'dash.forceOpenTitle': 'Forcer ouverture de caisse {{magasin}}',
    'dash.forceOpenWarning': 'Toute caisse ouverte sera automatiquement fermée. Une nouvelle caisse sera créée avec le montant indiqué.',
    'dash.noOpenCaisseToForce': 'Aucune caisse ouverte à fermer de force pour {{magasin}}.',
    'dash.thisMagasin': 'ce magasin',
    'dash.statusOpenF': 'Ouverte',
    'dash.statusClosedF': 'Fermée',
    'dash.openMagasin': 'Ouvrir {{magasin}}',
    'dash.forceOpenShort': 'Force ouvrir',
    'dash.closeMagasin': 'Fermer {{magasin}}',
    'dash.forceCloseShort': 'Force fermer',
    'dash.subtitleNetwork': 'Vue réseau · caisse · KPIs',
    'dash.subtitleWorkshop': 'Atelier · réparations',
    'dash.subtitleDefault': 'Tableau de bord · ventes & activité',
    'dash.caisseActionsByStore': 'Actions caisse par magasin',
    'devisFactures.printPopupBlocked': 'Veuillez autoriser les popups pour imprimer.',
    'devisFactures.errorPrintTicket': 'Erreur impression ticket',
    'devisFactures.errorPrintA4': 'Erreur impression A4',
    'devisFactures.errorConvert': 'Erreur conversion commande',
    'devisFactures.errorDelete': 'Erreur suppression',
    'devisFactures.errorInvalidEmail': 'Adresse email invalide',
    'devisFactures.emailSent': '{{type}} envoyé à {{email}}',
    'devisFactures.errorSendEmail': 'Erreur envoi email',
    'devisFactures.linkedTo': 'Lié à {{ref}}',
    'devisFactures.sendByEmail': 'Envoyer par email',
    'devisFactures.detachConfirm': 'Détacher ce devis de {{ref}} ?',
    'devisFactures.error': 'Erreur',
    'devisFactures.attachToRepair': 'Attacher à une réparation',
    'devisFactures.emailModalTitle': 'Envoyer {{type}} par email',
    'devisFactures.refLabel': 'Réf :',
    'devisFactures.a4PdfNote': 'Le document sera envoyé en format A4 PDF',
    'devisFactures.clientEmailLabel': 'Adresse email du client',
    'devisFactures.emailPlaceholder': 'client@exemple.com',
    'devisFactures.labelDevis': 'Devis',
    'devisFactures.labelFacture': 'Facture',
    'devisFactures.labelCommande': 'Commande',
    'devisFactures.labelAvoir': 'Avoir',
    'devisFactures.labelPaye': 'Payé',
    'devisFactures.labelAnnule': 'Annulé',
    'devisFactures.labelEnAttente': 'En attente',
    'clients.tabPins': 'PINs / Mots de passe',
    'clients.pin': 'PIN',
    'clients.error': 'Erreur',
    'clients.loadError': 'Erreur lors du chargement',
    'clients.saveError': 'Erreur lors de l\'enregistrement',
    'clients.sendError': 'Erreur envoi',
    'clients.noIdLegacy': 'Ce client n\'a pas d\'ID (legacy). Modifiez-le pour le mettre à jour.',
    'clients.ficheAccessDenied': 'Accès refusé : seul l\'admin peut consulter la fiche client.',
    'clients.pinGenerated': 'PIN {{pin}} généré pour {{nom}}',
    'clients.ficheClient': 'Fiche client',
    'clients.optional': 'Optionnel',
    'clients.genNewPin': 'Générer nouveau PIN',
    'clients.sendPinEmail': 'Envoyer PIN par email',
    'clients.loyaltyLine': 'Fidélité : {{level}} — {{points}} pts — {{purchases}} achats',
    'clients.repairs': 'Réparations',
    'clients.commandes': 'Commandes',
    'clients.devis': 'Devis',
    'clients.ventesPos': 'Ventes POS',
    'clients.acomptes': 'Acomptes',
    'clients.noneFem': 'Aucune',
    'clients.noneMasc': 'Aucun',
    'cmd.clientPartsTitle': 'Commandes pièces clients',
    'cmd.pageIntro': 'Ajoutez des pièces (stock ou à commander) comme en réparation. Les acomptes se déduisent du total.',
    'cmd.deposits': 'Acomptes',
    'cmd.remainingShort': 'Reste',
    'cmd.statusConverting': 'En conversion',
    'cmd.repairBadge': 'Réparation {{ref}}',
    'cmd.toOrderShort': 'à cmd',
    'cmd.stockOutShort': 'sorti stock',
    'cmd.inStockShort': 'en stock',
    'cmd.view': 'Voir',
    'cmd.addDeposit': '+ Acompte',
    'cmd.settled': 'Soldé',
    'cmd.convertToRepair': 'Transformer en réparation',
    'cmd.trackingWith': 'Suivi : {{num}}',
    'cmd.trackingNumber': 'Numéro de suivi',
    'cmd.newClientParts': 'Nouvelle commande pièces',
    'cmd.partsSectionTitle': 'Pièces (comme en réparation)',
    'cmd.searchStockPlaceholder': 'Rechercher une pièce en stock…',
    'cmd.noRef': 'sans réf.',
    'cmd.toOrder': 'à commander',
    'cmd.stock': 'stock',
    'cmd.qtyShort': 'Qté',
    'cmd.unitPriceLabel': 'Prix U. (€)',
    'cmd.stockSection': 'Stock',
    'cmd.alreadyOut': 'Déjà sorti du stock',
    'cmd.decrementOnSave': 'Décrémente à l\'enregistrement',
    'cmd.stillInStock': 'Encore en stock',
    'cmd.outOnConvert': 'Sortie à la conversion réparation',
    'cmd.addPendingBtn': 'Pièce à commander (hors stock)',
    'cmd.pendingTitle': 'Pièce à commander',
    'cmd.designationPlaceholder': 'Désignation *',
    'cmd.refOptPlaceholder': 'Réf. (opt.)',
    'cmd.salePricePlaceholder': 'Prix vente €',
    'cmd.partsTotal': 'Total pièces',
    'cmd.depositsPaid': 'Acomptes déjà versés',
    'cmd.addDepositTitle': 'Ajouter un acompte',
    'cmd.orderLabel': 'Commande',
    'cmd.alreadyPaid': 'Déjà versé',
    'cmd.depositAmount': 'Montant acompte (€)',
    'cmd.paymentMode': 'Mode de paiement',
    'cmd.payCash': 'Espèces',
    'cmd.payCard': 'CB',
    'cmd.payTransfer': 'Virement',
    'cmd.payCheck': 'Chèque',
    'cmd.newRemainingAfter': 'Nouveau reste après acompte :',
    'cmd.depositsPaidTitle': 'Acomptes versés',
    'cmd.noDeposits': 'Aucun acompte versé',
    'cmd.trackingPlaceholder': 'Ex. 8R123456789FR',
    'cmd.trackingEmailNote': 'Un e-mail sera envoyé au client si un email est renseigné.',
    'cmd.error': 'Erreur',
    'cmd.errDesignationRequired': 'Désignation requise pour la pièce à commander',
    'cmd.errClientPhoneRequired': 'Client et téléphone requis',
    'cmd.errAddPart': 'Ajoutez au moins une pièce (recherche stock ou pièce à commander)',
    'cmd.errDelete': 'Erreur lors de la suppression',
    'cmd.cancelConfirm': 'Annuler cette commande ?',
    'cmd.errInvalidAmount': 'Montant invalide',
    'cmd.errDepositExceeds': 'L\'acompte ne peut pas dépasser le reste à payer ({{reste}})',
    'cmd.errPrintTicket': 'Erreur impression ticket',
    'cmd.errPrintDepositTicket': 'Erreur impression ticket acompte',
    'cmd.convertConfirm': 'Transformer cette commande en réparation ?',
    'cmd.errConvert': 'Erreur conversion réparation',
    'cmd.promptClientEmail': 'Email du client :',
    'cmd.emailSent': 'Bon de commande envoyé à {{email}}',
    'cmd.errSendEmail': 'Erreur envoi email',
    'cmd.errTracking': 'Erreur suivi',
    'pos.insufficientStock': 'Stock insuffisant',
    'pos.partialPaymentConfirm': 'Le montant payé ({{paid}}) est inférieur au total ({{total}}).\n\nReste à payer : {{remaining}}\n\nValider comme paiement partiel ?',
    'pos.loyaltyRewardEarned': '\n\nFIDÉLITÉ : Bravo ! Récompense débloquée ! 15 % sur le prochain achat ou 10 % sur la prochaine réparation !',
    'pos.loyaltyRewardPending': '\n\nFIDÉLITÉ : Récompense en attente (15 % prochain achat POS ou 10 % réparation)',
    'pos.loyaltyProgress': '\n\nFIDÉLITÉ : {{points}}/10 achats. Plus que {{remaining}} achat(s) avant la récompense !',
    'pos.partialPaymentLine': '\nPAIEMENT PARTIEL - Reste à payer : {{remaining}}',
    'pos.invoiceSentAuto': '\nFacture envoyée automatiquement à {{email}}',
    'pos.offlineSaleMsg': '\n\nMODE HORS LIGNE - Vente enregistrée localement.\nLa synchronisation se fera automatiquement dès le retour d\'Internet.\n(L\'envoi e-mail et la mise à jour du stock se feront à ce moment-là.)',
    'pos.refLabel': 'Réf : {{ref}}',
    'pos.totalLabel': 'Total : {{total}}',
    'pos.saleError': 'Erreur lors de la vente.\nCode HTTP : {{code}}\nLa vente n\'a peut-être pas été enregistrée. Vérifier l\'historique.',
    'pos.unknownStatus': 'inconnu',
    'pos.invalidEmailEnter': 'Veuillez entrer une adresse e-mail valide',
    'pos.accountCreated': 'Compte client créé ! Les identifiants ont été envoyés par e-mail.',
    'pos.accountCreateError': 'Erreur lors de la création du compte',
    'pos.invalidAmount': 'Montant invalide',
    'pos.acompteDesignation': 'Acompte réparation {{ref}}',
    'pos.designationPriceRequired': 'Désignation et prix requis',
    'pos.manualAddError': 'Erreur ajout manuel',
    'pos.adminValidationFailed': 'Validation admin échouée',
    'pos.printTicketError': 'Erreur impression ticket',
    'pos.notAllTicketsPrintedConfirm': '⚠️ Vous n\'avez pas imprimé tous les tickets.\n\nLe client doit avoir chaque ticket. Fermer quand même ?',
    'pos.invalidEmail': 'Adresse e-mail invalide',
    'pos.invoiceSentTo': 'Facture envoyée à {{email}}',
    'pos.sendEmailError': 'Erreur envoi e-mail',
    'pos.caisseClosedOffline': 'Caisse fermée. Connectez-vous à Internet et ouvrez la caisse depuis le tableau de bord pour effectuer des ventes.',
    'pos.caisseCachedHint': 'État caisse récupéré du cache local (mode hors ligne). La vérification finale aura lieu au retour d\'Internet.',
    'pos.catalog': 'Catalogue',
    'pos.available': '{{count}} dispo',
    'pos.outOfStockShort': 'Rupture',
    'pos.acompteRepair': 'Acompte réparation',
    'pos.rewardAvailable': 'Récompense disponible !',
    'pos.rewardAutoApplied': '-15 % auto-appliqué',
    'pos.purchases': 'achats',
    'pos.beforeReward': '({{count}} avant récompense)',
    'pos.searchClientPlaceholder': 'Rechercher...',
    'pos.clientName': 'Nom client',
    'pos.phone': 'Téléphone',
    'pos.emailOptional': 'E-mail (optionnel)',
    'pos.totalCaps': 'TOTAL',
    'pos.willGenerateTickets': 'Cette vente générera {{count}} tickets séparés :',
    'pos.neutralItems': 'neutres',
    'pos.attachedToSession': '(rattachés à la session)',
    'pos.clientEmailPlaceholder': 'E-mail du client',
    'pos.sent': 'Envoyé',
    'pos.send': 'Envoyer',
    'pos.alsoAddToStock': 'Ajouter aussi dans le stock',
    'pos.offlineCbHint': 'Mode hors ligne — paiement Carte Bancaire désactivé (terminal nécessite le réseau).',
    'pos.whichMagasinTitle': 'Enregistrer la vente dans quel magasin ?',
    'pos.close': 'Fermer',
    'pos.magasinChoiceHelp': 'Choisis le magasin d\'enregistrement pour cette vente. Le magasin sélectionné sera utilisé pour la vente et pour les articles sans magasin explicite.',
    'pos.magasinLabel': 'Magasin {{code}}',
    'pos.currentPosSessionFull': 'Session POS actuelle : {{code}}. Si tu choisis un autre magasin, la session POS basculera dessus pour la vente.',
    'pos.validateFor': 'Valider pour {{magasin}}',
    'pos.createClientAccount': 'Créer un compte client ?',
    'pos.createAccountPrompt': 'Ce client n\'a pas encore de compte. Souhaitez-vous lui créer un compte pour accéder à ses factures en ligne ?',
    'pos.creating': 'Création...',
    'pos.yesSendCredentials': 'Oui, envoyer les identifiants',
    'pos.noThanks': 'Non merci',
    'pos.searchRepair': 'Rechercher la réparation',
    'pos.searchRepairPlaceholder': 'REP0047, nom client, modèle...',
    'pos.priceLabel': 'Prix : {{price}}',
    'pos.alreadyPaid': 'Déjà payé : {{amount}}',
    'pos.remainingDue': 'Reste dû : {{amount}}',
    'pos.changeSelection': 'Changer',
    'pos.totalPrice': 'Prix total',
    'pos.alreadyPaidShort': 'Déjà payé',
    'pos.remainingDueShort': 'Reste dû',
    'pos.acompteAmountLabel': 'Montant de l\'acompte (EUR)',
    'pos.addToCart': 'Ajouter au panier',
    'pos.saleRecordedTickets': 'Vente enregistrée — {{count}} tickets générés',
    'pos.printAllForClient': 'Imprime les {{count}} tickets pour le client.',
    'pos.printed': 'Imprimé',
    'pos.scanToFind': 'Scan pour retrouver {{ref}}',
    'pos.detailUnavailable': 'Détail indisponible (mode hors-ligne ?)',
    'pos.payment': 'Paiement',
    'pos.printing': 'Impression...',
    'pos.printTicketFor': 'Imprimer ticket {{magasin}}',
    'pos.allTicketsSentToPrint': 'Tous les tickets ont été envoyés à l\'impression.',
    'pos.ticketsPrintedCount': '{{printed}} / {{total}} ticket(s) imprimé(s).',
    'pos.printAllTickets': 'Imprimer tous les tickets',
    'pos.articlesCount': '{{count}} article(s)',
    'activite.pageTitle': 'Centre Activité',
    'activite.pageSubtitle': 'Timeline unifiée · ventes · paiements · caisse · stock · réparations',
    'activite.historiqueDetaille': 'Historique détaillé',
    'remcaches.err_connexion': 'Erreur de connexion au serveur',
    'remcaches.err_champs_requis': 'Nom d\'utilisateur et code PIN obligatoires',
    'remcaches.err_pin_court': 'Le code PIN doit contenir au moins 4 chiffres',
    'remcaches.err_creation': 'Erreur lors de la création',
    'remcaches.config_initiale': 'Configuration initiale',
    'remcaches.deja_config': 'Configuration déjà effectuée',
    'remcaches.admin_existe': 'Un administrateur existe déjà. Cette page est désactivée.',
    'remcaches.aller_connexion': 'Aller à la connexion',
    'remcaches.admin_cree': 'Administrateur créé avec succès !',
    'remcaches.label_utilisateur': 'Utilisateur :',
    'remcaches.label_role': 'Rôle :',
    'remcaches.conserver_identifiants': 'Conservez ces identifiants en lieu sûr. Cette page ne sera plus accessible.',
    'remcaches.se_connecter': 'Se connecter',
    'remcaches.label_username': 'Nom d\'utilisateur *',
    'remcaches.ph_username': 'ex. : carlos',
    'remcaches.label_pin': 'Code PIN (mot de passe) *',
    'remcaches.ph_pin': '4 à 6 chiffres',
    'remcaches.label_email': 'Email (optionnel)',
    'remcaches.label_telephone': 'Téléphone (optionnel)',
    'remcaches.btn_creer_admin': 'Créer l\'administrateur',
    'remcaches.footer': 'R.E.Mobiles - Configuration sécurisée',
    'blog.page_title': 'Blog Réparation Téléphone',
    'blog.subtitle': 'Conseils, astuces et actualités sur la réparation de smartphones en Guyane Française.',
    'blog.cta_title': 'Besoin d\'une réparation ?',
    'blog.cta_desc': 'Contactez Resurrection Mobile pour un devis gratuit.',
    'blog.loading': 'Chargement...',
    'blog.article_not_found': 'Article introuvable',
    'blog.back_to_blog': 'Retour au blog',
    'blog.home': 'Accueil',
    'blog.see_pricing': 'Voir nos tarifs',
    'blog.footer_pricing': 'Nos tarifs',
    'blog.empty_title': 'Aucun article pour le moment',
    'blog.empty_subtitle': 'Revenez bientôt pour découvrir nos conseils !',
    'brandsModels.error': 'Erreur',
    'brandsModels.deleteBrandConfirm': 'Supprimer la marque « {{name}} » et tous ses modèles ?',
    'brandsModels.noModels': 'Aucun modèle.',
    'brandsModels.home': 'Accueil',
    'brandsModels.title': 'Marques & Modèles',
    'brandsModels.countBrands': '{{count}} marques',
    'brandsModels.countSeries': '{{count}} séries',
    'brandsModels.countModels': '{{count}} modèles',
    'brandsModels.searchPlaceholder': 'Rechercher une marque, série ou modèle...',
    'brandsModels.newBrandPlaceholder': 'Nouvelle marque...',
    'brandsModels.addBrand': 'Ajouter',
    'brandsModels.loading': 'Chargement...',
    'brandsModels.rename': 'Renommer',
    'brandsModels.delete': 'Supprimer',
    'brandsModels.addModelPlaceholder': 'Ajouter un modèle {{brand}}...',
    'brandsModels.addModel': 'Modèle',
    'brandsModels.deleteModel': 'Supprimer ce modèle',
    'brandsModels.noResults': 'Aucun résultat pour cette recherche',
    'brandsModels.empty': 'Aucune marque. Ajoutez-en une ci-dessus.',
    'allDocs.title': 'Tous les documents',
    'allDocs.docsCount': '{{count}} documents',
    'allDocs.stat.devis': 'Devis',
    'allDocs.stat.factures': 'Factures',
    'allDocs.stat.bonsCmd': 'Bons cmd',
    'allDocs.stat.tickets': 'Tickets',
    'allDocs.stat.total': 'Total',
    'allDocs.searchPlaceholder': 'Rechercher par réf, client, téléphone...',
    'allDocs.filter': 'Filtrer',
    'allDocs.filterAll': 'Tous',
    'allDocs.type.devis': 'Devis',
    'allDocs.type.facture': 'Facture',
    'allDocs.type.bonCommande': 'Bon de commande',
    'allDocs.type.ticket': 'Ticket',
    'allDocs.col.reference': 'Référence',
    'allDocs.col.type': 'Type',
    'allDocs.col.client': 'Client',
    'allDocs.col.telephone': 'Téléphone',
    'allDocs.col.total': 'Total',
    'allDocs.col.statut': 'Statut',
    'allDocs.col.liaisons': 'Liaisons',
    'allDocs.col.date': 'Date',
    'allDocs.col.actions': 'Actions',
    'allDocs.loading': 'Chargement...',
    'allDocs.empty': 'Aucun document trouvé',
    'allDocs.status.devis': 'Devis',
    'allDocs.status.enAttente': 'En attente',
    'allDocs.status.accepte': 'Accepté',
    'allDocs.status.refuse': 'Refusé',
    'allDocs.status.payee': 'Payée',
    'allDocs.status.commande': 'Commandé',
    'allDocs.status.enCours': 'En cours',
    'allDocs.status.recu': 'Reçu',
    'allDocs.status.livre': 'Livré',
    'allDocs.status.termine': 'Terminé',
    'allDocs.action.print': 'Imprimer / Voir PDF',
    'allDocs.action.download': 'Télécharger PDF',
    'allDocs.action.email': 'Envoyer par e-mail',
    'allDocs.footerCount': '{{count}} document affiché',
    'allDocs.footerCountPlural': '{{count}} documents affichés',
    'allDocs.printUnavailable': 'Impression ticket 80 mm indisponible pour ce document (source={{source}}).',
    'allDocs.downloadUnavailable': 'Téléchargement indisponible pour ce type de document (source={{source}}).',
    'allDocs.emailUnavailable': 'Envoi par e-mail non disponible pour ce type de document (source={{source}}).',
    'allDocs.emailPrompt': 'E-mail du destinataire :',
    'allDocs.emailSent': 'E-mail envoyé !',
    'allDocs.error': 'Erreur : {{msg}}',
    'themeSettings.title': 'Personnalisation des couleurs',
    'themeSettings.subtitle': 'Adaptez l\'apparence de votre plateforme',
    'themeSettings.cancel': 'Annuler',
    'themeSettings.saved': 'Enregistré',
    'themeSettings.saving': 'Enregistrement...',
    'themeSettings.save': 'Enregistrer',
    'themeSettings.presetsTitle': 'Palettes prédéfinies',
    'themeSettings.customTitle': 'Couleurs personnalisées',
    'themeSettings.previewTitle': 'Aperçu en direct',
    'themeSettings.previewCompany': 'Mon Entreprise',
    'themeSettings.previewPrimaryBtn': 'Bouton Principal',
    'themeSettings.previewSecondaryBtn': 'Bouton Secondaire',
    'themeSettings.previewNavDashboard': 'Tableau de bord',
    'themeSettings.previewNavRepairs': 'Réparations',
    'themeSettings.previewNavStock': 'Stock',
    'themeSettings.previewNavClients': 'Clients',
    'themeSettings.previewStatusInProgress': 'En cours',
    'themeSettings.previewStatusPending': 'En attente',
    'themeSettings.fieldPrimaryLabel': 'Couleur Principale',
    'themeSettings.fieldPrimaryDesc': 'Boutons, liens, accents principaux',
    'themeSettings.fieldSecondaryLabel': 'Couleur Secondaire',
    'themeSettings.fieldSecondaryDesc': 'Badges, indicateurs, accents secondaires',
    'themeSettings.fieldAccentLabel': 'Couleur Accent',
    'themeSettings.fieldAccentDesc': 'Fond des en-têtes, texte contrasté',
    'themeSettings.fieldSidebarBgLabel': 'Fond Sidebar',
    'themeSettings.fieldSidebarBgDesc': 'Arrière-plan du menu latéral',
    'themeSettings.fieldSidebarTextLabel': 'Texte Sidebar',
    'themeSettings.fieldSidebarTextDesc': 'Couleur du texte dans le menu',
    'themeSettings.fieldHeaderBgLabel': 'Fond En-tête',
    'themeSettings.fieldHeaderBgDesc': 'Arrière-plan de la barre supérieure',
    'themeSettings.presetRougeJaune': 'Rouge & Jaune',
    'themeSettings.presetGuyane': 'Guyane',
    'themeSettings.presetOceanBleu': 'Océan Bleu',
    'themeSettings.presetRoyalViolet': 'Royal Violet',
    'themeSettings.presetEmeraude': 'Émeraude',
    'themeSettings.presetSunset': 'Coucher de soleil',
    'boutiqueCmd.pageTitle': 'Commandes E-shop',
    'boutiqueCmd.deleteSelection': 'Supprimer sélection ({{count}})',
    'boutiqueCmd.confirmDelete': 'Supprimer {{count}} commande(s) ?',
    'boutiqueCmd.errUpdate': 'Erreur lors de la mise à jour',
    'boutiqueCmd.errDelete': 'Erreur lors de la suppression',
    'boutiqueCmd.noteSent': '✅ Note envoyée au client avec succès',
    'boutiqueCmd.errSendNote': 'Erreur lors de l\'envoi de la note',
    'boutiqueCmd.trackingSavedEmail': '✅ Numéro de suivi enregistré et email envoyé au client !',
    'boutiqueCmd.trackingSaved': '✅ Numéro de suivi enregistré !',
    'boutiqueCmd.errSaveTracking': 'Erreur lors de l\'enregistrement',
    'boutiqueCmd.confirmValidateProof': 'Valider cette preuve de paiement ?',
    'boutiqueCmd.confirmRejectProof': 'Refuser cette preuve de paiement ?',
    'boutiqueCmd.errGeneric': 'Erreur',
    'boutiqueCmd.errDownload': 'Erreur lors du téléchargement',
    'boutiqueCmd.statutEnAttente': 'En attente',
    'boutiqueCmd.statutProofUploaded': 'Preuve envoyée',
    'boutiqueCmd.statutPayee': 'Payée',
    'boutiqueCmd.statutConfirmee': 'Confirmée',
    'boutiqueCmd.statutPreparee': 'Préparée',
    'boutiqueCmd.statutExpediee': 'Expédiée',
    'boutiqueCmd.statutLivree': 'Livrée',
    'boutiqueCmd.statutAnnulee': 'Annulée',
    'boutiqueCmd.colReference': 'Référence',
    'boutiqueCmd.colClient': 'Client',
    'boutiqueCmd.colArticles': 'Articles',
    'boutiqueCmd.colTotal': 'Total',
    'boutiqueCmd.colAdresse': 'Adresse',
    'boutiqueCmd.colStatut': 'Statut',
    'boutiqueCmd.colSuivi': 'Suivi',
    'boutiqueCmd.colPaiement': 'Paiement',
    'boutiqueCmd.colDate': 'Date',
    'boutiqueCmd.colActions': 'Actions',
    'boutiqueCmd.noOrders': 'Aucune commande',
    'boutiqueCmd.editTracking': 'Modifier',
    'boutiqueCmd.addTrackingTitle': 'Ajouter numéro de suivi',
    'boutiqueCmd.addTrackingBtn': '+ Suivi',
    'boutiqueCmd.viewProof': 'Voir la preuve',
    'boutiqueCmd.validatePayment': 'Valider le paiement',
    'boutiqueCmd.rejectProof': 'Refuser la preuve',
    'boutiqueCmd.validated': 'Validé',
    'boutiqueCmd.notesMessages': 'Notes/Messages',
    'boutiqueCmd.notesModalTitle': 'Notes & Messages - Commande {{ref}}',
    'boutiqueCmd.clientLabel': 'Client :',
    'boutiqueCmd.phoneLabel': 'Téléphone :',
    'boutiqueCmd.deliveryAddressLabel': 'Adresse de livraison :',
    'boutiqueCmd.notSpecified': 'Non spécifiée',
    'boutiqueCmd.exchangeHistory': 'Historique des échanges',
    'boutiqueCmd.noNote': 'Aucune note pour cette commande',
    'boutiqueCmd.staff': '👤 Staff',
    'boutiqueCmd.client': '👥 Client',
    'boutiqueCmd.clientResponse': 'Réponse du client :',
    'boutiqueCmd.sendMessageTitle': '✉️ Envoyer un message au client',
    'boutiqueCmd.notePlaceholder': 'Ex: Bonjour, pouvez-vous confirmer votre adresse de livraison ? Merci.',
    'boutiqueCmd.noteHint': '💡 Le client recevra ce message et pourra y répondre depuis son espace client',
    'boutiqueCmd.close': 'Fermer',
    'boutiqueCmd.sending': 'Envoi...',
    'boutiqueCmd.sendToClient': 'Envoyer au client',
    'boutiqueCmd.trackingNumber': 'Numéro de suivi',
    'boutiqueCmd.orderShortLabel': 'Commande:',
    'boutiqueCmd.clientShortLabel': 'Client:',
    'boutiqueCmd.trackingPlaceholder': 'Ex: LA123456789FR',
    'boutiqueCmd.trackingHint': 'Le client verra ce numéro dans son espace',
    'boutiqueCmd.cancel': 'Annuler',
    'boutiqueCmd.saving': 'Enregistrement...',
    'boutiqueCmd.save': 'Enregistrer',
    'blogAdmin.confirmDelete': 'Supprimer cet article ?',
    'blogAdmin.pageTitle': 'Blog & Articles SEO',
    'blogAdmin.pageSubtitle': 'Publiez des articles et gérez le contenu du blog',
    'blogAdmin.viewBlog': 'Voir le blog',
    'blogAdmin.newArticle': 'Nouvel article',
    'blogAdmin.tabArticles': 'Articles',
    'blogAdmin.tabContent': 'Contenu de la page',
    'blogAdmin.editArticle': 'Modifier l\'article',
    'blogAdmin.fieldTitle': 'Titre *',
    'blogAdmin.titlePlaceholder': 'ex : Réparation écran iPhone à Cayenne : prix et délais',
    'blogAdmin.fieldExcerpt': 'Extrait (aperçu)',
    'blogAdmin.excerptPlaceholder': 'Courte description pour la liste...',
    'blogAdmin.fieldContent': 'Contenu * (Markdown supporté)',
    'blogAdmin.contentPlaceholder': 'Écrivez votre article ici...',
    'blogAdmin.fieldTags': 'Tags (séparés par virgule)',
    'blogAdmin.tagsPlaceholder': 'réparation, iphone, cayenne',
    'blogAdmin.fieldMeta': 'Meta description SEO',
    'blogAdmin.metaPlaceholder': 'Description pour Google (160 car. max)',
    'blogAdmin.publishNow': 'Publier immédiatement',
    'blogAdmin.update': 'Modifier',
    'blogAdmin.save': 'Enregistrer',
    'blogAdmin.loading': 'Chargement...',
    'blogAdmin.noArticles': 'Aucun article',
    'blogAdmin.noArticlesHint': 'Créez votre premier article pour améliorer le SEO',
    'blogAdmin.statusPublished': 'PUBLIÉ',
    'blogAdmin.statusDraft': 'BROUILLON',
    'blogAdmin.byAuthor': 'Par {{author}}',
    'blogAdmin.unpublish': 'Dépublier',
    'blogAdmin.publish': 'Publier',
    'blogAdmin.loadingContent': 'Chargement du contenu...',
    'blogAdmin.contentNotice1': 'Modifiez ici le contenu affiché sur la page publique ',
    'blogAdmin.contentNotice2': '. Les modifications seront visibles immédiatement.',
    'blogAdmin.blogHeader': 'En-tête du blog',
    'blogAdmin.mainTitle': 'Titre principal',
    'blogAdmin.accentWord': 'Mot en couleur (accent)',
    'blogAdmin.description': 'Description',
    'blogAdmin.ctaSection': 'Appel à l\'action (CTA dans les articles)',
    'blogAdmin.ctaTitle': 'Titre CTA',
    'blogAdmin.ctaDescription': 'Description CTA',
    'blogAdmin.footerSection': 'Pied de page',
    'blogAdmin.footerText': 'Texte du footer',
    'blogAdmin.hidePreview': 'Masquer aperçu',
    'blogAdmin.livePreview': 'Aperçu en direct',
    'blogAdmin.savedSuccess': 'Enregistré avec succès !',
    'blogAdmin.saving': 'Enregistrement...',
    'blogAdmin.saveContent': 'Enregistrer le contenu',
    'blogAdmin.previewLabel': 'Aperçu de la page blog',
    'businessCard.title': 'Cartes de visite',
    'businessCard.subtitle': 'Modèles, édition et impression A4 (10 cartes)',
    'businessCard.previewBtn': 'Aperçu',
    'businessCard.edit': 'Modifier',
    'businessCard.printA4': 'Imprimer A4 (10 cartes)',
    'businessCard.chooseTemplate': 'Choisir un modèle ({{count}} disponibles)',
    'businessCard.tplName.classic': 'Classique',
    'businessCard.tplName.modern': 'Moderne',
    'businessCard.tplName.gradient': 'Dégradé',
    'businessCard.tplName.minimal': 'Minimaliste',
    'businessCard.tplName.gold': 'Gold Premium',
    'businessCard.tplName.ocean': 'Océan',
    'businessCard.tplName.forest': 'Forêt',
    'businessCard.tplName.sunset': 'Coucher de soleil',
    'businessCard.tplName.corporate': 'Corporate',
    'businessCard.tplName.pastel': 'Pastel Rose',
    'businessCard.tplDesc.classic': 'Sobre et professionnel',
    'businessCard.tplDesc.modern': 'Épuré avec accent cyan',
    'businessCard.tplDesc.gradient': 'Fond dégradé vibrant',
    'businessCard.tplDesc.minimal': 'Blanc et net',
    'businessCard.tplDesc.gold': 'Noir et or luxueux',
    'businessCard.tplDesc.ocean': 'Bleu profond apaisant',
    'businessCard.tplDesc.forest': 'Vert nature élégant',
    'businessCard.tplDesc.sunset': 'Orange chaleureux',
    'businessCard.tplDesc.corporate': 'Bleu marine pro',
    'businessCard.tplDesc.pastel': 'Doux et féminin',
    'businessCard.logoTransparent': 'Logo avec fond transparent',
    'businessCard.cardInfo': 'Informations de la carte',
    'businessCard.field.companyName': 'Nom de la société',
    'businessCard.field.subtitle': 'Sous-titre / Activité',
    'businessCard.field.ownerName': 'Nom du responsable',
    'businessCard.field.ownerTitle': 'Titre / Fonction',
    'businessCard.field.phone': 'Téléphone',
    'businessCard.field.email': 'Email',
    'businessCard.field.address': 'Adresse',
    'businessCard.field.city': 'Ville / Code postal',
    'businessCard.field.website': 'Site web',
    'businessCard.field.siret': 'SIRET',
    'businessCard.reset': 'Réinitialiser',
    'businessCard.previewTitle': 'Aperçu — {{name}}',
    'businessCard.viewFront': 'Voir le recto',
    'businessCard.viewBack': 'Voir le verso',
    'businessCard.standardFormat': 'Format standard : 85 x 55 mm',
    'businessCard.allTemplates': 'Tous les modèles',
    'businessCard.printTitle': 'Cartes de Visite',
    'businessCard.recto': 'RECTO',
    'businessCard.verso': 'VERSO',
    'hub.title': 'Hub',
    'hub.refresh': 'Rafraîchir',
    'hub.kpiTicketsOpen': '{{n}} tickets ouverts',
    'hub.kpiFacturesToday': '{{n}} factures jour ({{total}})',
    'hub.kpiDevisOpen': '{{n}} devis ouverts',
    'hub.magasinDefaultName': 'Magasin 1',
    'hub.magasinBadgeTitle': 'Magasin actuel (POS) — {{name}}',
    'hub.counterViewDetailed': 'Vue détaillée',
    'hub.counterViewCompact': 'Vue compacte',
    'hub.counterMagasinTitle': '{{name}} — {{tickets}} tickets · {{devis}} devis · {{total}}',
    'hub.counterCompact': '{{tickets}}T·{{devis}}D·{{total}}',
    'hub.counterTickets': 'tickets',
    'hub.counterDevis': 'devis',
    'hub.counterPerDay': '€/j',
    'hub.searchPlaceholder': 'Rechercher une REF (REM0143, POS-..., DEV-00002), un client, un téléphone…',
    'hub.filterAll': 'Tous',
    'hub.filterToday': 'Aujourd\'hui',
    'hub.filterOverdue': 'En retard',
    'hub.filterPaid': 'Payés',
    'hub.filterUnpaid': 'Non payés',
    'hub.columnReparations': 'Réparations',
    'hub.columnFactures': 'Factures',
    'hub.columnDevis': 'Devis',
    'hub.seeAll': 'Tout voir',
    'hub.empty': 'Aucun élément',
    'hub.actionView': 'Voir',
    'hub.actionPrint': 'Imprimer',
    'hub.actionMail': 'Envoyer par email',
    'hub.actionMarkReady': 'Marquer comme prêt',
    'hub.walkinClient': 'Client de passage',
    'hub.invoicedAs': '→ Facturé : {{ref}}',
    'hub.errorPrint': 'Erreur lors de l\'impression',
    'hub.errorPopupBlocked': 'Veuillez autoriser les popups pour imprimer.',
    'hub.statusWaiting': 'En attente',
    'hub.statusInProgress': 'En cours',
    'hub.statusReady': 'Prêt',
    'hub.statusDelivered': 'Livré',
    'hub.statusPaid': 'Payée',
    'hub.statusInvoiced': 'Facturé',
    'hub.statusSent': 'Envoyé',
    'hub.statusAccepted': 'Accepté',
    'hub.statusCancelled': 'Annulé',
    'hub.statusDone': 'Terminé',
    'subscription.title': 'Mon abonnement',
    'subscription.subtitle': 'Gérez votre plan et votre facturation',
    'subscription.currentPlan': 'Plan actuel',
    'subscription.status': 'Statut',
    'subscription.statusActive': 'Actif',
    'subscription.statusTrial': 'Essai gratuit',
    'subscription.monthlyPrice': 'Prix mensuel',
    'subscription.perMonth': '/mois',
    'subscription.nextBilling': 'Prochain paiement',
    'subscription.changePlan': 'Changer de plan',
    'subscription.redirecting': 'Redirection...',
    'subscription.upgrade': 'Surclasser',
    'subscription.downgrade': 'Déclasser',
    'subscription.upgradeTitle': 'Surclassement de plan',
    'subscription.downgradeTitle': 'Déclassement de plan',
    'subscription.newPlan': 'Nouveau plan',
    'subscription.newMonthlyPrice': 'Nouveau prix mensuel',
    'subscription.upgradeDiffNow': 'Différence à payer maintenant',
    'subscription.changeFee': 'Frais de changement',
    'subscription.downgradeFeeNotice': 'Des frais fixes de {{amount}} s\'appliquent pour tout déclassement de plan.',
    'subscription.cancel': 'Annuler',
    'subscription.confirmWithAmount': 'Confirmer ({{amount}})',
    'subscription.toastChanged': 'Votre plan a été changé avec succès !',
    'subscription.toastCancelled': 'Le changement de plan a été annulé.',
    'subscription.errorPreview': 'Erreur lors de la prévisualisation',
    'subscription.errorChange': 'Erreur lors du changement de plan',
    'subscription.featStartRepairs': 'Gestion des réparations',
    'subscription.featStartClients': 'Suivi client',
    'subscription.featStartQuotesInvoices': 'Devis & Factures',
    'subscription.featStartOnePos': '1 point de vente',
    'subscription.featProAllStart': 'Tout le plan Start',
    'subscription.featProMultiUsers': 'Multi-utilisateurs',
    'subscription.featProAdvancedStats': 'Statistiques avancées',
    'subscription.featProThreePos': '3 points de vente',
    'subscription.featProPrioritySupport': 'Support prioritaire',
    'subscription.featSuperAllPro': 'Tout le plan Pro',
    'subscription.featSuperUnlimitedPos': 'Points de vente illimités',
    'subscription.featSuperCustomApi': 'API personnalisée',
    'subscription.featSuperDedicatedSupport': 'Support dédié 24/7',
    'subscription.featSuperWhiteLabel': 'Marque blanche',
    'terms.title': 'Conditions générales d\'utilisation',
    'terms.edition': 'Juin 2026',
    'terms.introBefore': 'Les présentes conditions régissent l\'utilisation du site',
    'terms.introMiddle': ', de l\'espace client, du chat support et des services de réparation proposés par',
    'terms.introAfter': ', SASU, Cayenne, Guyane française.',
    'terms.acceptIntro': 'En créant un compte ou en nous contactant (site, chat, WhatsApp), vous acceptez ces conditions ainsi que notre',
    'terms.privacyPolicy': 'politique de confidentialité',
    'terms.servicesTitle': 'Services',
    'terms.servicesBody': 'Réparation et vente de téléphones, suivi SAV, devis, paiements en ligne lorsque activés, assistance via chat ou WhatsApp Business.',
    'terms.pricingTitle': 'Tarifs',
    'terms.pricingBody': 'Les devis et tarifs communiqués (magasin, chat, WhatsApp) sont indicatifs jusqu\'à validation en point de vente.',
    'terms.dataTitle': 'Données personnelles',
    'terms.dataBefore': 'Vos données sont traitées conformément au RGPD. Demande de suppression :',
    'terms.dataAfter': 'ou voir la section « Vos droits » de la politique de confidentialité.',
    'terms.contactTitle': 'Contact',
    'notifSettings.title': 'Notifications push',
    'notifSettings.intro': 'Reçois une alerte native (Windows / macOS / Android) dès qu\'un événement important se produit en boutique. Réservé au personnel R.E.Mobiles.',
    'notifSettings.statusUnsupported': 'Non supporté (iOS 16.4+ requis)',
    'notifSettings.statusBlocked': 'Bloquées (permission refusée)',
    'notifSettings.statusEnabled': 'Activées sur ce navigateur',
    'notifSettings.statusDisabled': 'Non activées',
    'notifSettings.activeCount': '{{count}} abonnement(s) actif(s)',
    'notifSettings.enableBtn': 'Activer les notifications',
    'notifSettings.testBtn': 'Envoyer notif test',
    'notifSettings.disableBtn': 'Désactiver',
    'notifSettings.iosHintPre': 'Sur iPhone, les notifications push web nécessitent',
    'notifSettings.iosHintPost': 'et l\'app installée sur l\'écran d\'accueil (PWA). Mets à jour ton iPhone puis re-installe l\'app.',
    'notifSettings.blockedHint': 'Permission refusée. Ouvre les réglages de site du navigateur, autorise les notifications pour ce domaine puis recharge la page.',
    'notifSettings.categoriesTitle': 'Catégories',
    'notifSettings.categoriesHint': 'Désactive ce que tu ne veux pas recevoir. Modifié immédiatement, pour ce compte.',
    'notifSettings.catNewTicketLabel': 'Nouveau ticket réparation',
    'notifSettings.catNewTicketDesc': 'Un dépôt est créé en boutique.',
    'notifSettings.catTicketReadyLabel': 'Ticket passé à « Prêt »',
    'notifSettings.catTicketReadyDesc': 'Le technicien marque la réparation comme prête. Pense à prévenir le client.',
    'notifSettings.catNewInvoiceLabel': 'Nouvelle facture POS',
    'notifSettings.catNewInvoiceDesc': 'Une vente vient d\'être encaissée.',
    'notifSettings.catNewChatLabel': 'Nouveau message dans le chat',
    'notifSettings.catNewChatDesc': 'DM staff, client ou B2B.',
    'notifSettings.catDevisLabel': 'Devis créé ou accepté',
    'notifSettings.catDevisDesc': 'Un nouveau devis est généré ou un client clique sur Accepter.',
    'notifSettings.accountLabel': 'Compte',
    'notifSettings.roleLabel': 'Rôle',
    'notifSettings.totalSubsLabel': 'Abonnements totaux',
    'notifSettings.errPermDenied': 'Permission refusée. Activez les notifications dans les réglages du navigateur.',
    'notifSettings.errPermNotGranted': 'Permission non accordée.',
    'notifSettings.errVapidUnavailable': 'Clé VAPID indisponible côté serveur.',
    'notifSettings.infoEnabled': 'Notifications activées sur ce navigateur.',
    'notifSettings.errEnableFailed': 'Échec d\'activation.',
    'notifSettings.infoDisabled': 'Notifications désactivées sur ce navigateur.',
    'notifSettings.errDisableFailed': 'Échec de désactivation.',
    'notifSettings.errPrefsUpdate': 'Échec mise à jour des préférences.',
    'notifSettings.infoTestSent': 'Notification de test envoyée ({{sent}}/{{subs}}). Vérifie le centre de notifications de ton OS.',
    'notifSettings.errNoneSent': 'Aucune notification envoyée. Vérifie que les notifs sont activées sur ce navigateur.',
    'notifSettings.errTestFailed': 'Échec du test.',
    'guyarepairLogin.subscriberSpace': 'Espace abonné',
    'guyarepairLogin.businessLoginTitle': 'Connexion entreprise',
    'guyarepairLogin.businessLoginSubtitle': 'Connectez-vous à votre tableau de bord GUYAREPAIR',
    'guyarepairLogin.emailLabel': 'Email',
    'guyarepairLogin.emailPlaceholder': 'votre@email.com',
    'guyarepairLogin.passwordLabel': 'Mot de passe',
    'guyarepairLogin.passwordPlaceholder': 'Votre mot de passe',
    'guyarepairLogin.loggingIn': 'Connexion...',
    'guyarepairLogin.loginButton': 'Se connecter',
    'guyarepairLogin.twoFATitle': 'Vérification 2FA',
    'guyarepairLogin.twoFASubtitle': 'Entrez le code de votre application d\'authentification',
    'guyarepairLogin.otpLabel': 'Code à 6 chiffres',
    'guyarepairLogin.verifying': 'Vérification...',
    'guyarepairLogin.verifyButton': 'Vérifier',
    'guyarepairLogin.backToLogin': 'Retour à la connexion',
    'guyarepairLogin.notSubscribedYet': 'Pas encore abonné ?',
    'guyarepairLogin.freeTrial': 'Essai gratuit',
    'guyarepairLogin.secureConnection': 'Connexion sécurisée',
    'guyarepairLogin.guyarepairHome': 'Accueil GUYAREPAIR',
    'guyarepairLogin.errInvalidCredentials': 'Identifiants incorrects',
    'guyarepairLogin.err2FAInvalid': 'Code 2FA invalide',
    'analytics.period_today': 'Aujourd\'hui',
    'analytics.period_7d': '7 jours',
    'analytics.period_30d': '30 jours',
    'analytics.period_90d': '90 jours',
    'analytics.period_365d': '1 an',
    'analytics.alert_suspicious_found': '{{count}} IP(s) suspecte(s) détectée(s) !',
    'analytics.alert_no_suspicious': 'Aucune IP suspecte détectée.',
    'analytics.page_title': 'Analytics — Visites',
    'analytics.page_subtitle': 'Suivi des visites sur tous vos sites',
    'analytics.refresh': 'Actualiser',
    'analytics.tab_dashboard': 'Tableau de bord',
    'analytics.tab_visits': 'Visites',
    'analytics.tab_blocked': 'IPs bloquées',
    'analytics.tab_alerts': 'Alertes IP',
    'analytics.all_sites': 'Tous les sites',
    'analytics.kpi_total_visits': 'Visites totales',
    'analytics.kpi_unique_visitors': 'Visiteurs uniques',
    'analytics.kpi_active_sites': 'Sites actifs',
    'analytics.kpi_countries': 'Pays',
    'analytics.visits_per_day': 'Visites par jour',
    'analytics.by_site': 'Par site',
    'analytics.by_country': 'Par pays',
    'analytics.top_pages': 'Pages les plus visitées',
    'analytics.visits_per_hour': 'Visites par heure',
    'analytics.empty_no_visits': 'Aucune visite enregistrée pour cette période',
    'analytics.empty_install_script': 'Le script de tracking doit être installé sur vos sites',
    'analytics.search_placeholder': 'Rechercher par IP, page, pays...',
    'analytics.col_date': 'Date',
    'analytics.col_site': 'Site',
    'analytics.col_page': 'Page',
    'analytics.col_country_city': 'Pays / Ville',
    'analytics.col_screen': 'Écran',
    'analytics.col_action': 'Action',
    'analytics.no_visits': 'Aucune visite',
    'analytics.blocked_inline': '(BLOQUÉE)',
    'analytics.unblock': 'Débloquer',
    'analytics.block': 'Bloquer',
    'analytics.visits_count': '{{count}} visites',
    'analytics.blocked_ips_title': 'Adresses IP bloquées',
    'analytics.active_count': '{{count}} active(s)',
    'analytics.col_status': 'Statut',
    'analytics.col_reason': 'Raison',
    'analytics.col_blocked_by': 'Bloquée par',
    'analytics.no_blocked_ips': 'Aucune IP bloquée',
    'analytics.status_blocked': 'BLOQUÉE',
    'analytics.status_inactive': 'INACTIVE',
    'analytics.reblock': 'Re-bloquer',
    'analytics.alert_config_title': 'Configuration des alertes',
    'analytics.checking': 'Vérification...',
    'analytics.check_now': 'Vérifier maintenant',
    'analytics.saving': 'Sauvegarde...',
    'analytics.save': 'Sauvegarder',
    'analytics.alerts_enabled': 'Alertes activées',
    'analytics.alerts_enabled_desc': 'Surveille les IPs suspectes toutes les 15 min',
    'analytics.threshold_label': 'Seuil (visites/heure)',
    'analytics.alert_email_label': 'E-mail d\'alerte',
    'analytics.autoblock': 'Auto-blocage',
    'analytics.autoblock_desc': 'Bloquer automatiquement les IPs qui dépassent le seuil',
    'analytics.alert_history_title': 'Historique des alertes',
    'analytics.alerts_count': '{{count}} alerte(s)',
    'analytics.no_alerts': 'Aucune alerte déclenchée',
    'analytics.col_visits_per_hour': 'Visites/h',
    'analytics.col_sites': 'Sites',
    'analytics.col_autoblocked': 'Auto-bloquée',
    'analytics.col_email': 'E-mail',
    'analytics.yes': 'OUI',
    'analytics.no': 'NON',
    'analytics.sent': 'ENVOYÉ',
    'analytics.confirm_block_title': 'Bloquer cette IP ?',
    'analytics.confirm_block_ip_prefix': 'L\'IP ',
    'analytics.confirm_block_ip_suffix': ' sera bloquée sur tous les sites',
    'analytics.block_reason_placeholder': 'Raison du blocage (optionnel)...',
    'analytics.cancel': 'Annuler',
    'analytics.blocking': 'Blocage...',
    'analytics.confirm_block': 'Confirmer le blocage',
    'guyarepairLanding.navTarifs': 'Tarifs',
    'guyarepairLanding.navAnnuaire': 'Annuaire',
    'guyarepairLanding.navMaReparation': 'Ma réparation',
    'guyarepairLanding.navConnexion': 'Connexion',
    'guyarepairLanding.navEssaiGratuit': 'Essai gratuit',
    'guyarepairLanding.heroBadge': 'Plateforme SaaS de gestion de réparations',
    'guyarepairLanding.heroTitleLine1': 'Gérez votre atelier de',
    'guyarepairLanding.heroTitleLine2': 'réparation',
    'guyarepairLanding.heroTitleHighlight': 'simplement',
    'guyarepairLanding.heroSubtitle': 'GUYAREPAIR est la solution tout-en-un pour les ateliers de réparation. POS, suivi des réparations, gestion du stock, facturation et fidélité client — tout dans une seule plateforme.',
    'guyarepairLanding.heroCtaStart': 'Commencer gratuitement',
    'guyarepairLanding.heroCtaPricing': 'Voir les tarifs',
    'guyarepairLanding.repairLookupTitle': 'Retrouver ma réparation',
    'guyarepairLanding.repairLookupSubtitle': 'Entrez votre référence de réparation pour suivre son avancement',
    'guyarepairLanding.repairLookupPlaceholder': 'Ex : TFX0001, MBR0012...',
    'guyarepairLanding.rechercher': 'Rechercher',
    'guyarepairLanding.repairErrorDefault': 'Erreur lors de la recherche',
    'guyarepairLanding.repairFoundAt': 'Réparation trouvée chez',
    'guyarepairLanding.statutTermine': 'Terminé',
    'guyarepairLanding.statutEnCours': 'En cours',
    'guyarepairLanding.statutEnAttente': 'En attente',
    'guyarepairLanding.labelReference': 'Référence',
    'guyarepairLanding.labelAppareil': 'Appareil',
    'guyarepairLanding.labelProbleme': 'Problème',
    'guyarepairLanding.voirPageDe': 'Voir la page de {{nom}}',
    'guyarepairLanding.directoryTitle': 'Trouvez votre réparateur',
    'guyarepairLanding.directorySubtitle': 'Recherchez un magasin de réparation partenaire GUYAREPAIR',
    'guyarepairLanding.searchPlaceholder': 'Nom du magasin, ville...',
    'guyarepairLanding.resultats': '{{count}} résultat(s)',
    'guyarepairLanding.featuresTitle': 'Tout ce dont vous avez besoin',
    'guyarepairLanding.featuresSubtitle': 'Une suite complète d\'outils pour votre atelier',
    'guyarepairLanding.feature1Title': 'Gestion des réparations',
    'guyarepairLanding.feature1Desc': 'Suivi complet de chaque réparation, du diagnostic à la livraison',
    'guyarepairLanding.feature2Title': 'Point de Vente (POS)',
    'guyarepairLanding.feature2Desc': 'Encaissements, calcul de prix, gestion de caisse intégrée',
    'guyarepairLanding.feature3Title': 'Stock & Inventaire',
    'guyarepairLanding.feature3Desc': 'Mouvements de stock, alertes, fournisseurs et commandes',
    'guyarepairLanding.feature4Title': 'Clients & Fidélité',
    'guyarepairLanding.feature4Desc': 'Base clients, programme de fidélité avec récompenses',
    'guyarepairLanding.feature5Title': 'Devis & Factures',
    'guyarepairLanding.feature5Desc': 'Création rapide de devis, conversion en facture, envoi par email',
    'guyarepairLanding.feature6Title': 'Multi-boutiques',
    'guyarepairLanding.feature6Desc': 'Gérez plusieurs boutiques depuis un seul tableau de bord',
    'guyarepairLanding.pricingTitle': 'Tarifs simples et transparents',
    'guyarepairLanding.pricingSubtitle': 'Choisissez le plan adapté à votre activité',
    'guyarepairLanding.popular': 'POPULAIRE',
    'guyarepairLanding.perMonth': 'EUR/mois',
    'guyarepairLanding.commencer': 'Commencer',
    'guyarepairLanding.copyright': '© {{year}} REMCOMPANY. Tous droits réservés.',
    'guyarepairLanding.trademarkNotice': 'GUYAREPAIR est la marque commerciale du service.',
    'guyarepairLanding.passwordTooShort': 'Le mot de passe doit faire au moins 6 caractères',
    'guyarepairLanding.registerErrorDefault': 'Erreur lors de l\'inscription',
    'guyarepairLanding.registerSuccessTitle': 'Inscription réussie !',
    'guyarepairLanding.successAccountCreated': 'Votre compte a été créé avec un',
    'guyarepairLanding.successTrial': 'essai gratuit de 5 jours',
    'guyarepairLanding.successLoginHint': 'Connectez-vous pour configurer votre espace. Un email de bienvenue a été envoyé.',
    'guyarepairLanding.seConnecter': 'Se connecter',
    'guyarepairLanding.createAccountTitle': 'Créer votre compte',
    'guyarepairLanding.planLine': 'Plan {{nom}} — {{prix}} EUR/mois',
    'guyarepairLanding.planLabel': 'Plan',
    'guyarepairLanding.companyNameLabel': 'Nom de l\'entreprise',
    'guyarepairLanding.contactNameLabel': 'Nom du contact',
    'guyarepairLanding.phoneLabel': 'Téléphone',
    'guyarepairLanding.emailLabel': 'Email',
    'guyarepairLanding.passwordLabel': 'Mot de passe',
    'guyarepairLanding.cityLabel': 'Ville',
    'guyarepairLanding.addressLabel': 'Adresse',
    'guyarepairLanding.directoryToggle': 'Apparaître dans l\'annuaire public GUYAREPAIR',
    'guyarepairLanding.creating': 'Création en cours...',
    'guyarepairLanding.createMyAccount': 'Créer mon compte',
    'guyarepairLanding.alreadyRegistered': 'Déjà inscrit ?',
    'alertsConfig.saved': 'Configuration des alertes sauvegardée',
    'alertsConfig.error': 'Erreur',
    'alertsConfig.title': 'Alertes automatiques',
    'alertsConfig.subtitle': 'Configurez les alertes automatiques pour votre entreprise. Vous recevrez un email quotidien si des conditions sont remplies.',
    'alertsConfig.emailAlertsLabel': 'Alertes par email',
    'alertsConfig.emailAlertsDesc': 'Activer les alertes automatiques par email (réparations en attente, rupture de stock)',
    'alertsConfig.repairAlertsTitle': 'Alertes réparations en attente',
    'alertsConfig.repairAlertsDesc': 'Recevez un email quand une réparation est en attente depuis plus de X jours.',
    'alertsConfig.delayLabel': 'Délai (jours)',
    'alertsConfig.daysShort': '{{n}}j',
    'alertsConfig.stockAlertsTitle': 'Alertes stock',
    'alertsConfig.stockAlertsDesc': 'Recevez un email quand des articles sont en rupture de stock ou sous un seuil.',
    'alertsConfig.lowStockThresholdLabel': 'Seuil stock faible',
    'alertsConfig.clientNotifLabel': 'Notifications clients',
    'alertsConfig.clientNotifDesc': 'Envoyer un email au client quand le statut de sa réparation change (terminé, en cours, etc.)',
    'alertsConfig.emailSenderInfo': 'L\'email sera envoyé depuis votre adresse configurée, ou depuis GUYAREPAIR par défaut.',
    'alertsConfig.saving': 'Sauvegarde...',
    'alertsConfig.save': 'Sauvegarder',
    'companyAnalytics.title': 'Analytics',
    'companyAnalytics.subtitle': 'Vue d\'ensemble des performances de votre entreprise',
    'companyAnalytics.loadError': 'Erreur lors du chargement',
    'companyAnalytics.kpiRepairsToday': 'Réparations aujourd\'hui',
    'companyAnalytics.kpiThisWeek': '{{count}} cette semaine',
    'companyAnalytics.kpiRevenueToday': 'Revenu aujourd\'hui',
    'companyAnalytics.kpiThisMonthAmount': '{{amount}} ce mois',
    'companyAnalytics.kpiClients': 'Clients',
    'companyAnalytics.kpiNewThisMonth': '{{count}} nouveaux ce mois',
    'companyAnalytics.kpiAvgTime': 'Temps moyen',
    'companyAnalytics.daysShort': '{{count}}j',
    'companyAnalytics.kpiPerRepair': 'par réparation',
    'companyAnalytics.statTotalRepairs': 'Total réparations',
    'companyAnalytics.statActive': 'Actives',
    'companyAnalytics.statCompleted': 'Terminées',
    'companyAnalytics.statStockItems': 'Stock articles',
    'companyAnalytics.statOutOfStock': 'Rupture stock',
    'companyAnalytics.repairsByStore': 'Réparations en cours par magasin',
    'companyAnalytics.repairsM1Explicit': '{{count}} réparations M1 explicites',
    'companyAnalytics.repairsLegacy': '{{count}} réparations legacy (pré-M2)',
    'companyAnalytics.totalShown': 'Total affiché : {{count}}',
    'companyAnalytics.repairsM2': '{{count}} réparations M2',
    'companyAnalytics.repairsTrend14Days': 'Réparations (14 derniers jours)',
    'companyAnalytics.statusDistribution': 'Répartition des statuts',
    'companyAnalytics.noRepairs': 'Aucune réparation',
    'companyAnalytics.revenue': 'Revenus',
    'companyAnalytics.revToday': 'Aujourd\'hui',
    'companyAnalytics.revThisWeek': 'Cette semaine',
    'companyAnalytics.revThisMonth': 'Ce mois',
    'companyAnalytics.revTotal': 'Total',
    'companyAnalytics.statusPending': 'En attente',
    'companyAnalytics.statusInProgress': 'En cours',
    'companyAnalytics.statusCompleted': 'Terminé',
    'companyAnalytics.statusDelivered': 'Livré',
    'companyAnalytics.statusCancelled': 'Annulé',
    'staffCommissions.title': 'Mes commissions',
    'staffCommissions.pdfDownloadError': 'Erreur lors du téléchargement du PDF',
    'staffCommissions.downloadMonthSheet': 'Télécharger ma fiche du mois :',
    'staffCommissions.generating': 'Génération…',
    'staffCommissions.downloadPdf': 'Télécharger PDF',
    'staffCommissions.toReceive': 'À recevoir',
    'staffCommissions.alreadyReceived': 'Déjà reçu',
    'staffCommissions.totalCumulative': 'Total cumul',
    'staffCommissions.detailByType': 'Détail par type',
    'staffCommissions.toPay': 'À payer : {{amount}}',
    'staffCommissions.paidDetail': 'Payé : {{amount}}',
    'staffCommissions.noCommissionYet': 'Aucune commission encore',
    'staffCommissions.filterAll': 'Toutes',
    'staffCommissions.filterPending': 'À payer',
    'staffCommissions.filterPaid': 'Payées',
    'staffCommissions.filterCancelled': 'Annulées',
    'staffCommissions.colDate': 'Date',
    'staffCommissions.colType': 'Type',
    'staffCommissions.colTransaction': 'Transaction',
    'staffCommissions.colAmountTtc': 'Montant TTC',
    'staffCommissions.colCommission': 'Commission',
    'staffCommissions.colStatus': 'Statut',
    'staffCommissions.noCommission': 'Aucune commission',
    'staffCommissions.month1': 'Janvier',
    'staffCommissions.month2': 'Février',
    'staffCommissions.month3': 'Mars',
    'staffCommissions.month4': 'Avril',
    'staffCommissions.month5': 'Mai',
    'staffCommissions.month6': 'Juin',
    'staffCommissions.month7': 'Juillet',
    'staffCommissions.month8': 'Août',
    'staffCommissions.month9': 'Septembre',
    'staffCommissions.month10': 'Octobre',
    'staffCommissions.month11': 'Novembre',
    'staffCommissions.month12': 'Décembre',
    'staffCommissions.typeVentes': 'Vente POS',
    'staffCommissions.typeCommandes': 'Commande',
    'staffCommissions.typeAcomptes': 'Acompte',
    'staffCommissions.typeReparations': 'Réparation',
    'staffCommissions.typeFactures': 'Facture',
    'staffCommissions.typeDevis': 'Devis',
    'staffCommissions.typeB2b': 'B2B',
    'staffCommissions.typeDeplacement': 'Déplacement',
    'labelConfig.title': 'Configuration Étiquettes',
    'labelConfig.subtitle': 'Ajustez les marges et dimensions pour votre imprimante',
    'labelConfig.reset': 'Valeurs par défaut',
    'labelConfig.save': 'Sauvegarder',
    'labelConfig.saving': 'Sauvegarde...',
    'labelConfig.saved': 'Sauvegardé',
    'labelConfig.save_error': 'Erreur sauvegarde : {{error}}',
    'labelConfig.global_dimensions': 'Dimensions générales',
    'labelConfig.label_width': 'Largeur étiquette',
    'labelConfig.label_height': 'Hauteur étiquette',
    'labelConfig.cols': 'Colonnes',
    'labelConfig.rows': 'Lignes',
    'labelConfig.margins_spacing': 'Marges et espacement',
    'labelConfig.left_margin': 'Marge gauche',
    'labelConfig.top_margin': 'Marge haute',
    'labelConfig.h_spacing': 'Espacement H',
    'labelConfig.v_spacing': 'Espacement V',
    'labelConfig.col_offset_title': 'Décalage par colonne',
    'labelConfig.cols_count': '({{count}} colonnes)',
    'labelConfig.col_n': 'Col {{n}}',
    'labelConfig.col_offset_hint': 'Valeurs positives = décalage vers la droite. Négatives = vers la gauche.',
    'labelConfig.row_offset_title': 'Décalage par ligne',
    'labelConfig.rows_count': '({{count}} lignes)',
    'labelConfig.row_n': 'Ligne {{n}}',
    'labelConfig.row_offset_hint': 'Valeurs positives = décalage vers le haut. Négatives = vers le bas.',
    'labelConfig.preview_title': 'Aperçu feuille A4',
    'labelConfig.preview_count': '{{cols}} x {{rows}} = {{total}} étiquettes/feuille',
    'labelConfig.preview_dims': '{{width}} x {{height}} mm',
    'paymentConfig.title': 'Configuration des paiements',
    'paymentConfig.statusActiveTitle': 'Paiements en ligne actifs',
    'paymentConfig.providerLabel': 'Fournisseur : {{name}}',
    'paymentConfig.statusInactiveTitle': 'Paiements en ligne désactivés',
    'paymentConfig.statusInactiveDesc': 'Configurez un fournisseur pour accepter les paiements en ligne. Seuls les paiements hors ligne (espèces, carte en magasin) sont disponibles.',
    'paymentConfig.chooseProvider': 'Choisissez votre fournisseur de paiement :',
    'paymentConfig.apiKeysTitle': 'Clés API {{name}}',
    'paymentConfig.savedPlaceholder': 'Enregistrée : {{value}}',
    'paymentConfig.save': 'Sauvegarder',
    'paymentConfig.testConnection': 'Tester la connexion',
    'paymentConfig.infoTitle': 'Informations importantes',
    'paymentConfig.info1': 'Les paiements en ligne sont versés directement sur votre compte marchand.',
    'paymentConfig.info2': 'Vos clés API sont chiffrées et stockées de manière sécurisée.',
    'paymentConfig.info3': 'Sans configuration valide, seuls les paiements hors ligne sont disponibles.',
    'paymentConfig.info4': 'Chaque entreprise gère ses propres clés de manière indépendante.',
    'paymentConfig.saveError': 'Erreur de sauvegarde',
    'paymentConfig.testError': 'Erreur de test',
    'paymentConfig.disableConfirm': 'Désactiver les paiements en ligne ?',
    'paymentConfig.stripeDesc': 'Paiements par carte bancaire, Apple Pay, Google Pay',
    'paymentConfig.sumupDesc': 'Terminal TPE POS V2 + paiements en ligne (merchant_code, client_id/secret)',
    'paymentConfig.fieldPublicKey': 'Clé publique (pk_...)',
    'paymentConfig.fieldSecretKey': 'Clé secrète (sk_...)',
    'paymentConfig.fieldWebhookSecret': 'Secret webhook (whsec_...)',
    'paymentConfig.fieldApiKey': 'Clé API',
    'paymentConfig.fieldMerchantCode': 'Code marchand',
    'paymentConfig.fieldClientId': 'Client ID',
    'paymentConfig.fieldClientSecret': 'Client Secret',
    'loyaltyAdmin.title': 'Programme de Fidélité',
    'loyaltyAdmin.subtitle': 'Suivi des points et récompenses clients',
    'loyaltyAdmin.refresh': 'Actualiser',
    'loyaltyAdmin.kpiMembers': 'Membres',
    'loyaltyAdmin.kpiPendingRewards': 'Récompenses en attente',
    'loyaltyAdmin.kpiRedeemed': 'Récompenses utilisées',
    'loyaltyAdmin.kpiThreshold': 'Seuil récompense',
    'loyaltyAdmin.purchasesSuffix': 'achats',
    'loyaltyAdmin.rewardRule': '-{{pos}}% POS / -{{repair}}% réparation',
    'loyaltyAdmin.topClients': 'Top Clients Fidèles',
    'loyaltyAdmin.clientFallback': 'Client',
    'loyaltyAdmin.flashOffers': 'Offres Flash',
    'loyaltyAdmin.newOffer': 'Nouvelle offre',
    'loyaltyAdmin.createFlashOffer': 'Créer une offre flash',
    'loyaltyAdmin.offerTitlePlaceholder': 'Titre de l\'offre (ex : Weekend Special)',
    'loyaltyAdmin.offerDescPlaceholder': 'Description (ex : Réparation écran à prix réduit)',
    'loyaltyAdmin.discountLabel': 'Remise (%)',
    'loyaltyAdmin.endDateLabel': 'Date de fin',
    'loyaltyAdmin.targetLevelsLabel': 'Niveaux cibles',
    'loyaltyAdmin.creating': 'Création...',
    'loyaltyAdmin.createOffer': 'Créer l\'offre',
    'loyaltyAdmin.noOffers': 'Aucune offre flash créée',
    'loyaltyAdmin.offerMeta': 'Cibles : {{levels}} | Emails : {{emails}}',
    'loyaltyAdmin.offerEnd': ' | Fin : {{date}}',
    'loyaltyAdmin.deactivate': 'Désactiver',
    'loyaltyAdmin.activate': 'Activer',
    'loyaltyAdmin.sendByEmail': 'Envoyer par email',
    'loyaltyAdmin.delete': 'Supprimer',
    'loyaltyAdmin.allMembers': 'Tous les membres ({{count}})',
    'loyaltyAdmin.searchPlaceholder': 'Rechercher...',
    'loyaltyAdmin.colClient': 'Client',
    'loyaltyAdmin.colPhone': 'Téléphone',
    'loyaltyAdmin.colPurchases': 'Achats',
    'loyaltyAdmin.colPoints': 'Points',
    'loyaltyAdmin.colTotalSpent': 'Total dépensé',
    'loyaltyAdmin.colStatus': 'Statut',
    'loyaltyAdmin.colRewards': 'Récompenses',
    'loyaltyAdmin.noMembers': 'Aucun membre',
    'loyaltyAdmin.rewardAvailable': 'Récompense dispo',
    'loyaltyAdmin.purchasesRemaining': '{{count}} achats restants',
    'loyaltyAdmin.pageOf': 'Page {{page}} / {{total}}',
    'loyaltyAdmin.confirmDeleteOffer': 'Supprimer cette offre ?',
    'loyaltyAdmin.emailsSent': 'Emails envoyés',
    'loyaltyAdmin.levelBronze': 'Bronze',
    'loyaltyAdmin.levelArgent': 'Argent',
    'loyaltyAdmin.levelOr': 'Or',
    'emailConfig.pageTitle': 'Configuration Email',
    'emailConfig.pageSubtitle': 'Configure le serveur SMTP pour l\'envoi des factures, devis et notifications par email.',
    'emailConfig.smtpSection': 'Serveur SMTP',
    'emailConfig.fieldHost': 'Hôte SMTP',
    'emailConfig.fieldPort': 'Port',
    'emailConfig.fieldUser': 'Utilisateur SMTP (email)',
    'emailConfig.fieldPassword': 'Mot de passe email',
    'emailConfig.passwordPlaceholderExisting': '•••••••• (laisse vide pour conserver)',
    'emailConfig.passwordPlaceholderNew': 'Mot de passe email Hostinger',
    'emailConfig.useSsl': 'Utiliser SSL/TLS (recommandé port 465)',
    'emailConfig.enableEmails': 'Activer l\'envoi d\'emails',
    'emailConfig.tipTitle': 'Astuce Hostinger :',
    'emailConfig.tipBody': 'le mot de passe email est différent du mot de passe hPanel. Tu peux le vérifier ou le réinitialiser dans hPanel → Emails → Comptes Email → Gérer.',
    'emailConfig.senderSection': 'Expéditeur',
    'emailConfig.fieldSenderName': 'Nom de l\'expéditeur',
    'emailConfig.fieldSenderEmail': 'Email expéditeur',
    'emailConfig.saving': 'Sauvegarde…',
    'emailConfig.save': 'Sauvegarder',
    'emailConfig.testing': 'Envoi…',
    'emailConfig.testConnection': 'Tester la connexion',
    'emailConfig.disable': 'Désactiver',
    'emailConfig.loadError': 'Erreur de chargement (HTTP {{status}})',
    'emailConfig.saveSuccess': 'Configuration sauvegardée. Tu peux maintenant cliquer sur « Tester la connexion ».',
    'emailConfig.saveErrorFallback': 'Erreur de sauvegarde',
    'emailConfig.testSuccess': 'Email de test envoyé. Vérifie ta boîte de réception.',
    'emailConfig.testErrorFallback': 'Échec du test SMTP. Vérifie le mot de passe email Hostinger (différent du mot de passe hPanel).',
    'emailConfig.disableConfirm': 'Désactiver la configuration personnalisée ? Le serveur reviendra à la configuration .env par défaut.',
    'emailConfig.disableSuccess': 'Configuration personnalisée désactivée.',
    'emailConfig.disableErrorFallback': 'Erreur lors de la désactivation',
    'promosCalendar.title': 'Calendrier promotions',
    'promosCalendar.subtitle': 'Promotions programmées par jour',
    'promosCalendar.empty': 'Aucune promotion programmée pour ce mois.',
    'adminIntegrations.supplierCredentials': 'Identifiants fournisseurs (Mobilax · Jens · LCD-Phone)',
    'adminIntegrations.generateStockPhotos': 'Générer les photos stock (IA) — M1 / M2',
    'adminIntegrations.stockCategoryAudit': 'Audit catégories stock — téléphone / IMEI / accessoires',
    'printerTokens.title': 'Tokens agent imprimante',
    'printerTokens.desc': 'Gestion des tokens utilisés par l\'agent Windows pour s\'authentifier auprès du backend. Un token par poste (recommandé) ou un token partagé pour les petites installations.',
    'printerTokens.newBtn': 'Nouveau token',
    'printerTokens.includeRevoked': 'Inclure les tokens révoqués',
    'printerTokens.refresh': 'Rafraîchir',
    'printerTokens.loading': 'Chargement…',
    'printerTokens.emptyPre': 'Aucun token. Cliquez sur',
    'printerTokens.emptyPost': 'pour en créer un.',
    'printerTokens.colLabel': 'Label',
    'printerTokens.colType': 'Type',
    'printerTokens.colPreview': 'Aperçu',
    'printerTokens.colCreated': 'Créé le',
    'printerTokens.colLastUsed': 'Dernière utilisation',
    'printerTokens.colStatus': 'Statut',
    'printerTokens.colActions': 'Actions',
    'printerTokens.typeShared': 'Partagé',
    'printerTokens.typePersonal': 'Personnel',
    'printerTokens.createdBy': 'par {{user}}',
    'printerTokens.statusRevoked': 'Révoqué',
    'printerTokens.statusActive': 'Actif',
    'printerTokens.revoke': 'Révoquer',
    'printerTokens.securityTitle': 'Sécurité',
    'printerTokens.securityHashPre': 'Les tokens sont stockés sous forme de hash (SHA-256). Le token complet n\'est',
    'printerTokens.securityHashEmph': 'jamais réaffiché',
    'printerTokens.securityHashPost': 'après sa création. En cas d\'oubli, révoquez-le et créez-en un nouveau.',
    'printerTokens.securityAudit': 'Toute création et révocation est tracée dans le journal d\'audit administrateur.',
    'printerTokens.createTitle': 'Nouveau token agent',
    'printerTokens.createLabelField': 'Label (ex: PC Caisse, Laptop Carlos)',
    'printerTokens.createLabelPlaceholder': 'PC Caisse',
    'printerTokens.createSharedLabel': 'Token partagé (utilisable par plusieurs postes)',
    'printerTokens.createSharedHint': 'Un seul token partagé actif à la fois. Pour la sécurité, préférez un token par poste.',
    'printerTokens.cancel': 'Annuler',
    'printerTokens.create': 'Créer',
    'printerTokens.revealTitle': 'Token créé — copiez-le maintenant',
    'printerTokens.revealLabelPrefix': 'Label :',
    'printerTokens.revealConfigPre': 'Configurez votre agent Windows avec ce token dans le header',
    'printerTokens.revealConfigPost': '.',
    'printerTokens.copied': 'Copié',
    'printerTokens.copy': 'Copier',
    'printerTokens.revealClose': 'J\'ai noté le token',
    'printerTokens.revokeTitle': 'Révoquer ce token ?',
    'printerTokens.revokeMsgPre': 'Le token',
    'printerTokens.revokeMsgPost': 'ne pourra plus authentifier aucun agent. Cette opération est conservée dans le journal et n\'efface pas le token (vous pouvez l\'afficher en cochant « Inclure les tokens révoqués »).',
    'printerTokens.actionError': 'Erreur : {{detail}}',
    'servicePrices.pageTitle': 'Tarifs réparations',
    'servicePrices.pageSubtitle': 'Gérez les prix et le contenu de la page publique',
    'servicePrices.viewPublicPage': 'Voir page publique',
    'servicePrices.add': 'Ajouter',
    'servicePrices.tabPrices': 'Tarifs',
    'servicePrices.tabContent': 'Contenu de la page',
    'servicePrices.editPriceTitle': 'Modifier le tarif',
    'servicePrices.newPriceTitle': 'Nouveau tarif',
    'servicePrices.brand': 'Marque *',
    'servicePrices.choose': 'Choisir...',
    'servicePrices.model': 'Modèle',
    'servicePrices.modelPlaceholder': 'ex : iPhone 14 Pro',
    'servicePrices.repairType': 'Type réparation *',
    'servicePrices.delay': 'Délai',
    'servicePrices.delayPlaceholder': 'ex : 30 min',
    'servicePrices.priceMin': 'Prix min (EUR)',
    'servicePrices.priceMax': 'Prix max (EUR)',
    'servicePrices.order': 'Ordre',
    'servicePrices.visiblePublic': 'Visible public',
    'servicePrices.btnUpdate': 'Modifier',
    'servicePrices.btnSave': 'Enregistrer',
    'servicePrices.loading': 'Chargement...',
    'servicePrices.noPrices': 'Aucun tarif enregistré',
    'servicePrices.noPricesHint': 'Ajoutez vos premiers tarifs pour les afficher sur la page publique',
    'servicePrices.colRepair': 'Réparation',
    'servicePrices.colPrice': 'Prix',
    'servicePrices.colVisible': 'Visible',
    'servicePrices.colActions': 'Actions',
    'servicePrices.allModels': 'Tous modèles',
    'servicePrices.contentLoading': 'Chargement du contenu...',
    'servicePrices.contentBannerPre': 'Modifiez ici le contenu affiché sur la page publique',
    'servicePrices.contentBannerPost': '. Les modifications seront visibles immédiatement après enregistrement.',
    'servicePrices.headerSection': 'En-tête de la page',
    'servicePrices.mainTitle': 'Titre principal',
    'servicePrices.accentWord': 'Mot en couleur (accent)',
    'servicePrices.seoDescription': 'Description SEO',
    'servicePrices.contactInfo': 'Informations de contact',
    'servicePrices.phone': 'Téléphone',
    'servicePrices.phoneDisplay': 'Tél. affiché',
    'servicePrices.whatsappLabel': 'WhatsApp (avec indicatif)',
    'servicePrices.address': 'Adresse',
    'servicePrices.hours': 'Horaires',
    'servicePrices.trustBadges': 'Badges de confiance',
    'servicePrices.addShort': '+ Ajouter',
    'servicePrices.titleField': 'Titre',
    'servicePrices.description': 'Description',
    'servicePrices.faqTitle': 'Questions fréquentes (FAQ)',
    'servicePrices.question': 'Question',
    'servicePrices.answer': 'Réponse',
    'servicePrices.ctaSection': 'Section appel à l\'action (CTA)',
    'servicePrices.ctaTitle': 'Titre CTA',
    'servicePrices.ctaDescription': 'Description CTA',
    'servicePrices.footer': 'Pied de page',
    'servicePrices.line1': 'Ligne 1',
    'servicePrices.line2': 'Ligne 2',
    'servicePrices.hidePreview': 'Masquer aperçu',
    'servicePrices.livePreview': 'Aperçu en direct',
    'servicePrices.savedSuccess': 'Enregistré avec succès !',
    'servicePrices.saving': 'Enregistrement...',
    'servicePrices.saveContent': 'Enregistrer le contenu',
    'servicePrices.previewLabel': 'Aperçu de la page publique',
    'servicePrices.faqShort': 'FAQ',
    'servicePrices.confirmDelete': 'Supprimer ce tarif ?',
    'servicePrices.repairTypes.ecran': 'Écran',
    'servicePrices.repairTypes.batterie': 'Batterie',
    'servicePrices.repairTypes.connecteurCharge': 'Connecteur de charge',
    'servicePrices.repairTypes.cameraArriere': 'Caméra arrière',
    'servicePrices.repairTypes.cameraAvant': 'Caméra avant',
    'servicePrices.repairTypes.hautParleur': 'Haut-parleur',
    'servicePrices.repairTypes.micro': 'Micro',
    'servicePrices.repairTypes.boutonPower': 'Bouton power',
    'servicePrices.repairTypes.boutonVolume': 'Bouton volume',
    'servicePrices.repairTypes.vitreArriere': 'Vitre arrière',
    'servicePrices.repairTypes.nappeFaceId': 'Nappe Face ID',
    'servicePrices.repairTypes.carteMere': 'Carte mère',
    'servicePrices.repairTypes.diagnostique': 'Diagnostic',
    'servicePrices.repairTypes.desoxydation': 'Désoxydation',
    'servicePrices.repairTypes.autre': 'Autre',
    'companySettings.toast.loadError': 'Erreur lors du chargement des paramètres',
    'companySettings.toast.saveSuccess': 'Paramètres enregistrés avec succès',
    'companySettings.toast.saveError': 'Erreur lors de l\'enregistrement',
    'companySettings.toast.notImage': 'Le fichier doit être une image',
    'companySettings.toast.tooLarge': 'Le fichier ne doit pas dépasser 5 Mo',
    'companySettings.toast.logoSuccess': 'Logo mis à jour avec succès',
    'companySettings.toast.logoError': 'Erreur lors de l\'upload du logo',
    'companySettings.toast.previewError': 'Erreur lors de la génération de l\'aperçu',
    'companySettings.tabs.info': 'Informations',
    'companySettings.tabs.documents': 'Documents (Factures, Devis, BC)',
    'companySettings.tabs.payment': 'Paiement',
    'companySettings.tabs.logo': 'Logo',
    'companySettings.tabs.preview': 'Aperçu PDF',
    'companySettings.tabs.security': 'Sécurité',
    'companySettings.title': 'Paramètres de l\'entreprise',
    'companySettings.subtitle': 'Configurez les informations de votre entreprise et vos documents',
    'companySettings.save': 'Enregistrer',
    'companySettings.info.sectionTitle': 'Informations de l\'entreprise',
    'companySettings.info.companyNameLabel': 'Nom de l\'entreprise',
    'companySettings.info.companyNamePlaceholder': 'Ex: Mon Entreprise SAS',
    'companySettings.info.legalFormLabel': 'Forme juridique',
    'companySettings.info.legalFormPlaceholder': 'Ex: SAS, SARL, EI...',
    'companySettings.info.capitalLabel': 'Capital social',
    'companySettings.info.capitalPlaceholder': 'Ex: 1 000 EUR',
    'companySettings.info.siretLabel': 'SIRET',
    'companySettings.info.siretPlaceholder': 'Ex: 123 456 789 00014',
    'companySettings.info.rcsLabel': 'RCS',
    'companySettings.info.rcsPlaceholder': 'Ex: Paris B 123 456 789',
    'companySettings.info.phoneLabel': 'Téléphone',
    'companySettings.info.phonePlaceholder': 'Ex: +594 694 XX XX XX',
    'companySettings.info.emailLabel': 'Email',
    'companySettings.info.emailPlaceholder': 'Ex: contact@monentreprise.com',
    'companySettings.info.postalLabel': 'Code postal',
    'companySettings.info.postalPlaceholder': 'Ex: 97300',
    'companySettings.info.addressLabel': 'Adresse',
    'companySettings.info.addressPlaceholder': 'Ex: 10 Rue Principale',
    'companySettings.info.cityLabel': 'Ville',
    'companySettings.info.cityPlaceholder': 'Ex: Cayenne',
    'companySettings.info.tvaLabel': 'Mention TVA',
    'companySettings.info.tvaPlaceholder': 'Mention fiscale sur les documents',
    'companySettings.documents.devisSectionTitle': 'Paramètres des Devis',
    'companySettings.documents.devisValidityLabel': 'Validité du devis',
    'companySettings.documents.devisValidityPlaceholder': 'Durée de validité du devis',
    'companySettings.documents.devisConditionsLabel': 'Conditions générales (devis)',
    'companySettings.documents.devisConditionsPlaceholder': 'Conditions générales affichées sur les devis',
    'companySettings.documents.bcSectionTitle': 'Paramètres des Bons de commande',
    'companySettings.documents.bcConditionsLabel': 'Conditions du bon de commande',
    'companySettings.documents.bcConditionsPlaceholder': 'Conditions d\'exécution des prestations',
    'companySettings.documents.factureSectionTitle': 'Paramètres des Factures',
    'companySettings.documents.facturePaymentLabel': 'Conditions de paiement',
    'companySettings.documents.facturePaymentPlaceholder': 'Ex: Paiement à réception...',
    'companySettings.documents.facturePenaltiesLabel': 'Pénalités de retard',
    'companySettings.documents.facturePenaltiesPlaceholder': 'Clause pénalités de retard',
    'companySettings.documents.factureRecoveryLabel': 'Indemnité de recouvrement',
    'companySettings.documents.factureRecoveryPlaceholder': 'Clause d\'indemnité forfaitaire',
    'companySettings.documents.factureReserveLabel': 'Réserve de propriété',
    'companySettings.documents.factureReservePlaceholder': 'Clause de réserve de propriété',
    'companySettings.documents.warrantySectionTitle': 'Garantie',
    'companySettings.documents.warrantyLabel': 'Mention de garantie',
    'companySettings.documents.warrantyPlaceholder': 'Ex: Garantie de 6 mois sur les pièces et la main d\'oeuvre à compter de la date de réparation.',
    'companySettings.documents.warrantyHint': 'Cette mention sera affichée en bas des factures si renseignée.',
    'companySettings.payment.sectionTitle': 'Paiement en ligne',
    'companySettings.payment.disableTitle': 'Désactiver le paiement en ligne',
    'companySettings.payment.disableDesc': 'Quand activé, les options de paiement en ligne (Stripe) sont cachées sur tous les devis. Les clients pourront uniquement demander un lien de paiement SumUp.',
    'companySettings.payment.statusDisabled': 'Paiement en ligne DÉSACTIVÉ - Les clients verront uniquement le formulaire de demande SumUp',
    'companySettings.payment.statusEnabled': 'Paiement en ligne ACTIVÉ - Les clients peuvent payer directement en ligne',
    'companySettings.payment.howTitle': 'Comment ça fonctionne ?',
    'companySettings.payment.step1': '1. Le client reçoit le devis par email et l\'accepte',
    'companySettings.payment.step2': '2. Au lieu de payer en ligne, il remplit un formulaire avec son email/téléphone',
    'companySettings.payment.step3': '3. Vous recevez une notification avec la demande de paiement',
    'companySettings.payment.step4': '4. Vous envoyez manuellement le lien de paiement SumUp au client',
    'companySettings.logo.sectionTitle': 'Logo de l\'entreprise',
    'companySettings.logo.description': 'Ce logo sera affiché sur vos factures, devis et bons de commande (formats PNG, JPG, max 5 Mo).',
    'companySettings.logo.alt': 'Logo',
    'companySettings.logo.none': 'Aucun logo',
    'companySettings.logo.uploading': 'Upload en cours...',
    'companySettings.logo.choose': 'Choisir un logo',
    'companySettings.logo.hint': 'Le logo sera automatiquement redimensionné sur les documents PDF.',
    'companySettings.preview.sectionTitle': 'Aperçu de vos documents',
    'companySettings.preview.description': 'Visualisez un exemple de facture ou devis avec vos paramètres actuels (logo, informations, mentions légales).',
    'companySettings.preview.saveReminder': 'Pensez à enregistrer vos modifications avant de générer l\'aperçu.',
    'companySettings.preview.facture': 'Facture',
    'companySettings.preview.devis': 'Devis',
    'companySettings.preview.generating': 'Génération...',
    'companySettings.preview.generate': 'Générer l\'aperçu',
    'companySettings.preview.iframeTitle': 'Aperçu PDF',
    'companySettings.security.genericError': 'Erreur',
    'companySettings.security.invalidCode': 'Code invalide',
    'companySettings.security.enabledToast': '2FA activé avec succès !',
    'companySettings.security.disabledToast': '2FA désactivé',
    'companySettings.security.sectionTitle': 'Sécurité du compte',
    'companySettings.security.twoFaTitle': 'Authentification à deux facteurs (2FA)',
    'companySettings.security.statusActive': 'Activé',
    'companySettings.security.statusInactive': 'Désactivé',
    'companySettings.security.intro': 'Protégez votre compte avec une vérification en deux étapes. À chaque connexion, un code à 6 chiffres vous sera demandé en plus de votre mot de passe.',
    'companySettings.security.configureBtn': 'Configurer 2FA',
    'companySettings.security.step1ScanPrefix': '1. Scannez ce QR code avec',
    'companySettings.security.step1ScanSuffix': ' :',
    'companySettings.security.qrAlt': 'QR Code 2FA',
    'companySettings.security.manualKeyLabel': 'Ou entrez cette clé manuellement :',
    'companySettings.security.step2Enter': '2. Entrez le code affiché dans l\'application :',
    'companySettings.security.activate': 'Activer',
    'companySettings.security.protectedMsg': 'Votre compte est protégé par le 2FA',
    'companySettings.security.disablePrompt': 'Pour désactiver, entrez votre code actuel :',
    'companySettings.security.disable': 'Désactiver',
    'docTimezone.title': 'Horaires Documents',
    'docTimezone.intro': 'Configurez le fuseau horaire utilisé pour les dates et heures sur vos documents (tickets, factures, devis, bons de commande).',
    'docTimezone.sectionTimezone': 'Fuseau Horaire',
    'docTimezone.selectLabel': 'Sélectionnez votre fuseau horaire',
    'docTimezone.currentLabel': 'Fuseau actuel :',
    'docTimezone.selectHint': 'Ce fuseau horaire sera appliqué à toutes les dates affichées sur vos documents. L\'heure d\'enregistrement des tickets ne changera jamais une fois enregistrée.',
    'docTimezone.save': 'Enregistrer',
    'docTimezone.importantTitle': 'Important',
    'docTimezone.importantBody': 'Par défaut, tous les documents utilisent le fuseau horaire de la Guyane Française (Cayenne, UTC-3). Si vous modifiez ce paramètre, les futurs documents utiliseront le nouveau fuseau. Les documents déjà créés conserveront leur heure d\'enregistrement originale.',
    'docTimezone.toastUpdated': 'Fuseau horaire mis à jour',
    'docTimezone.errUpdate': 'Erreur lors de la mise à jour',
    'docTimezone.errNetwork': 'Erreur réseau',
    'docTimezone.tzCayenne': 'Guyane Française (Cayenne)',
    'docTimezone.tzMartinique': 'Martinique / Guadeloupe',
    'docTimezone.tzGuadeloupe': 'Guadeloupe',
    'docTimezone.tzParis': 'France Métropolitaine (Paris)',
    'docTimezone.tzReunion': 'La Réunion',
    'docTimezone.tzNoumea': 'Nouvelle-Calédonie',
    'docTimezone.tzTahiti': 'Polynésie Française (Tahiti)',
    'flashOffers.confirmDelete': 'Supprimer cette offre ?',
    'flashOffers.emailsSentFallback': 'E-mails envoyés',
    'flashOffers.pageTitle': 'Offres Flash & Promos',
    'flashOffers.pageSubtitle': 'Gérez vos promotions temporaires et envoyez-les aux clients fidèles',
    'flashOffers.newOffer': 'Nouvelle offre',
    'flashOffers.createTitle': 'Créer une offre flash',
    'flashOffers.labelTitle': 'Titre *',
    'flashOffers.placeholderTitle': 'Ex : Spécial week-end',
    'flashOffers.labelDiscount': 'Remise (%)',
    'flashOffers.labelDescription': 'Description',
    'flashOffers.placeholderDescription': 'Ex : Réparation écran à prix réduit',
    'flashOffers.labelEndDate': 'Date de fin',
    'flashOffers.labelTargetLevels': 'Niveaux ciblés',
    'flashOffers.levelBronze': 'Bronze',
    'flashOffers.levelSilver': 'Argent',
    'flashOffers.levelGold': 'Or',
    'flashOffers.creating': 'Création...',
    'flashOffers.createOffer': 'Créer l\'offre',
    'flashOffers.emptyTitle': 'Aucune offre flash créée',
    'flashOffers.emptyHint': 'Cliquez sur « {{btn}} » pour commencer',
    'flashOffers.badgeExpired': 'Expirée',
    'flashOffers.badgeDisabled': 'Désactivée',
    'flashOffers.endLabel': 'Fin : {{date}}',
    'flashOffers.emailsCount': 'E-mails : {{count}}',
    'flashOffers.lastSent': 'Dernier envoi : {{date}}',
    'flashOffers.deactivate': 'Désactiver',
    'flashOffers.activate': 'Activer',
    'flashOffers.sendByEmail': 'Envoyer par e-mail',
    'flashOffers.delete': 'Supprimer',
    'mailsAi.oauthDenied': 'Autorisation Google refusée.',
    'mailsAi.sessionExpired': 'Session expirée, veuillez réessayer.',
    'mailsAi.tokenExchangeFailed': 'Erreur de connexion Google, veuillez réessayer.',
    'mailsAi.missingParams': 'Paramètres manquants.',
    'mailsAi.googleConnectError': 'Erreur de connexion Google.',
    'mailsAi.errorWith': 'Erreur : {{msg}}',
    'mailsAi.aiAnalysisError': 'Erreur analyse IA : {{msg}}',
    'mailsAi.confirmDeleteAccount': 'Supprimer ce compte email et tous ses messages stockés ?',
    'mailsAi.confirmRefetch': 'Cela va supprimer tous les emails en cache et les re-télécharger avec le rendu HTML complet. Continuer ?',
    'mailsAi.confirmBulkAnalyze': 'Analyser {{count}} emails non analysés ? (Utilise des crédits IA)',
    'mailsAi.fetchAnalyzedHeader': '{{count}} nouveaux emails récupérés et analysés.',
    'mailsAi.alertsDetected': '{{count}} alerte(s) détectée(s) :',
    'mailsAi.fetchAnalyzedNoThreat': '{{count}} nouveaux emails récupérés et analysés automatiquement. Aucune menace détectée.',
    'mailsAi.fetchRetrieved': '{{count}} nouveaux emails récupérés.',
    'mailsAi.noNewEmail': 'Aucun nouvel email.',
    'mailsAi.refetchDone': 'Re-synchronisation terminée ! {{count}} emails récupérés avec le rendu HTML.',
    'mailsAi.allVisibleAnalyzed': 'Tous les emails visibles sont déjà analysés !',
    'mailsAi.bulkAnalyzeDone': 'Analyse terminée ! {{done}}/{{total}} emails analysés.',
    'mailsAi.emailSent': 'Email envoyé avec succès !',
    'mailsAi.subtitle': 'Gestion intelligente de vos emails professionnels',
    'mailsAi.autoRefresh': 'Auto-refresh',
    'mailsAi.refresh': 'Actualiser',
    'mailsAi.analyzeAll': 'Analyser tout',
    'mailsAi.compose': 'Nouveau mail',
    'mailsAi.addAccount': 'Ajouter un compte',
    'mailsAi.loadingAccounts': 'Chargement des comptes...',
    'mailsAi.noAccountTitle': 'Aucun compte email connecté',
    'mailsAi.noAccountDesc': 'Connectez votre premier compte email pour commencer.',
    'mailsAi.fetchingAll': 'Récupération de tous les emails...',
    'mailsAi.fetchingAllHint': 'Cela peut prendre quelques minutes',
    'mailsAi.noEmail': 'Aucun email.',
    'mailsAi.noSubject': '(sans objet)',
    'mailsAi.prev': 'Préc.',
    'mailsAi.next': 'Suiv.',
    'mailsAi.pageOf': '{{page}} / {{total}}',
    'sumupTerminal.title': 'Terminal SumUp (TPE)',
    'sumupTerminal.subtitle': 'Un TPE par magasin — M1 et M2 sont indépendants. Le POS V2 utilise le TPE du magasin sélectionné.',
    'sumupTerminal.hintM1': 'TPE Resurrection Mobile (SOLO)',
    'sumupTerminal.hintM2': 'À configurer quand le 2ᵉ TPE sera jumelé SumUp',
    'sumupTerminal.m2NotConfigured': 'M2 n\'est pas encore configuré — normal si le 2ᵉ TPE n\'est pas encore jumelé. Quand il le sera, remplissez les champs ci-dessous (compte SumUp M2 séparé).',
    'sumupTerminal.step1Lead': 'Dans SumUp Cloud → Terminaux → copiez le',
    'sumupTerminal.step1Merchant': 'code marchand',
    'sumupTerminal.step1And': ' et l\'',
    'sumupTerminal.step1Reader': 'ID lecteur',
    'sumupTerminal.step2Lead': 'Collez la',
    'sumupTerminal.step2Secret': 'clé SECRÈTE',
    'sumupTerminal.step2Mid': '(sup_sk_…) —',
    'sumupTerminal.step2Public': 'pas la clé publique sup_pk_',
    'sumupTerminal.step3Lead': 'Cliquez',
    'sumupTerminal.step3Verify': 'Vérifier la clé API',
    'sumupTerminal.step3Rest': '→ le code marchand se remplit automatiquement',
    'sumupTerminal.step4Lead': 'Sélectionnez le TPE dans la liste, puis',
    'sumupTerminal.step4Save': 'Enregistrer',
    'sumupTerminal.labelName': 'Nom du TPE (optionnel)',
    'sumupTerminal.namePlaceholder': 'Ex: MON TPE M1',
    'sumupTerminal.labelApiKey': 'Clé API secrète SumUp (sup_sk_…) *',
    'sumupTerminal.savedKeyPlaceholder': 'Enregistrée : {{masked}}',
    'sumupTerminal.apiKeyHint': 'Clé secrète sup_sk_ uniquement. SumUp ne la montre qu\'une fois à la création.',
    'sumupTerminal.verifyKeyBtn': '1. Vérifier la clé API',
    'sumupTerminal.keyConfirmed': '✓ Clé confirmée par SumUp',
    'sumupTerminal.labelMerchantCode': 'Code marchand *',
    'sumupTerminal.labelReaderId': 'ID lecteur (reader) *',
    'sumupTerminal.discoverBtn': 'Trouver mes TPE',
    'sumupTerminal.readerFallback': 'TPE SumUp',
    'sumupTerminal.labelDeviceId': 'Identifiant appareil (optionnel)',
    'sumupTerminal.saveBtn': 'Enregistrer {{mag}}',
    'sumupTerminal.testBtn': 'Test {{amount}} sur TPE',
    'sumupTerminal.checklistTitle': 'Checklist TPE',
    'sumupTerminal.checklistWifi': 'Terminal allumé et connecté au Wi‑Fi',
    'sumupTerminal.checklistPaired': 'Statut « Jumelé » dans SumUp Cloud',
    'sumupTerminal.checklistSolo': 'Logiciel Solo ≥ 3.3.24',
    'sumupTerminal.checklistBluetooth': 'Bluetooth et API ne fonctionnent pas ensemble — coupez Bluetooth sur le SOLO si vous utilisez le POS',
    'sumupTerminal.checklistCancel': 'Si le montant s\'affiche puis s\'annule seul : reconnectez API sur le TPE (pas un bug POS)',
    'sumupTerminal.openCloud': 'Ouvrir SumUp Cloud',
    'sumupTerminal.errLoad': 'Impossible de charger la config',
    'sumupTerminal.msgMerchantChanged': 'Compte marchand modifié — vérifiez la clé API puis sélectionnez le TPE.',
    'sumupTerminal.errPasteSecret': 'Collez d\'abord la clé secrète SumUp (sup_sk_…), pas la clé publique sup_pk_.',
    'sumupTerminal.keyOkReaders': 'Clé OK — compte {{mc}} · {{count}} TPE trouvé(s).',
    'sumupTerminal.keyOkNone': 'Clé OK — compte {{mc}} · aucun TPE jumelé dans SumUp Cloud.',
    'sumupTerminal.errKeyRejected': 'Clé API refusée par SumUp',
    'sumupTerminal.msgNoReaders': 'Aucun TPE trouvé — vérifiez que le terminal est jumelé dans SumUp Cloud.',
    'sumupTerminal.errDiscover': 'Erreur recherche TPE',
    'sumupTerminal.readerSelected': 'TPE sélectionné : {{name}}',
    'sumupTerminal.errMerchantChangeKey': 'Changement de compte SumUp : saisissez la nouvelle clé API (sup_sk_…) avant d\'enregistrer.',
    'sumupTerminal.errVerifyFirst': 'Cliquez d\'abord sur « Vérifier la clé API » — SumUp doit confirmer la clé avant l\'enregistrement.',
    'sumupTerminal.errReaderRequired': 'ID lecteur requis — cliquez « Trouver mes TPE » et sélectionnez le terminal.',
    'sumupTerminal.savedWithNotice': 'Configuration {{mag}} enregistrée. {{notice}}',
    'sumupTerminal.saved': 'Configuration {{mag}} enregistrée.',
    'sumupTerminal.errSave': 'Erreur enregistrement',
    'sumupTerminal.testOk': 'Test OK — regardez le TPE',
    'sumupTerminal.errTest': 'Test échoué',
    'adminB2B.accessDenied': 'Accès refusé',
    'adminB2B.reservedAdmins': 'Réservé aux administrateurs.',
    'adminB2B.backToDashboard': 'Retour au tableau de bord',
    'adminB2B.back': 'Retour',
    'adminB2B.title': 'Clients B2B',
    'adminB2B.accountsSingular': 'Entreprises inscrites sur le portail B2B — {{count}} compte',
    'adminB2B.accountsPlural': 'Entreprises inscrites sur le portail B2B — {{count}} comptes',
    'adminB2B.colCompany': 'Entreprise',
    'adminB2B.colManager': 'Gérant',
    'adminB2B.colEmail': 'Email',
    'adminB2B.colPhone': 'Téléphone',
    'adminB2B.colStatus': 'Statut',
    'adminB2B.colRegistered': 'Inscription',
    'adminB2B.empty': 'Aucun client B2B',
    'adminB2B.statusValide': 'Validé',
    'adminB2B.statusEnAttente': 'En attente',
    'adminB2B.statusRefuse': 'Refusé',
    'adminCache.statusCompleted': 'Terminé',
    'adminCache.statusRunning': 'En cours...',
    'adminCache.statusUpdating': 'Mise à jour',
    'adminCache.statusError': 'Erreur',
    'adminCache.never': 'Jamais',
    'adminCache.title': 'Données Fournisseurs',
    'adminCache.refreshing': 'Actualisation...',
    'adminCache.refreshData': 'Actualiser les données',
    'adminCache.step1Title': 'Étape 1 — Identifiants fournisseurs.',
    'adminCache.step1Intro': 'Saisissez email et mot de passe Mobilax, JensMobiles et LCD-Phone sur la page',
    'adminCache.step1LinkText': 'Identifiants fournisseurs',
    'adminCache.step1Outro': 'Puis revenez ici et cliquez « {{action}} » pour alimenter l\'Auto-Devis IA.',
    'adminCache.configurePasswords': 'Configurer les MDP',
    'adminCache.totalCached': 'Total produits en cache',
    'adminCache.spareParts': 'Pièces détachées',
    'adminCache.accessories': 'Accessoires',
    'adminCache.phones': 'Téléphones',
    'adminCache.syncState': 'État de la synchronisation',
    'adminCache.noSync': 'Aucune synchronisation effectuée',
    'adminCache.exploreCache': 'Explorer le cache',
    'adminCache.searchPlaceholder': 'Rechercher (ex: coque iPhone 14, Galaxy A06 neuf)...',
    'adminCache.allTypes': 'Tous types',
    'adminCache.filterParts': 'Pièces',
    'adminCache.filterAccessories': 'Accessoires',
    'adminCache.filterPhones': 'Téléphones',
    'adminCache.colType': 'Type',
    'adminCache.colSupplier': 'Fournisseur',
    'adminCache.colPart': 'Pièce',
    'adminCache.colBrand': 'Marque',
    'adminCache.colPrice': 'Prix',
    'adminCache.colStock': 'Stock',
    'adminCache.colRef': 'Réf.',
    'adminCache.catPart': 'Pièce',
    'adminCache.catAccessory': 'Accessoire',
    'adminCache.catPhone': 'Téléphone',
    'adminCache.inStock': 'En stock',
    'adminCache.outOfStock': 'Rupture de stock',
    'adminCache.noResults': 'Aucun résultat pour "{{query}}"',
    'adminDownloads.artifactDesktopLabel': 'Application Windows staff',
    'adminDownloads.artifactDesktopDesc': 'Archive ZIP distribuée aux utilisateurs Windows.',
    'adminDownloads.artifactPackLabel': 'Pack agent imprimante',
    'adminDownloads.artifactPackDesc': 'Archive ZIP source pour reconstruire l\'agent d\'impression.',
    'adminDownloads.artifactExeLabel': 'Agent Windows',
    'adminDownloads.artifactExeDesc': 'Exécutable prêt à lancer sur le poste technicien.',
    'adminDownloads.available': 'Disponible',
    'adminDownloads.missing': 'Manquant',
    'adminDownloads.download': 'Télécharger',
    'adminDownloads.activeFile': 'Fichier actif',
    'adminDownloads.size': 'Taille',
    'adminDownloads.lastUpdate': 'Dernière mise à jour',
    'adminDownloads.uploadedBy': 'Mis en ligne par',
    'adminDownloads.replaceLiveFile': 'Remplacer le fichier live',
    'adminDownloads.uploading': 'Upload...',
    'adminDownloads.replace': 'Remplacer',
    'adminDownloads.replaceHint': 'Le fichier choisi remplace directement celui servi aux utilisateurs sur remobiles.com.',
    'adminDownloads.selectedFile': 'Fichier sélectionné : {{name}}',
    'adminDownloads.loadError': 'Erreur de chargement des fichiers',
    'adminDownloads.downloadLinkUnavailable': 'Lien de téléchargement indisponible',
    'adminDownloads.downloadFailed': 'Téléchargement impossible',
    'adminDownloads.selectFilePrompt': 'Sélectionne un fichier pour {{label}}.',
    'adminDownloads.confirmReplace': 'Remplacer maintenant {{label}} par {{name}} ?',
    'adminDownloads.replaceSuccess': '{{label}} remplacé avec succès.',
    'adminDownloads.uploadError': 'Erreur pendant l\'upload',
    'adminDownloads.title': 'Installateurs & téléchargements',
    'adminDownloads.subtitle': 'Téléchargements directs des packages Windows et remplacement live pour super admin.',
    'adminDownloads.printerConfig': 'Configuration imprimante',
    'adminDownloads.refresh': 'Actualiser',
    'adminDownloads.availableArtifacts': 'Artifacts disponibles',
    'adminDownloads.totalSize': 'Taille totale',
    'adminDownloads.alert': 'Alerte',
    'adminDownloads.alertText': 'Les remplacements écrasent le fichier live. Pas de suppression distincte.',
    'adminDownloads.accessTitle': 'Accès admin et super admin',
    'adminDownloads.accessText': 'Cette page centralise les téléchargements visibles depuis remobiles.com. Le remplacement live des fichiers n\'apparaît que pour le super admin.',
    'adminDownloads.signedLinksNote': 'Les liens de téléchargement restent signés par le backend pour éviter les blobs côté navigateur.',
    'adminCachePurge.accessDenied': 'Accès réservé à Carlos.',
    'adminCachePurge.title': 'Purge documents commerciaux',
    'adminCachePurge.descIntro': 'Page cachée — Carlos uniquement. Supprime ventes, registres, commandes, acomptes et devis/factures',
    'adminCachePurge.descBefore': 'avant',
    'adminCachePurge.descOutro': 'la date choisie. Les réparations ne sont pas touchées.',
    'adminCachePurge.warnBackupBefore': 'Action destructive et irréversible. Faites un export backup depuis',
    'adminCachePurge.warnBackupLink': 'Base de données',
    'adminCachePurge.warnBackupAfter': 'avant toute purge réelle.',
    'adminCachePurge.resultDryRunLine': 'Simulation terminée — {{count}} document(s) seraient supprimés avant {{before}}.',
    'adminCachePurge.resultPurgeLine': 'Purge exécutée — {{count}} document(s) supprimés avant {{before}}.',
    'adminCachePurge.sectionParams': 'Paramètres',
    'adminCachePurge.labelBeforeDate': 'Supprimer tout avant le',
    'adminCachePurge.hintStrictlyBefore': 'Strictement avant 00:00 ce jour-là.',
    'adminCachePurge.labelConfirm': 'Confirmation (obligatoire)',
    'adminCachePurge.hintTypeToken': 'Tapez : {{token}}',
    'adminCachePurge.dryRunLabel': 'Mode simulation (dry-run) — ne supprime rien',
    'adminCachePurge.previewBtn': 'Aperçu',
    'adminCachePurge.simulateBtn': 'Simuler la purge',
    'adminCachePurge.executeBtn': 'Exécuter la purge',
    'adminCachePurge.previewHeading': 'Aperçu — {{count}} document(s)',
    'adminCachePurge.beforeLabel': 'avant {{before}}',
    'adminCachePurge.previewEmpty': 'Aucune donnée à afficher.',
    'adminCachePurge.colCollection': 'Collection',
    'adminCachePurge.colCount': 'Nombre',
    'adminCachePurge.colExamples': 'Exemples',
    'adminCachePurge.sectionExcluded': 'Non supprimé',
    'adminCachePurge.excludedReparations': 'Réparations (devices)',
    'adminCachePurge.excludedStock': 'Stock',
    'adminCachePurge.excludedClients': 'Clients',
    'adminCachePurge.excludedUtilisateurs': 'Utilisateurs',
    'adminCachePurge.confirmDryRun': 'Simulation purge avant le {{before}} ({{count}} documents) ?',
    'adminCachePurge.confirmDelete': '⚠️ IRRÉVERSIBLE — Supprimer {{count}} documents commerciaux avant le {{before}} ?',
    'adminCachePurge.errorPreview': 'Erreur lors de l\'aperçu',
    'adminCachePurge.errorLoad': 'Erreur de chargement',
    'adminCachePurge.errorPurge': 'Erreur lors de la purge',
    'adminSupplierCreds.title': 'Identifiants fournisseurs',
    'adminSupplierCreds.subtitle': '{{providers}} — pour l\'Auto-Devis et le cache catalogue',
    'adminSupplierCreds.supplierData': 'Données fournisseurs',
    'adminMagasins.statusActive': 'Actif',
    'adminMagasins.statusArchived': 'Archivé',
    'adminMagasins.newStore': 'Nouveau magasin',
    'adminMagasins.fieldCode': 'Code (auto-généré, éditable)',
    'adminMagasins.fieldName': 'Nom *',
    'adminMagasins.namePlaceholder': 'ex : Magasin Cayenne Centre',
    'adminMagasins.fieldAddress': 'Adresse',
    'adminMagasins.fieldPhone': 'Téléphone',
    'adminMagasins.fieldPrinterIp': 'Imprimante (IP)',
    'adminMagasins.printerIpPlaceholder': 'ex : 192.168.1.50  — laisser vide si pas d\'imprimante dédiée',
    'adminMagasins.printerIpHint': 'Si vide → repli sur l\'imprimante de la session POS.',
    'adminMagasins.fieldBadgeColor': 'Couleur du badge',
    'adminMagasins.setAsDefault': 'Définir comme magasin par défaut',
    'adminMagasins.defaultWillBeDemoted': 'Le magasin {{code}} ({{name}}) est actuellement par défaut. Il sera rétrogradé automatiquement.',
    'adminMagasins.cancel': 'Annuler',
    'adminMagasins.createStore': 'Créer le magasin',
    'adminMagasins.nameRequired': 'Nom requis',
    'adminMagasins.createError': 'Erreur de création',
    'adminMagasins.confirmOverrideDefault': 'Le magasin « {{code}} — {{name}} » est actuellement le magasin par défaut.\n\nEn cochant « Définir par défaut », il sera rétrogradé automatiquement.\n\nConfirmer ?',
    'adminMagasins.loadError': 'Erreur de chargement',
    'adminMagasins.confirmArchive': 'Archiver le magasin {{code}} ? Les articles et ventes ne seront PAS supprimés.',
    'adminMagasins.genericError': 'Erreur',
    'adminMagasins.back': 'Retour',
    'adminMagasins.title': 'Magasins',
    'adminMagasins.subtitle': 'Gérer les magasins (boutiques physiques)',
    'adminMagasins.filterActive': 'Actifs',
    'adminMagasins.filterArchived': 'Archivés',
    'adminMagasins.filterAll': 'Tous',
    'adminMagasins.colCode': 'Code',
    'adminMagasins.colName': 'Nom',
    'adminMagasins.colAddress': 'Adresse',
    'adminMagasins.colPhone': 'Téléphone',
    'adminMagasins.colPrinterIp': 'Imprimante IP',
    'adminMagasins.colColor': 'Couleur',
    'adminMagasins.colStatus': 'Statut',
    'adminMagasins.colActions': 'Actions',
    'adminMagasins.loading': 'Chargement…',
    'adminMagasins.emptyArchived': 'Aucun magasin archivé.',
    'adminMagasins.emptyActive': 'Aucun magasin actif.',
    'adminMagasins.defaultBadge': 'DÉFAUT',
    'adminMagasins.edit': 'Modifier',
    'adminMagasins.cannotArchiveDefault': 'Impossible — magasin par défaut',
    'adminMagasins.archive': 'Archiver',
    'adminMagasins.restore': 'Restaurer',
    'adminMagasins.footerNote': 'Les magasins archivés conservent leurs articles et ventes (R1 — soft delete uniquement). Le magasin marqué « {{badge}} » ne peut pas être archivé.',
    'adminPromos.title': 'Promotions automatisées',
    'adminPromos.subtitle': 'Promotions actives, calendrier et paramètres',
    'adminPromos.tabCurrent': 'Promotions actives',
    'adminPromos.tabCalendar': 'Calendrier mensuel',
    'adminPromos.tabSettings': 'Paramètres',
    'adminPromos.forceDailyDraw': 'Forcer un nouveau tirage daily',
    'adminPromos.ref': 'Réf : {{ref}}',
    'adminPromos.statusActive': '🟢 Active',
    'adminPromos.statusInactive': '⚫ Inactive',
    'adminPromos.endLabel': 'fin : {{date}}',
    'adminPromos.emptyPromos': 'Aucune promotion',
    'adminPromos.regenThisMonth': 'Régénérer ce mois',
    'adminPromos.productsCount': '{{count}} produits',
    'adminPromos.emptyCalendar': 'Aucun calendrier — Régénérer ?',
    'adminPromos.configDaily': 'Daily auto-bot',
    'adminPromos.excludedCategories': 'Catégories exclues (séparées par virgule)',
    'adminPromos.excludedKeywords': 'Mots-clés exclus (regex OR, optionnel — vide = utilise les défauts)',
    'adminPromos.save': 'Sauvegarder',
    'adminPromos.minPct': 'Min %',
    'adminPromos.maxPct': 'Max %',
    'adminPromos.confirmRegenDaily': 'Tirer une nouvelle promo daily maintenant ?',
    'adminPromos.drawResult': 'Nouveau tirage : {{name}}',
    'adminPromos.statusResult': 'Statut : {{status}}',
    'adminPromos.confirmRegenCalendar': 'Régénérer le calendrier de {{month}} ? Cela écrase l\'existant.',
    'adminPromos.calendarRegenResult': '{{status}} — {{count}} produits utilisés',
    'adminPromos.settingsSaved': 'Paramètres sauvegardés',
    'adminCadbotPrix.source.ventePos': 'Vente POS',
    'adminCadbotPrix.source.reparation': 'Réparation',
    'adminCadbotPrix.source.devisValide': 'Devis validé',
    'adminCadbotPrix.refSource.prixValide': 'prix validé',
    'adminCadbotPrix.refSource.tarifPublic': 'tarif public',
    'adminCadbotPrix.refSource.calculFournisseur': 'calcul fournisseur',
    'adminCadbotPrix.refSource.aucune': 'aucune référence',
    'adminCadbotPrix.loadError': 'Erreur de chargement',
    'adminCadbotPrix.genericError': 'Erreur',
    'adminCadbotPrix.toastCollected': '{{ventes}} ventes + {{reparations}} réparations mémorisées',
    'adminCadbotPrix.toastAnalyzed': '{{creees}} nouvelle(s) proposition(s), {{maj}} mise(s) à jour',
    'adminCadbotPrix.priceInvalid': 'Prix invalide',
    'adminCadbotPrix.toastApproved': 'Prix validé : {{price}} — {{detail}}',
    'adminCadbotPrix.toastApprovedLocked': 'tarif manuel verrouillé, proposition en attente',
    'adminCadbotPrix.toastApprovedPublished': 'page Tarifs mise à jour',
    'adminCadbotPrix.rejectReasonPrompt': 'Motif du refus (optionnel) :',
    'adminCadbotPrix.proposalRejected': 'Proposition refusée',
    'adminCadbotPrix.settingsSaved': 'Réglages enregistrés',
    'adminCadbotPrix.confirmRemoveValidated': 'Retirer le prix validé {{model}} · {{part}} · {{quality}} ?',
    'adminCadbotPrix.validatedRemoved': 'Prix validé retiré',
    'adminCadbotPrix.pageTitle': 'Validation des prix CADBOT',
    'adminCadbotPrix.pageSubtitle': 'CADBOT mémorise les prix réellement facturés et propose des ajustements. Chaque prix validé alimente la page Tarifs et devient prioritaire pour les devis.',
    'adminCadbotPrix.rules': 'Règles',
    'adminCadbotPrix.collecting': 'Collecte…',
    'adminCadbotPrix.memorizeSales': 'Mémoriser les ventes',
    'adminCadbotPrix.analyzing': 'Analyse…',
    'adminCadbotPrix.analyze': 'Analyser',
    'adminCadbotPrix.minSales': 'Ventes minimum',
    'adminCadbotPrix.tolerancePct': 'Écart minimum (%)',
    'adminCadbotPrix.toleranceEur': 'Écart minimum (€)',
    'adminCadbotPrix.windowDays': 'Fenêtre (jours)',
    'adminCadbotPrix.publishOnApprove': 'Publier sur la page Tarifs dès la validation',
    'adminCadbotPrix.countDevisValides': 'Compter aussi les devis IA approuvés (en plus des ventes facturées)',
    'adminCadbotPrix.filterPending': 'À valider',
    'adminCadbotPrix.filterApproved': 'Validées',
    'adminCadbotPrix.filterRejected': 'Refusées',
    'adminCadbotPrix.filterAll': 'Toutes',
    'adminCadbotPrix.refresh': 'Rafraîchir',
    'adminCadbotPrix.loading': 'Chargement…',
    'adminCadbotPrix.emptyProposals': 'Aucune proposition {{scope}}. Cliquez « {{collect}} » puis « {{analyze}} ».',
    'adminCadbotPrix.emptyScopePending': 'à valider',
    'adminCadbotPrix.tier': 'Gamme',
    'adminCadbotPrix.realSales': '{{count}} vente(s) réelle(s) (de {{min}} à {{max}})',
    'adminCadbotPrix.lastSaleOn': 'dernière le {{date}}',
    'adminCadbotPrix.statusBadgePending': 'À VALIDER',
    'adminCadbotPrix.statusBadgeApproved': 'VALIDÉE',
    'adminCadbotPrix.statusBadgeRejected': 'REFUSÉE',
    'adminCadbotPrix.referencePrice': 'Prix de référence',
    'adminCadbotPrix.medianRealSales': 'Médiane des ventes réelles',
    'adminCadbotPrix.priceToValidate': 'Prix à valider (modifiable)',
    'adminCadbotPrix.priceRetained': 'Prix retenu',
    'adminCadbotPrix.evidenceSales': 'Ventes justificatives ({{count}})',
    'adminCadbotPrix.thDate': 'Date',
    'adminCadbotPrix.thSource': 'Source',
    'adminCadbotPrix.thRef': 'Réf.',
    'adminCadbotPrix.thDesignation': 'Désignation',
    'adminCadbotPrix.thPriceTtc': 'Prix TTC',
    'adminCadbotPrix.validate': 'Valider',
    'adminCadbotPrix.validateAt': 'à {{price}} €',
    'adminCadbotPrix.reject': 'Refuser',
    'adminCadbotPrix.reviewApproved': 'Validée par {{by}} le {{date}}',
    'adminCadbotPrix.reviewRejected': 'Refusée par {{by}} le {{date}}',
    'adminCadbotPrix.lockedPendingNote': '(tarif édité à la main : verrouillé, prix en attente)',
    'adminCadbotPrix.validatedPrices': 'Prix validés ({{count}})',
    'adminCadbotPrix.noValidatedPrices': 'Aucun prix validé pour le moment.',
    'adminCadbotPrix.thDevice': 'Appareil',
    'adminCadbotPrix.thPart': 'Pièce',
    'adminCadbotPrix.thTier': 'Gamme',
    'adminCadbotPrix.thPrice': 'Prix',
    'adminCadbotPrix.thValidated': 'Validé',
    'adminCadbotPrix.salesCountShort': '{{count}} vente(s)',
    'adminCadbotPrix.remove': 'Retirer',
    'adminCommissions.typeVentes': 'Ventes',
    'adminCommissions.typeCommandes': 'Commandes',
    'adminCommissions.typeAcomptes': 'Acomptes',
    'adminCommissions.typeReparations': 'Réparations',
    'adminCommissions.typeFactures': 'Factures',
    'adminCommissions.typeDevis': 'Devis',
    'adminCommissions.typeB2b': 'B2B',
    'adminCommissions.typeDeplacement': 'Déplacement',
    'adminCommissions.tagBackfill': 'Backfill',
    'adminCommissions.tagDoublonPotentiel': 'Doublon potentiel',
    'adminCommissions.tagSuspectReparation': 'Suspect réparation',
    'adminCommissions.tagSuspectCommande': 'Suspect commande',
    'adminCommissions.confirmCancel': 'Annuler cette commission ?',
    'adminCommissions.noSelection': 'Aucune ligne sélectionnée',
    'adminCommissions.confirmBulkMarkPaid': 'Marquer {{count}} commission(s) comme payée(s) ?',
    'adminCommissions.confirmRecompute30d': 'Recalculer les commissions des 30 derniers jours pour les ventes existantes ?\nIdempotent : ne crée pas de doublon.',
    'adminCommissions.recomputeResult': 'Scan : {{scanned}} ventes — {{created}} commissions créées',
    'adminCommissions.error': 'Erreur : {{detail}}',
    'adminCommissions.title': 'Commissions',
    'adminCommissions.totalToPay': 'Total à payer',
    'adminCommissions.alreadyPaid': 'Déjà payé',
    'adminCommissions.recompute30d': 'Recalculer 30 derniers jours',
    'adminCommissions.recompute30dHint': 'Backfill rétroactif des ventes existantes',
    'adminCommissions.configPerStaff': 'Configuration par staff',
    'adminCommissions.configure': 'Configurer',
    'adminCommissions.noStaffFound': 'Aucun staff trouvé',
    'adminCommissions.filters': 'Filtres',
    'adminCommissions.allStatuses': 'Tous statuts',
    'adminCommissions.statusToPay': 'À payer',
    'adminCommissions.statusPaid': 'Payées',
    'adminCommissions.statusCancelled': 'Annulées',
    'adminCommissions.allStaff': 'Tous staff',
    'adminCommissions.allTypes': 'Tous types',
    'adminCommissions.auditHeuristic': 'Audit heuristique',
    'adminCommissions.auditAdvanced': 'Audit avancé multi-signaux',
    'adminCommissions.metierAuditReadOnly': 'Audit avancé — lecture seule · ledger Mongo intact · multi-signaux analyseur uniquement',
    'adminCommissions.metierAuditLoading': 'Analyse métier en cours…',
    'adminCommissions.ledgerCommissionStored': 'Commission ledger (stockée)',
    'adminCommissions.metierCommissionTheoretical': 'Commission métier théorique',
    'adminCommissions.totalGapPeriod': 'Écart total période',
    'adminCommissions.rowsAnalyzed': 'Lignes analysées',
    'adminCommissions.typeMismatchDetected': 'Écarts type détectés',
    'adminCommissions.auditHeuristicLegend': 'Audit heuristique : classification par référence transaction. Aucune écriture en base.',
    'adminCommissions.legendRecompute30d': 'recalcul 30j',
    'adminCommissions.combinedAuditNote': 'Colonnes Ledger = valeurs stockées Mongo (type, taux snapshot, commission_amount). Colonnes Métier = analyse multi-signaux + config actuelle staff pour le type détecté.',
    'adminCommissions.bulkMarkPaid': 'Marquer payées ({{count}})',
    'adminCommissions.clearSelection': 'Annuler la sélection',
    'adminCommissions.colDate': 'Date',
    'adminCommissions.colStaff': 'Staff',
    'adminCommissions.colType': 'Type',
    'adminCommissions.colTransaction': 'Transaction',
    'adminCommissions.colAmount': 'Montant',
    'adminCommissions.colRateApplied': 'Taux appliqué',
    'adminCommissions.colCommission': 'Commission',
    'adminCommissions.colStatus': 'Statut',
    'adminCommissions.colLedgerType': 'L. type',
    'adminCommissions.colLedgerRate': 'L. taux',
    'adminCommissions.colLedgerCommission': 'L. commission',
    'adminCommissions.colMetierType': 'M. type',
    'adminCommissions.colMetierRate': 'M. taux',
    'adminCommissions.colMetierCommission': 'M. commission',
    'adminCommissions.colGap': 'Écart',
    'adminCommissions.colAuditSignals': 'Signaux audit',
    'adminCommissions.colRealType': 'Type réel (audit)',
    'adminCommissions.colAppliedType': 'Type appliqué',
    'adminCommissions.colSource': 'Source',
    'adminCommissions.loading': 'Chargement…',
    'adminCommissions.mixed': 'mixte',
    'adminCommissions.pairLabel': 'Paire : {{id}}',
    'adminCommissions.expectedLabel': 'Attendu : {{type}}',
    'adminCommissions.markPaidShort': 'Payé',
    'adminCommissions.noCommissionInFilter': 'Aucune commission dans ce filtre',
    'adminCommissions.noCommissionHint': 'Si une commission vient d\'être activée, utilisez le bouton « Recalculer 30 derniers jours » ci-dessus.',
    'adminCommissions.modalTitle': 'Commissions de {{name}}',
    'adminCommissions.cancel': 'Annuler',
    'adminCommissions.save': 'Sauvegarder',
    'adminCloud.status.ok': 'OK',
    'adminCloud.status.ko': 'Échec',
    'adminCloud.status.skipped': 'Skip',
    'adminCloud.docType.ticket': 'Ticket réparation',
    'adminCloud.docType.facture': 'Facture',
    'adminCloud.docType.acompte': 'Acompte',
    'adminCloud.docType.devis': 'Devis',
    'adminCloud.docType.bonCommande': 'Bon de commande',
    'adminCloud.errors.load': 'Erreur de chargement',
    'adminCloud.errors.save': 'Erreur d\'enregistrement',
    'adminCloud.errors.test': 'Erreur de test',
    'adminCloud.errors.rebuild': 'Erreur reconstruction',
    'adminCloud.errors.syncToggle': 'Erreur basculement sync.',
    'adminCloud.save.success': 'Paramètres enregistrés (la clé en clair n\'est jamais renvoyée).',
    'adminCloud.test.ok': '✓ Connexion OK — {{name}} (owner: {{owner}}, expire: {{expires}})',
    'adminCloud.test.ko': 'Connexion KO: {{error}}',
    'adminCloud.test.unknownError': 'inconnue',
    'adminCloud.hierarchy.ok': '✓ Hiérarchie OK — {{path}} (folder_id: {{folderId}}...)',
    'adminCloud.hierarchy.ko': 'Hiérarchie KO — {{message}}',
    'adminCloud.access.adminRequired': 'Accès admin requis.',
    'adminCloud.sync.resumed': 'Synchronisation cloud REPRISE.',
    'adminCloud.sync.paused': 'Synchronisation cloud MISE EN PAUSE.',
    'adminCloud.title': 'Sync Cloud — remobiles.fr',
    'adminCloud.subtitlePre': 'Vos PDFs (tickets, factures, devis, acomptes) sont automatiquement archivés dans votre espace privé',
    'adminCloud.refresh': 'Rafraîchir',
    'adminCloud.sync.active': 'Synchronisation cloud ACTIVE',
    'adminCloud.sync.pausedLabel': 'Synchronisation cloud EN PAUSE',
    'adminCloud.sync.pausedAt': 'Mise en pause le {{date}}',
    'adminCloud.sync.pausedBy': ' par {{by}}',
    'adminCloud.sync.activeHint': 'Tous les nouveaux documents PDF sont automatiquement uploades vers remobiles.fr.',
    'adminCloud.sync.pauseBtn': 'Mettre en pause',
    'adminCloud.sync.resumeBtn': 'Reprendre',
    'adminCloud.confirm.resumeTitle': 'Reprendre la synchronisation ?',
    'adminCloud.confirm.pauseTitle': 'Mettre en pause la synchronisation ?',
    'adminCloud.confirm.resumeBody': 'Les nouveaux documents seront a nouveau uploades automatiquement vers remobiles.fr.',
    'adminCloud.confirm.pauseBody': 'Aucun nouveau document ne sera uploade tant que vous ne reprendrez pas la sync. Les documents existants ne sont pas affectes.',
    'adminCloud.cancel': 'Annuler',
    'adminCloud.stats.globalStatus': 'Statut global',
    'adminCloud.stats.enabled': 'Activé',
    'adminCloud.stats.disabled': 'Désactivé',
    'adminCloud.stats.uploadsOk': 'Uploads OK',
    'adminCloud.stats.uploadsKo': 'Uploads KO',
    'adminCloud.stats.total': 'Total',
    'adminCloud.structure.title': 'Structure cible cloud (hiérarchie réelle)',
    'adminCloud.structure.cachedTotal': '{{count}} dossiers en cache',
    'adminCloud.structure.createdThisMonth': '{{count}} créés ce mois',
    'adminCloud.structure.retryHierarchy': 'Réessayer la création de la hiérarchie',
    'adminCloud.structure.noUploadToday': '(aucun upload aujourd\'hui)',
    'adminCloud.structure.flat': '(flat)',
    'adminCloud.structure.recentFolders': 'Dossiers récemment créés',
    'adminCloud.structure.noFolderCache': '(aucun dossier en cache)',
    'adminCloud.structure.policyLabel': 'Politique',
    'adminCloud.structure.policyBody': ': aucune suppression de dossier ou fichier n\'est jamais envoyée à remobiles.fr. Les fichiers de test restent visibles côté cloud.',
    'adminCloud.loading': 'Chargement...',
    'adminCloud.connection.title': 'Paramètres de connexion',
    'adminCloud.connection.uploadUrl': 'URL d\'upload',
    'adminCloud.connection.status': 'Statut',
    'adminCloud.connection.enableAuto': 'Activer la synchronisation automatique',
    'adminCloud.connection.currentKey': 'Clé API actuelle : {{masked}}',
    'adminCloud.connection.noKey': '<aucune>',
    'adminCloud.connection.keyPlaceholder': 'Coller ici une nouvelle clé pour remplacer (rcsk_...)',
    'adminCloud.connection.keyHint': 'La clé est chiffrée (Fernet) en base. Laissez vide pour ne pas la modifier.',
    'adminCloud.save.btn': 'Enregistrer',
    'adminCloud.test.btn': 'Tester la connexion (whoami)',
    'adminCloud.test.lastTest': 'Dernier test : {{mark}} {{date}}',
    'adminCloud.logs.title': 'Journal des uploads',
    'adminCloud.logs.allStatuses': 'Tous statuts',
    'adminCloud.logs.filterOk': 'OK',
    'adminCloud.logs.filterKo': 'KO',
    'adminCloud.logs.filterSkipped': 'Skipped',
    'adminCloud.logs.allTypes': 'Tous types',
    'adminCloud.logs.typeTickets': 'Tickets',
    'adminCloud.logs.typeFactures': 'Factures',
    'adminCloud.logs.typeAcomptes': 'Acomptes',
    'adminCloud.logs.typeDevis': 'Devis',
    'adminCloud.logs.typeBonsCommande': 'Bons de commande',
    'adminCloud.logs.colDate': 'Date',
    'adminCloud.logs.colType': 'Type',
    'adminCloud.logs.colRef': 'Référence',
    'adminCloud.logs.colStatus': 'Statut',
    'adminCloud.logs.colFolder': 'Dossier',
    'adminCloud.logs.colError': 'Erreur',
    'adminCloud.logs.empty': 'Aucun upload pour l\'instant.',
    'size50x30': '50 x 30 mm (standard Bixolon)',
    'protocolZpl': 'ZPL (recommandé Bixolon récent)',
    'protocolBpl': 'BPL (ancien / série SLP)',
    'fieldClientName': 'Nom client',
    'fieldClientPhone': 'Téléphone client',
    'fieldDeviceLock': 'Code / verrou',
    'fieldModel': 'Modèle',
    'fieldParts': 'Pièces / panne',
    'fieldDate': 'Date',
    'fieldPrice': 'Prix',
    'fieldRef': 'Référence REM-XXX',
    'errLoad': 'Erreur chargement configuration',
    'saved': 'Configuration enregistrée.',
    'errSave': 'Erreur sauvegarde',
    'previewNeedRef': 'Saisir une référence REM-XXX pour la preview.',
    'errPreview': 'Erreur génération preview',
    'testQueued': 'Test envoyé dans la queue. L\'agent local le traitera dès qu\'il sera connecté.',
    'errTest': 'Erreur test imprimante',
    'confirmRotate': 'Régénérer le token va invalider l\'ancien. Continuer ?',
    'tokenGenerated': 'Nouveau token généré. Copiez-le et collez-le dans la config de l\'agent local.',
    'errRotate': 'Erreur régénération token',
    'tokenCopied': 'Token copié dans le presse-papiers.',
    'copyFailed': 'Copie impossible.',
    'errDownloadPack': 'Téléchargement impossible{{http}} : {{detail}}',
    'downloadLinkUnavailable': 'Lien de téléchargement indisponible',
    'downloadStartedHint': 'Téléchargement lancé. Si rien ne se passe, autorisez les téléchargements dans le navigateur.',
    'errDownloadApp': 'Téléchargement application impossible{{http}} : {{detail}}',
    'agentExeDownloaded': 'Agent Windows téléchargé avec succès.',
    'errDownloadAgent': 'Téléchargement agent impossible{{http}} : {{detail}}',
    'packDownloaded': 'Pack agent téléchargé avec succès.',
    'securityTitle': 'Sécurité imprimante réseau',
    'securityBody': 'Pensez à changer le mot de passe admin par défaut (admin/admin) et à désactiver TELNET et FTP via l\'interface web de l\'imprimante',
    'securityNoInternet': 'N\'exposez jamais le port 9100 sur Internet.',
    'downloadsTitle': 'Téléchargements & installateurs',
    'downloadsDesc': 'Accès direct aux ZIP Windows, à l\'agent imprimante et à la page de remplacement live.',
    'openInstallers': 'Ouvrir les installateurs',
    'loading': 'Chargement...',
    'bixolonSection': 'Bixolon - étiquettes QR',
    'fieldPrinterName': 'Nom imprimante',
    'fieldIp': 'Adresse IP',
    'fieldPortRaw': 'Port (RAW socket)',
    'fieldIpMethod': 'Méthode IP',
    'ipMethodManual': 'Manuel (IP fixe)',
    'ipMethodDhcp': 'DHCP',
    'fieldSubnet': 'Sous-réseau',
    'fieldGateway': 'Passerelle',
    'fieldDns': 'DNS',
    'fieldProtocol': 'Protocole d\'impression',
    'fieldDefaultLabelFormat': 'Format étiquette par défaut',
    'printerActive': 'Imprimante active',
    'testConnection': 'Tester la connexion',
    'lastTest': 'Dernier test : {{date}}',
    'epsonSection': 'Epson - tickets caisse',
    'epsonDesc': 'Ces valeurs servent aux tickets 80 mm. L\'agent Windows lit cette configuration puis envoie le ticket vers l\'imprimante Epson du magasin.',
    'fieldTicketIp': 'Adresse IP Epson',
    'fieldTicketPort': 'Port Epson',
    'fieldTicketProtocol': 'Protocole ticket',
    'ticketProtoEscpos': 'ESC/POS (Epson)',
    'ticketProtoZplFallback': 'ZPL (repli)',
    'agentSection': 'Agent local',
    'agentDesc': 'L\'agent local tourne sur un poste du LAN, reçoit les jobs via polling et envoie les étiquettes Bixolon ou les tickets Epson vers les imprimantes configurées. Le token API est utilisé pour s\'authentifier en tant qu\'agent.',
    'tokenCopyNow': 'Token (à copier maintenant - ne sera plus affiché) :',
    'agentTokenLabel': 'Token agent',
    'tokenCreated': '(créé)',
    'tokenNotGenerated': '(non généré)',
    'noToken': '— aucun token —',
    'hide': 'Masquer',
    'show': 'Afficher',
    'copy': 'Copier',
    'regenerateToken': 'Régénérer le token',
    'generateToken': 'Générer le token',
    'agentWinTitle': 'Agent local Windows',
    'agentWinDesc': 'Téléchargez l\'agent prêt à lancer, ou le pack zip si vous devez reconstruire l\'agent sur un poste Windows.',
    'directLinks': 'Liens directs',
    'dlDesktopApp': 'Application Windows staff',
    'dlAgentExe': 'Agent Windows (.exe)',
    'dlAgentPack': 'Pack agent (.zip)',
    'tempLinksNote': 'Liens temporaires signés automatiquement. Ils expirent au bout de quelques minutes.',
    'downloading': 'Téléchargement...',
    'dlAgentExeBtn': 'Télécharger l\'agent Windows (.exe)',
    'dlAgentPackBtn': 'Télécharger le pack agent (.zip)',
    'desktopAppDesc': 'Téléchargez l\'application bureau R.E.Mobiles déjà compilée. Elle lance le frontend local, le backend local et l\'agent d\'impression inclus.',
    'dlDesktopAppBtn': 'Télécharger l\'application Windows (.zip)',
    'printedFields': 'Champs imprimés',
    'fieldFontSize': 'Taille police (6-16)',
    'fieldMargin': 'Marge (0-24 pt)',
    'previewPdf': 'Preview PDF',
    'previewDesc': 'Générer une étiquette PDF de test pour une réparation existante.',
    'previewRefPlaceholder': 'Réf REM-XXX',
    'previewBtn': 'Preview',
    'save': 'Enregistrer',
    'reload': 'Recharger',
    'errUnknown': 'Erreur inconnue',
    'adminPertes.title': 'Pertes',
    'adminPertes.subtitle': 'Ventes hors stock encaissées sous le prix catalogue et remises au-delà du seuil autorisé, par vendeur.',
    'adminPertes.exportCsv': 'Exporter CSV',
    'adminPertes.recalcul': 'Recalculer sur l’historique',
    'adminPertes.typeHorsStock': 'Hors stock sous prix',
    'adminPertes.typeRemise': 'Remise excessive',
    'adminPertes.typeSousCatalogue': 'Prix sous catalogue',
    'adminPertes.preset30j': '30 j',
    'adminPertes.preset3m': '3 mois',
    'adminPertes.preset12m': '12 mois',
    'adminPertes.presetCustom': 'Personnalisé',
    'adminPertes.payCb': 'Carte bancaire',
    'adminPertes.payCash': 'Espèces',
    'adminPertes.payCheque': 'Chèque',
    'adminPertes.payVirement': 'Virement',
    'adminPertes.payMixte': 'Mixte',
    'adminPertes.payAvoir': 'Avoir',
    'adminPertes.payAcompte': 'Acompte',
    'adminPertes.periode': 'Période : {{debut}} → {{fin}}',
    'adminPertes.du': 'Du',
    'adminPertes.au': 'Au',
    'adminPertes.vendeur': 'Vendeur',
    'adminPertes.type': 'Type',
    'adminPertes.magasin': 'Magasin',
    'adminPertes.tous': 'Tous',
    'adminPertes.tileTotal': 'Perte totale',
    'adminPertes.calculeLe': 'Calculé le {{date}}',
    'adminPertes.remisesExcessives': 'Remises excessives',
    'adminPertes.auDelaDe': 'Au-delà de {{pct}}',
    'adminPertes.tileNb': 'Ventes concernées',
    'adminPertes.parVendeur': 'Par vendeur',
    'adminPertes.loading': 'Chargement…',
    'adminPertes.aucunePerte': 'Aucune perte sur la période.',
    'adminPertes.colTotal': 'Total',
    'adminPertes.colNbVentes': 'Nb ventes',
    'adminPertes.filtrerVendeur': 'Filtrer le détail sur ce vendeur',
    'adminPertes.detailTitle': 'Détail des ventes',
    'adminPertes.pageRange': '{{from}}–{{to}} sur {{total}}',
    'adminPertes.pageN': 'Page {{page}}',
    'adminPertes.aucuneLigne': 'Aucune ligne pour ces filtres.',
    'adminPertes.colDate': 'Date',
    'adminPertes.colTicket': 'Ticket',
    'adminPertes.colArticle': 'Article',
    'adminPertes.colQte': 'Qté',
    'adminPertes.colPrixVendu': 'Prix vendu',
    'adminPertes.colPrixRef': 'Prix réf.',
    'adminPertes.colRemise': 'Remise',
    'adminPertes.colPerte': 'Perte',
    'adminPertes.trierPerte': 'Trier par perte',
    'adminPertes.colStatut': 'Statut',
    'adminPertes.colActions': 'Actions',
    'adminPertes.ticket': 'Ticket',
    'adminPertes.ouvrirTicket': 'Ouvrir le ticket de caisse (PDF) dans un nouvel onglet',
    'adminPertes.voirVente': 'Voir la vente',
    'adminPertes.masquerVente': 'Masquer le contenu de la vente',
    'adminPertes.voirVenteTitle': 'Voir ce qui a été vendu sur ce ticket',
    'adminPertes.venteLabel': 'Vente',
    'adminPertes.paiement': 'Paiement :',
    'adminPertes.contenuIndispo': 'Contenu de la vente indisponible pour ce ticket (ouvrez le ticket PDF).',
    'adminPertes.ligneEnPerte': '(ligne en perte)',
    'adminPertes.totalVente': 'Total vente :',
    'adminPertes.precedent': 'Précédent',
    'adminPertes.suivant': 'Suivant',
    'adminPertes.lignesParPage': '{{count}} lignes par page',
    'adminPertes.legendeTitle': 'Comment sont calculées les pertes',
    'adminPertes.legendeHorsStockText': 'Vente « hors stock » encaissée sous le prix catalogue alors que l’article existait en base au moment de la vente. Perte =',
    'adminPertes.legendeHorsStockFormula': '(prix de référence − prix vendu) × quantité',
    'adminPertes.legendeRemiseText': 'Remise supérieure à {{seuil}} sur une ligne de vente. Seule la part au-delà de {{seuil}} est comptée :',
    'adminPertes.legendeRemiseFormula': '(remise − {{seuil}}) × prix de référence × quantité',
    'adminPertes.legendeSousCatalogue': 'Article en stock vendu sous le prix catalogue sans remise déclarée : même formule que « hors stock sous prix ».',
    'adminPertes.legendeFooter': 'Le prix de référence est le prix catalogue de l’article à la date de la vente. « Recalculer sur l’historique » relit toutes les ventes passées ; l’affichage courant est mis en cache et rafraîchi automatiquement.',
    'adminPertes.confirmRecalcul': 'Recalculer les pertes sur tout l’historique des ventes ? Cette opération relit toutes les ventes passées et peut prendre quelques instants.',
    'adminPertes.recalculDone': 'Recalcul terminé — {{count}} vente(s) analysée(s)',
    'adminPertes.recalculDoneGeneric': 'Recalcul terminé sur tout l’historique',
    'adminPertes.recalculFail': 'Échec du recalcul',
    'adminPertes.exportDone': 'Export CSV téléchargé',
    'adminPertes.exportUnavailable': 'Export indisponible (backend à mettre à jour)',
    'adminPertes.exportFail': 'Échec de l’export',
    'adminPertes.refManquante': 'Référence de vente manquante : ticket introuvable',
    'adminPertes.ticketFail': 'Impossible d’ouvrir le ticket',
    'adminPertes.endpointIndispo': 'Endpoint « Pertes » indisponible (backend à mettre à jour).',
    'adminPertes.errLoad': 'Erreur de chargement',
    'adminPertes.ticketTooltipRef': 'Ticket {{ref}}',
    'adminPertes.lignes_one': '{{count}} ligne',
    'adminPertes.lignes_other': '{{count}} lignes',
    'adminPertes.articles_one': '{{count}} article',
    'adminPertes.articles_other': '{{count}} articles',
    'adminPertes.autres_one': '(+{{count}} autre)',
    'adminPertes.autres_other': '(+{{count}} autres)',
    'adminTodo.cat.ventesHorsStock': 'Ventes hors stock à confirmer',
    'adminTodo.cat.cadbotPrix': 'Prix CADBOT à valider',
    'adminTodo.cat.devisChat': 'Devis du chat à traiter',
    'adminTodo.cat.acomptesACommander': 'Acomptes → pièces à commander',
    'adminTodo.cat.commandesSansSuivi': 'Commandes sans numéro de suivi',
    'adminTodo.cat.sumupAConfirmer': 'Paiements SumUp à confirmer',
    'adminTodo.cat.factureRequests': 'Demandes de facture',
    'adminTodo.groupFallback': 'Groupe',
    'adminTodo.time.now': 'à l\'instant',
    'adminTodo.time.minutesAgo': 'il y a {{n}} min',
    'adminTodo.time.hoursAgo': 'il y a {{n}} h',
    'adminTodo.error.endpointUnavailable': 'Endpoint « À faire » indisponible (backend à mettre à jour).',
    'adminTodo.error.load': 'Erreur de chargement',
    'adminTodo.settings.unavailable': 'Réglages indisponibles (backend à mettre à jour).',
    'adminTodo.settings.notLoaded': 'Réglages non chargés',
    'adminTodo.settings.saved': 'Réglages enregistrés',
    'adminTodo.settings.saveError': 'Impossible d\'enregistrer les réglages',
    'adminTodo.title': 'À faire',
    'adminTodo.subtitleUpdated': 'Mis à jour à {{time}} · actualisation automatique toutes les 60 s',
    'adminTodo.subtitleDefault': 'Tout ce qui attend une action, au même endroit.',
    'adminTodo.notifications': 'Notifications',
    'adminTodo.refresh': 'Actualiser',
    'adminTodo.settings.saving': 'Enregistrement…',
    'adminTodo.settings.loading': 'Chargement des réglages…',
    'adminTodo.settings.pushLabel': 'Notification push sur le téléphone',
    'adminTodo.settings.pushHint': 'Une alerte dès qu\'une nouvelle action apparaît.',
    'adminTodo.settings.digestLabel': 'Récapitulatif quotidien à 9 h',
    'adminTodo.settings.digestHint': 'Un seul message chaque matin avec tout ce qui reste à faire.',
    'adminTodo.settings.categoriesTracked': 'Catégories suivies',
    'adminTodo.allClear': 'Rien en attente. Tout est à jour.',
    'adminTodo.groupNothingPending': 'Rien en attente',
    'adminTodo.open': 'Ouvrir',
    'adminTodo.seeAll': 'Voir les {{count}} éléments',
    'adminTodo.openPage': 'Ouvrir la page',
    'adminTodo.pushOn': 'Push activé',
    'adminTodo.pushOff': 'Push désactivé',
    'adminTodo.digestOn': 'Récap 9 h activé',
    'adminTodo.digestOff': 'Récap 9 h désactivé',
    'adminUsers.role.super_admin.label': 'Super-admin',
    'adminUsers.role.super_admin.desc': 'Accès complet à tout le système (carlos uniquement)',
    'adminUsers.role.admin_magasin.label': 'Admin magasin',
    'adminUsers.role.admin_magasin.desc': 'Gère un ou plusieurs magasins assignés',
    'adminUsers.role.technicien.label': 'Technicien SAV',
    'adminUsers.role.technicien.desc': 'Tickets SAV des 2 magasins. Pas de POS, pas de compta.',
    'adminUsers.role.vendeur.label': 'Vendeur',
    'adminUsers.role.vendeur.desc': 'POS sur tous magasins. Pas de compta, pas d\'admin.',
    'adminUsers.roleUnknown': 'inconnu',
    'adminUsers.modal.editTitle': 'Éditer {{username}}',
    'adminUsers.createUser': 'Créer un utilisateur',
    'adminUsers.field.username': 'Nom d\'utilisateur',
    'adminUsers.field.passwordEdit': 'Nouveau mot de passe (laisser vide pour conserver)',
    'adminUsers.field.passwordCreate': 'Mot de passe * (min. {{min}} car.)',
    'adminUsers.field.email': 'E-mail',
    'adminUsers.field.telephone': 'Téléphone',
    'adminUsers.field.role': 'Rôle magasin',
    'adminUsers.field.assignedMagasins': 'Magasins assignés',
    'adminUsers.modal.minOneRequired': '(min. 1 requis)',
    'adminUsers.modal.ignoredForRole': '— Stocké mais ignoré pour ce rôle (scope = tous magasins)',
    'adminUsers.modal.loadingMagasins': 'Chargement des magasins…',
    'adminUsers.modal.posOnlyTitle': 'Absent / suspension — POS uniquement',
    'adminUsers.modal.posOnlyDesc': 'Peut se connecter et encaisser au POS, sans accès aux autres pages (réparations, stock, clients, admin…).',
    'adminUsers.action.cancel': 'Annuler',
    'adminUsers.action.save': 'Enregistrer',
    'adminUsers.action.create': 'Créer',
    'adminUsers.denied.title': 'Accès refusé',
    'adminUsers.denied.desc': 'Cette page est réservée au super-administrateur.',
    'adminUsers.denied.back': 'Retour au tableau de bord',
    'adminUsers.error.load': 'Erreur de chargement',
    'adminUsers.error.passwordMin': 'Le mot de passe doit contenir au minimum {{min}} caractères.',
    'adminUsers.feedback.updated': 'Utilisateur {{username}} mis à jour.',
    'adminUsers.feedback.created': 'Utilisateur {{username}} créé.',
    'adminUsers.error.operation': 'Erreur lors de l\'opération',
    'adminUsers.error.needsMagasinPick': 'Choisissez d\'abord un magasin de session (fenêtre au centre de l\'écran), puis créez l\'utilisateur.',
    'adminUsers.feedback.disabled': '{{username}} désactivé.',
    'adminUsers.feedback.enabled': '{{username}} réactivé.',
    'adminUsers.error.generic': 'Erreur',
    'adminUsers.action.back': 'Retour',
    'adminUsers.title': 'Utilisateurs internes',
    'adminUsers.subtitle': 'Création / modification / désactivation (super-admin uniquement)',
    'adminUsers.limitInfo': '{{current}}/{{max}} utilisateurs · Plan {{plan}}',
    'adminUsers.limitReachedTitle': 'Limite atteinte ({{max}} utilisateurs max)',
    'adminUsers.limitReached': 'Limite atteinte ({{max}})',
    'adminUsers.includeDisabled': 'Inclure les utilisateurs désactivés',
    'adminUsers.col.role': 'Rôle',
    'adminUsers.col.emailTel': 'E-mail / Tél.',
    'adminUsers.col.status': 'Statut',
    'adminUsers.col.actions': 'Actions',
    'adminUsers.empty': 'Aucun utilisateur.',
    'adminUsers.allMagasins': 'tous',
    'adminUsers.status.active': 'Actif',
    'adminUsers.status.disabled': 'Désactivé',
    'adminUsers.status.posOnly': 'Absent · POS seul',
    'adminUsers.action.edit': 'Éditer',
    'adminUsers.commissions': 'Commissions',
    'adminUsers.action.disable': 'Désactiver',
    'adminUsers.action.enable': 'Réactiver',
    'adminHorsStock.stockUnknown': 'stock inconnu',
    'adminHorsStock.stockCount': 'stock {{count}}',
    'adminHorsStock.selected': 'Sélectionné',
    'adminHorsStock.lineDefaultDesignation': 'Article',
    'adminHorsStock.loadError': 'Erreur de chargement',
    'adminHorsStock.lineStillUnresolved': 'Une ligne est encore « À vérifier » ou sans référence rattachée.',
    'adminHorsStock.saleValidatedWithLoss': 'Vente {{ref}} validée — {{total}} dans l’historique. Perte enregistrée : {{loss}}.',
    'adminHorsStock.saleValidatedNoLoss': 'Vente {{ref}} validée — {{total}} dans l’historique, aucune perte.',
    'adminHorsStock.validationFailed': 'Validation impossible',
    'adminHorsStock.catalogBadge': 'Catalogue',
    'adminHorsStock.cashedLineInfo': 'encaissé {{qty}} × {{price}}',
    'adminHorsStock.horsStockBadge': 'Hors stock',
    'adminHorsStock.articleExistedQuestion': 'L’article existait ?',
    'adminHorsStock.optionLoss': 'Perte — l’article existait, rattacher la référence',
    'adminHorsStock.optionNonExistent': 'Article inexistant — accepter tel quel',
    'adminHorsStock.optionToVerify': 'À vérifier',
    'adminHorsStock.attachedArticle': 'Article rattaché',
    'adminHorsStock.refLabel': 'Réf. {{ref}}',
    'adminHorsStock.catalogPriceLabel': 'Prix catalogue',
    'adminHorsStock.unknown': 'inconnu',
    'adminHorsStock.soldLabel': 'vendu',
    'adminHorsStock.estimatedLoss': 'Perte estimée',
    'adminHorsStock.selectCatalogRef': 'Sélectionnez la référence du catalogue correspondant à cet article.',
    'adminHorsStock.catalogSuggestions': 'Suggestions du catalogue',
    'adminHorsStock.noSuggestion': 'Aucune suggestion pour cette ligne — utilisez la recherche ci-dessous.',
    'adminHorsStock.otherCatalogArticle': 'Autre article du catalogue',
    'adminHorsStock.searchPlaceholder': 'Rechercher référence / désignation / EAN…',
    'adminHorsStock.noArticleFound': 'Aucun article trouvé.',
    'adminHorsStock.freeArticleInfo': 'Article libre : la ligne est conservée telle quelle, sans rattachement ni mouvement de stock.',
    'adminHorsStock.toVerifyInfo': 'Bloque la validation tant que la ligne n’est pas tranchée (Oui / Non).',
    'adminHorsStock.toValidateBadge': 'À valider',
    'adminHorsStock.cashedBadge': 'Encaissée',
    'adminHorsStock.cashedAmountLabel': 'Encaissé',
    'adminHorsStock.subtotal': 'Sous-total',
    'adminHorsStock.discountLabel': 'Remise',
    'adminHorsStock.historyTotal': 'Total historique',
    'adminHorsStock.amountLockedInfo': 'Montant réellement encaissé : prix, quantités et remise ne sont pas modifiables ici.',
    'adminHorsStock.lossesPreview': 'Aperçu des pertes (visible uniquement par la direction)',
    'adminHorsStock.remiseExcessiveLabel': 'Remise au-delà de {{seuil}} % ({{pct}} accordés)',
    'adminHorsStock.lossRecorded': 'Perte constatée',
    'adminHorsStock.lossSavedInfo': 'Enregistrée dans la page Pertes lors de la validation.',
    'adminHorsStock.noLossYet': 'Aucune perte constatée à ce stade',
    'adminHorsStock.noLossYetSuffix': ' — le calcul se complète une fois les références rattachées.',
    'adminHorsStock.noteLabel': 'Note (optionnel)',
    'adminHorsStock.notePlaceholder': 'Ex. prix négocié, article reçu le…',
    'adminHorsStock.validateButton': 'Valider et écrire dans l’historique',
    'adminHorsStock.blockedTitle': 'Une ou plusieurs lignes hors stock sont encore à trancher',
    'adminHorsStock.validationBlocked': 'Validation bloquée :',
    'adminHorsStock.blockedVerifierCount': '{{n}} ligne(s) « À vérifier »',
    'adminHorsStock.blockedNoRefCount': '{{n}} ligne(s) « Oui » sans référence rattachée',
    'adminHorsStock.legendTitle': 'Ce qui se passe',
    'adminHorsStock.legendIntro': 'La vente est déjà encaissée : elle n’est pas annulable et le stock n’est pas modifié. La validation rattache le bon article, enregistre l’écart de prix ou la remise excessive dans les pertes, puis écrit la vente dans l’historique.',
    'adminHorsStock.legendYesWord': 'Oui',
    'adminHorsStock.legendYesDesc': '— l’article existait : sélectionnez la référence du catalogue (suggestions ou recherche).',
    'adminHorsStock.legendNonWord': 'Non',
    'adminHorsStock.legendNonDesc': '— article libre, conservé tel quel.',
    'adminHorsStock.legendVerifierDesc': '— bloque la validation tant que la ligne n’est pas tranchée.',
    'adminHorsStock.legendPertesWord': 'Pertes',
    'adminHorsStock.legendPertesDesc': '— écart entre prix catalogue et prix vendu, plus la part de remise au-delà de {{seuil}} % du sous-total ; visible uniquement ici et enregistré dans la page Pertes.',
    'adminHorsStock.pageTitle': 'Ventes hors-stock à valider',
    'adminHorsStock.pageSubtitle': 'Déjà encaissées ; absentes de l’historique jusqu’à validation par la direction.',
    'adminHorsStock.refresh': 'Actualiser',
    'adminHorsStock.emptyState': 'Aucune vente hors-stock en attente de validation.',
    'adminHorsStock.processedThisSession': 'Traitées dans cette session',
    'adminHorsStock.lossShortLabel': 'perte',
    'adminHorsStock.validatedBadge': 'Validée',
    'stockPhotoAi.title': 'Photos stock · IA',
    'stockPhotoAi.subtitle': 'Super-admin Carlos · génération OpenAI · magasin isolé M1/M2',
    'stockPhotoAi.apiKeysLink': 'Clés API OpenAI',
    'stockPhotoAi.statsTotal': 'Articles {{mag}}',
    'stockPhotoAi.statsWithPhoto': 'Avec photo',
    'stockPhotoAi.statsMissing': 'Sans photo',
    'stockPhotoAi.searchPlaceholder': 'Rechercher réf ou désignation…',
    'stockPhotoAi.filter': 'Filtrer',
    'stockPhotoAi.generateBatch': 'Générer batch (max 10)',
    'stockPhotoAi.batchResult': 'Batch {{mag}} : {{ok}} OK · {{skipped}} ignorés · {{errors}} erreurs',
    'stockPhotoAi.loading': 'Chargement…',
    'stockPhotoAi.stockLabel': 'Stock {{qty}}',
    'stockPhotoAi.generateOne': 'Générer IA',
    'stockPhotoAi.empty': 'Aucun article sans photo pour {{mag}}',
    'stockPhotoAi.errorLoad': 'Chargement impossible',
    'stockPhotoAi.errorGenerate': 'Génération échouée',
    'stockPhotoAi.errorBatch': 'Batch échoué',
    'stockPhotoAi.confirmBatch': 'Générer jusqu\'à {{max}} images IA pour {{mag}} ? (OpenAI · coût API)',
    'stockCatAudit.title': 'Audit catégories stock',
    'stockCatAudit.subtitle': 'Analyse complète téléphone vs pièce/accessoire · réservé Carlos',
    'stockCatAudit.backToIntegrations': 'Intégrations admin',
    'stockCatAudit.magasin': 'Magasin',
    'stockCatAudit.allStores': 'Tous',
    'stockCatAudit.issuesOnly': 'Lignes avec problèmes seulement',
    'stockCatAudit.runAnalysis': 'Lancer l\'analyse',
    'stockCatAudit.statTotal': 'Total',
    'stockCatAudit.statWithIssues': 'Avec souci',
    'stockCatAudit.statFalseImei': 'Faux IMEI',
    'stockCatAudit.statNeedsImei': 'IMEI requis',
    'stockCatAudit.statCategorieMismatch': 'Cat. différente',
    'stockCatAudit.statCategorieMissing': 'Cat. vide',
    'stockCatAudit.statAmbiguous': 'Ambigu',
    'stockCatAudit.currentCategories': 'Catégories actuelles',
    'stockCatAudit.suggestedCategories': 'Catégories suggérées',
    'stockCatAudit.searchPlaceholder': 'Réf, désignation, catégorie…',
    'stockCatAudit.allFilters': 'Tous les filtres',
    'stockCatAudit.applySuggested': 'Appliquer cat. suggérée ({{count}})',
    'stockCatAudit.colRef': 'Réf',
    'stockCatAudit.colDesignation': 'Désignation',
    'stockCatAudit.colMag': 'Mag',
    'stockCatAudit.colCurrentCat': 'Cat. actuelle',
    'stockCatAudit.colSuggestedCat': 'Cat. suggérée',
    'stockCatAudit.colType': 'Type',
    'stockCatAudit.colIssues': 'Problèmes',
    'stockCatAudit.typePhone': 'Tél',
    'stockCatAudit.typePiece': 'Pièce',
    'stockCatAudit.analyzing': 'Analyse en cours…',
    'stockCatAudit.emptyRows': 'Aucune ligne — lancez l\'analyse ou élargissez les filtres.',
    'stockCatAudit.hint': 'Ex. « Support téléphone » est désormais classé Accessoire (pas d\'IMEI). Les vrais téléphones complets restent soumis à l\'IMEI à l\'inventaire.',
    'stockCatAudit.errorAnalyze': 'Analyse impossible',
    'stockCatAudit.errorApply': 'Application échouée',
    'stockCatAudit.confirmApply': 'Appliquer la catégorie suggérée sur {{count}} article(s) ?',
    'stockCatAudit.issueFalsePhoneImei': 'Faux téléphone (IMEI à tort)',
    'stockCatAudit.issueNeedsImei': 'Téléphone — IMEI requis',
    'stockCatAudit.issueCategorieMismatch': 'Catégorie différente',
    'stockCatAudit.issueCategorieMissing': 'Catégorie manquante',
    'stockCatAudit.issueAmbiguous': 'Ambigu',
    'stockHist.periodToday': 'Aujourd\'hui',
    'stockHist.periodYesterday': 'Hier',
    'stockHist.periodWeek': 'Cette semaine',
    'stockHist.periodMonth': 'Ce mois',
    'stockHist.title': 'Historique stock',
    'stockHist.subtitle': 'Mouvements boutique et dépôt',
    'stockHist.statMovements': 'Mouvements',
    'stockHist.statPieces': 'Pièces',
    'stockHist.locationShop': 'Boutique',
    'stockHist.locationWarehouse': 'Dépôt',
    'stockHist.empty': 'Aucun ajout pour cette période',
    'stockHist.colDateTime': 'Date / Heure',
    'stockHist.colDesignation': 'Désignation',
    'stockHist.colStore': 'Mag.',
    'stockHist.colLocation': 'Lieu',
    'stockHist.colQty': 'Qte',
    'stockHist.colSalePrice': 'P. Vente',
    'stockHist.colBy': 'Par',
    'stockHist.statusNew': 'Nouveau',
    'stockHist.statusRestock': 'Ajout',
    'stockHist.selectedOne': 'sélectionné',
    'stockHist.selectedMany': 'sélectionnés',
    'stockHist.labelOne': 'étiquette',
    'stockHist.labelMany': 'étiquettes',
    'stockHist.printCount': 'Imprimer ({{count}})',
    'partsOrders.statusPending': 'En attente',
    'partsOrders.statusPartial': 'Partielle',
    'partsOrders.statusReceived': 'Reçue',
    'partsOrders.statusCancelled': 'Annulée',
    'partsOrders.filterAll': 'Toutes',
    'partsOrders.filterReceived': 'Reçues',
    'partsOrders.filterCancelled': 'Annulées',
    'partsOrders.partTypeStandard': 'Standard',
    'partsOrders.partTypeSpare': 'Pièce détachée',
    'partsOrders.partTypeSerialized': 'Sérialisé (n° série/IMEI)',
    'partsOrders.createTitle': 'Nouvelle commande fournisseur',
    'partsOrders.supplier': 'Fournisseur',
    'partsOrders.supplierPlaceholder': 'Nom du fournisseur',
    'partsOrders.line': 'Ligne {{num}}',
    'partsOrders.designationPlaceholder': 'Désignation *',
    'partsOrders.referencePlaceholder': 'Référence (optionnel)',
    'partsOrders.type': 'Type',
    'partsOrders.qty': 'Qté',
    'partsOrders.purchasePriceUnit': 'Prix achat U.',
    'partsOrders.expectedSalePrice': 'Prix vente prévu',
    'partsOrders.category': 'Catégorie',
    'partsOrders.categoryPlaceholder': 'Ex : Écran, Batterie',
    'partsOrders.location': 'Emplacement',
    'partsOrders.locationShop': 'Boutique',
    'partsOrders.locationWarehouse': 'Dépôt',
    'partsOrders.addLine': 'Ajouter une ligne',
    'partsOrders.notes': 'Notes',
    'partsOrders.errorNeedLine': 'Ajoutez au moins une ligne avec une désignation.',
    'partsOrders.errorCreate': 'Erreur lors de la création.',
    'partsOrders.cancel': 'Annuler',
    'partsOrders.creating': 'Création…',
    'partsOrders.create': 'Créer la commande',
    'partsOrders.receiveTitle': 'Réception — {{ref}}',
    'partsOrders.allReceived': 'Toutes les lignes ont déjà été reçues.',
    'partsOrders.remaining': 'Reste {{count}}',
    'partsOrders.receivedQty': 'Qté reçue',
    'partsOrders.serialsLabel': 'N° série / IMEI (un par ligne ou séparés par virgule)',
    'partsOrders.errorNeedQty': 'Indiquez au moins une quantité reçue.',
    'partsOrders.errorReceive': 'Erreur lors de la réception.',
    'partsOrders.close': 'Fermer',
    'partsOrders.validating': 'Validation…',
    'partsOrders.validateReceive': 'Valider la réception',
    'partsOrders.linkTitle': 'Affecter à une réparation',
    'partsOrders.linkDescription': 'La pièce « {{designation}} » sera intégrée au prix de la réparation sans être décomptée du stock (pas encore reçue).',
    'partsOrders.linkRefPlaceholder': 'Réf réparation (ex : REP-000123)',
    'partsOrders.errorNeedRef': 'Saisissez la référence réparation.',
    'partsOrders.errorRepairNotFound': 'Erreur : réparation introuvable ?',
    'partsOrders.assign': 'Affecter',
    'partsOrders.confirmCancel': 'Annuler cette commande ? Les pièces liées aux réparations seront détachées.',
    'partsOrders.errorCancel': 'Erreur annulation.',
    'partsOrders.errorGeneric': 'Erreur.',
    'partsOrders.supplierUnknown': 'Fournisseur ?',
    'partsOrders.linesCount': '{{count}} ligne(s)',
    'partsOrders.receivedCount': '{{received}}/{{total}} reçu',
    'partsOrders.purchaseCost': 'coût achat',
    'partsOrders.colDesignation': 'Désignation',
    'partsOrders.colReceivedQty': 'Reçu/Qté',
    'partsOrders.colPurchaseUnit': 'Achat U.',
    'partsOrders.colSalePlanned': 'Vente prévu',
    'partsOrders.colRepair': 'Réparation',
    'partsOrders.colAction': 'Action',
    'partsOrders.typeSerialized': 'Sérialisé',
    'partsOrders.typeSpareShort': 'Pièce',
    'partsOrders.typeStandardShort': 'Std',
    'partsOrders.detach': 'Détacher',
    'partsOrders.receive': 'Réceptionner',
    'partsOrders.pageTitle': 'Commandes de pièces',
    'partsOrders.pageSubtitle': 'Approvisionnement fournisseur — pré-affectation réparation & réception',
    'partsOrders.filterAllStores': 'Tous',
    'partsOrders.refresh': 'Actualiser',
    'partsOrders.newOrder': 'Nouvelle commande',
    'partsOrders.kpiOpenOrders': 'Commandes ouvertes',
    'partsOrders.kpiAssignedParts': 'Pièces affectées répa.',
    'partsOrders.kpiCostToReceive': 'Coût à recevoir',
    'partsOrders.loading': 'Chargement…',
    'partsOrders.empty': 'Aucune commande de pièces.',
    'stockForm.editTitle': 'Modifier article',
    'stockForm.addTitle': 'Ajouter article',
    'stockForm.productSheet': 'Fiche produit',
    'stockForm.newStockProduct': 'Nouveau produit stock',
    'stockForm.analyzePhoto': 'Analyser photo',
    'stockForm.scan': 'Scanner',
    'stockForm.supplierSearch': 'Recherche fournisseur',
    'stockForm.supplierSearchPlaceholder': 'Référence, EAN ou nom de pièce…',
    'stockForm.refShort': 'Réf. :',
    'stockForm.priceLabel': 'Prix :',
    'stockForm.sectionArticle': 'Section article',
    'stockForm.reference': 'Référence',
    'stockForm.ean': 'EAN',
    'stockForm.eanPlaceholder': 'Code-barres',
    'stockForm.category': 'Catégorie',
    'stockForm.categoryPlaceholder': 'Écrans, batteries…',
    'stockForm.designation': 'Désignation',
    'stockForm.supplier': 'Fournisseur',
    'stockForm.sectionStock': 'Section stock',
    'stockForm.location': 'Emplacement',
    'stockForm.shop': 'Boutique',
    'stockForm.depot': 'Dépôt',
    'stockForm.both': 'Les deux',
    'stockForm.qtyShop': 'Qté boutique',
    'stockForm.qtyDepot': 'Qté dépôt',
    'stockForm.alertThreshold': 'Seuil alerte',
    'stockForm.sectionPricing': 'Section tarifs',
    'stockForm.purchasePrice': 'Prix d\'achat (HT)',
    'stockForm.salePrice': 'Prix de vente (€)',
    'stockForm.margin': 'Marge',
    'stockForm.sectionShop': 'Section boutique',
    'stockForm.visibleOnline': 'Visible en boutique en ligne',
    'stockForm.visibleOnlineHint': 'Les clients pourront acheter cet article',
    'stockForm.cancel': 'Annuler',
    'stockForm.saving': 'Enregistrement…',
    'stockForm.edit': 'Modifier',
    'stockForm.addToStock': 'Ajouter au stock',
    'stockForm.save': 'Enregistrer',
    'stockForm.reviewTitle': 'Vérification article',
    'stockForm.newArticle': 'Nouvel article',
    'stockForm.existingBanner': 'Existant — {{designation}} (B:{{qb}} D:{{qd}}). Quantité ajoutée au stock.',
    'stockForm.imeiRequired': 'IMEI obligatoire pour enregistrer un téléphone en stock.',
    'stockForm.imeiInvalid': 'IMEI invalide (14 à 20 chiffres).',
    'stockForm.articleNotFound': 'Article non trouvé',
    'stockForm.imeiNotRegistered': 'IMEI non enregistré — vérifiez le numéro ou Stock avancé > IMEI.',
    'stockForm.imeiFirstRegistered': 'Premier IMEI enregistré. {{count}} appareil(s) restant(s) — complétez les IMEI dans Stock avancé > onglet IMEI (réf. {{ref}}).',
    'stockForm.saveError': 'Erreur lors de l\'enregistrement',
    'clientChat.typeBoutiqueOrder': 'Commande boutique',
    'clientChat.typeRepair': 'Réparation',
    'clientChat.typeClient': 'Discussion client',
    'clientChat.title': 'Chat Clients',
    'clientChat.convCount': '{{count}} conversation',
    'clientChat.convCountPlural': '{{count}} conversations',
    'clientChat.searchPlaceholder': 'Rechercher un client...',
    'clientChat.noConversations': 'Aucune conversation client',
    'clientChat.clientFallback': 'Client',
    'clientChat.startConversation': 'Démarrez la conversation',
    'clientChat.writePlaceholder': 'Écrire au client...',
    'clientChat.selectConversation': 'Sélectionnez une conversation',
    'stockInvImport.errorAiAnalysis': 'Erreur analyse IA — vérifiez Admin > Intégrations API (OpenAI)',
    'stockInvImport.confirmMissingImei': '{{count}} ligne(s) téléphone sans IMEI complet.\n\nContinuer l\'import ? Vous pourrez compléter dans Stock avancé > IMEI.',
    'stockInvImport.errorImport': 'Erreur import',
    'stockInvImport.locationDepot': 'Dépôt',
    'stockInvImport.locationBoutique': 'Boutique',
    'stockInvImport.pageTitle': 'Import facture IA',
    'stockInvImport.pageSubtitle': 'Analyse PDF · calculs alignés /calcul',
    'stockInvImport.visionHint': 'OpenAI Vision · arrondi prix identique au module Calcul marge',
    'stockInvImport.invoiceLabel': 'Facture (PDF ou image)',
    'stockInvImport.fileSize': '{{size}} Ko',
    'stockInvImport.clickToChoose': 'Cliquez pour choisir un fichier',
    'stockInvImport.shippingTotalLabel': 'Frais de port total (EUR)',
    'stockInvImport.autoIfEmpty': '— auto si vide',
    'stockInvImport.shippingPlaceholder': 'Ex: 29.90',
    'stockInvImport.customsPct': 'Douane %',
    'stockInvImport.marginPct': 'Marge %',
    'stockInvImport.analyzing': 'Analyse en cours… (15–30 s)',
    'stockInvImport.analyzeInvoice': 'Analyser la facture',
    'stockInvImport.kpiProducts': 'Produits',
    'stockInvImport.kpiSupplier': 'Fournisseur',
    'stockInvImport.kpiShippingTotal': 'Port total',
    'stockInvImport.kpiShippingPerUnit': 'Port / unité',
    'stockInvImport.recalc': 'Recalcul…',
    'stockInvImport.phonesCompleteImei': '{{count}} téléphone(s) — complétez l\'IMEI ci-dessous (extrait auto de la facture si présent).',
    'stockInvImport.colRef': 'Ref',
    'stockInvImport.colDesignation': 'Désignation',
    'stockInvImport.colQty': 'Qté',
    'stockInvImport.colPurchase': 'Achat',
    'stockInvImport.colPlusShipping': '+Port',
    'stockInvImport.colPlusCustoms': '+{{pct}}% Douane',
    'stockInvImport.colPlusMargin': '+{{pct}}% Marge',
    'stockInvImport.colLabor': 'M.O.',
    'stockInvImport.colFinalPrice': 'Prix Final',
    'stockInvImport.remove': 'Retirer',
    'stockInvImport.generateEan': 'Générer EAN',
    'stockInvImport.imeiDevicePlaceholder': 'IMEI appareil {{n}}',
    'stockInvImport.back': 'Retour',
    'stockInvImport.importing': 'Import…',
    'stockInvImport.confirm': 'Confirmer',
    'stockInvImport.importDone': 'Import terminé',
    'stockInvImport.created': 'Créés',
    'stockInvImport.updated': 'Mis à jour',
    'stockInvImport.imeiRegistered': 'IMEI enregistrés',
    'stockInvImport.errors': 'Erreurs',
    'stockInvImport.imeiMissingTitle': 'IMEI manquants — compléter dans Stock avancé',
    'stockInvImport.missingOfTotal': '{{missing}} manquant(s) / {{total}}',
    'stockInvImport.newImport': 'Nouvel import',
    'stockInvImport.backToStock': 'Retour au stock',
    'clientPwd.pinGenerated': 'PIN généré pour {{nom}} : {{pin}}',
    'clientPwd.error': 'Erreur',
    'clientPwd.errorSendEmail': 'Erreur envoi email',
    'clientPwd.errorSendBulk': 'Erreur envoi masse',
    'clientPwd.bulkResult': '{{sent}} emails envoyés, {{errors}} erreurs',
    'clientPwd.totalClients': '{{total}} clients au total',
    'clientPwd.sending': 'Envoi...',
    'clientPwd.sendToClients': 'Envoyer à {{count}} clients',
    'clientPwd.searchPlaceholder': 'Rechercher par nom, tel, email...',
    'clientPwd.filterAll': 'Tous',
    'clientPwd.filterSent': 'MDP envoyé',
    'clientPwd.filterNotSent': 'MDP non envoyé',
    'clientPwd.colName': 'Nom',
    'clientPwd.colPhone': 'Téléphone',
    'clientPwd.colEmail': 'Email',
    'clientPwd.colPin': 'PIN',
    'clientPwd.colStatus': 'Statut',
    'clientPwd.colActions': 'Actions',
    'clientPwd.loading': 'Chargement...',
    'clientPwd.noEmail': 'Pas d\'email',
    'clientPwd.statusSent': 'Envoyé',
    'clientPwd.statusPending': 'En attente',
    'clientPwd.statusNotGenerated': 'Non généré',
    'clientPwd.genPinTitle': 'Générer PIN',
    'clientPwd.resend': 'Renvoyer',
    'clientPwd.pageOf': 'Page {{page}} / {{total}}',
    'stockInv.error.pickMagasin': 'Choisissez d\'abord un magasin pour cet inventaire.',
    'stockInv.error.analyzeFailed': 'Analyse impossible — vérifiez la clé OpenAI ou réessayez.',
    'stockInv.error.server': 'Erreur serveur',
    'stockInv.dropdown.refLabel': 'Réf. :',
    'stockInv.short.boutique': 'B',
    'stockInv.short.depot': 'D',
    'stockInv.summary.title': 'Récapitulatif inventaire',
    'stockInv.summary.subtitle': '{{count}} article(s) enregistré(s)',
    'stockInv.summary.statusNew': 'Nouveau',
    'stockInv.summary.statusUpdated': 'Mis à jour',
    'stockInv.summary.errorsTitle': 'Erreurs',
    'stockInv.summary.created': '{{count}} créé(s)',
    'stockInv.summary.updated': '{{count}} mis à jour',
    'stockInv.summary.pieces': '{{count}} pièces',
    'stockInv.btn.printLabels': 'Imprimer étiquettes',
    'stockInv.btn.newInventory': 'Nouvel inventaire',
    'stockInv.btn.printCount': 'Imprimer ({{count}})',
    'stockInv.btn.addRow': 'Ligne',
    'stockInv.btn.scan': 'Scanner',
    'stockInv.btn.csvImport': 'Import CSV',
    'stockInv.btn.csvExport': 'Export',
    'stockInv.btn.saving': 'Enregistrement…',
    'stockInv.btn.saveAll': 'Enregistrer tout ({{count}})',
    'stockInv.col.status': 'Statut',
    'stockInv.col.reference': 'Référence',
    'stockInv.col.designation': 'Désignation',
    'stockInv.col.pAchat': 'P. achat',
    'stockInv.col.pVente': 'P. vente',
    'stockInv.col.lieu': 'Lieu',
    'stockInv.col.qteAjoutee': 'Qté ajoutée',
    'stockInv.col.stockTotal': 'Stock total',
    'stockInv.col.magasin': 'Magasin',
    'stockInv.col.prixAchat': 'Prix achat (€)',
    'stockInv.col.prixVente': 'Prix vente (€)',
    'stockInv.col.emplacement': 'Emplacement',
    'stockInv.col.qte': 'Qté',
    'stockInv.col.fournisseur': 'Fournisseur',
    'stockInv.location.boutique': 'Boutique',
    'stockInv.location.depot': 'Dépôt',
    'stockInv.header.title': 'Inventaire stock',
    'stockInv.header.subtitleMagasin': 'Saisie rapide · {{magasin}}',
    'stockInv.header.subtitleNoMagasin': 'Saisie rapide · choisissez un magasin',
    'stockInv.warn.pickMagasin': 'Choisissez un magasin avant d\'enregistrer l\'inventaire.',
    'stockInv.cross.title': '{{count}} référence(s) existe(nt) déjà dans un autre magasin',
    'stockInv.cross.explain': 'Tu as créé une nouvelle ligne dans ton magasin cible. Si c\'est volontaire (stock dédié par magasin), ignore ce message. Si tu voulais transférer, va sur',
    'stockInv.cross.explainTransfer': '→ Transférer.',
    'stockInv.cross.createdIn': 'créé en {{magasin}}',
    'stockInv.cross.existedIn': 'existait en',
    'stockInv.cross.noMagasin': '— sans magasin —',
    'stockInv.cross.qty': 'qté',
    'stockInv.badge.existing': 'existant',
    'stockInv.badge.new': 'nouveau',
    'stockInv.placeholder.refEan': 'Réf. / EAN',
    'stockInv.placeholder.ean13': 'Code EAN13',
    'stockInv.placeholder.productName': 'Nom du produit',
    'stockInv.placeholder.fournisseur': 'Fournisseur',
    'stockInv.footer.rows': 'lignes',
    'stockInv.footer.toSave': 'à enregistrer',
    'stockInv.footer.existingCount': '({{count}} existant(s))',
    'stockInv.footer.newCount': '({{count}} nouveau(x))',
    'stockInv.footer.piecesAndValue': '{{count}} pièces · {{value}} achat',
    'stockInv.hint.enterBefore': 'Appuyez sur',
    'stockInv.hint.enterKey': 'Entrée',
    'stockInv.hint.enterAfter': 'pour passer à la ligne suivante',
    'stockInv.review.title': 'Pré-analyse inventaire',
    'stockInv.review.subtitle': '{{count}} ligne(s) · magasin {{magasin}}',
    'staffChat.statusOnline': 'En ligne',
    'staffChat.statusBusy': 'Occupé',
    'staffChat.statusAway': 'Absent',
    'staffChat.statusOffline': 'Hors ligne',
    'staffChat.colorYellow': 'Jaune',
    'staffChat.colorBlue': 'Bleu',
    'staffChat.colorGreen': 'Vert',
    'staffChat.colorOrange': 'Orange',
    'staffChat.colorPurple': 'Violet',
    'staffChat.colorCyan': 'Cyan',
    'staffChat.colorRed': 'Rouge',
    'staffChat.quickRepliesTitle': 'Réponses rapides',
    'staffChat.quickRepliesSubtitle': 'Personnalisez les réponses du chat',
    'staffChat.qrLabelPlaceholder': 'Label (ex : Prêt !)',
    'staffChat.qrTextPlaceholder': 'Texte du message...',
    'staffChat.qrSaveEdit': 'Modifier',
    'staffChat.cancel': 'Annuler',
    'staffChat.add': 'Ajouter',
    'staffChat.filterAll': 'Tous',
    'staffChat.filterTeam': 'Équipe',
    'staffChat.filterClients': 'Clients',
    'staffChat.filterTickets': 'Tickets',
    'staffChat.filterQuick': 'Rapides',
    'staffChat.messaging': 'Messagerie',
    'staffChat.newConversation': 'Nouvelle conversation',
    'staffChat.searchPlaceholder': 'Rechercher une conversation...',
    'staffChat.noStaffAvailable': 'Aucun membre disponible',
    'staffChat.labelTeam': 'Équipe',
    'staffChat.labelOrder': 'Commande',
    'staffChat.labelRepair': 'Réparation',
    'staffChat.labelClient': 'Client',
    'staffChat.priorityUrgent': 'Urgent',
    'staffChat.priorityMedium': 'Moyen',
    'staffChat.priorityNormal': 'Normal',
    'staffChat.ticketsNone': 'Aucun ticket en attente',
    'staffChat.ticketsAllHandled': 'Tous les messages ont été traités',
    'staffChat.timeAgoLessThanHour': 'il y a moins d\'1 h',
    'staffChat.timeAgoHours': 'il y a {{h}} h',
    'staffChat.viewConversation': 'Voir conversation',
    'staffChat.close': 'Fermer',
    'staffChat.recentlyClosed': 'Récemment fermés',
    'staffChat.closedBy': 'par {{name}}',
    'staffChat.noConversations': 'Aucune conversation',
    'staffChat.conversation': 'Conversation',
    'staffChat.startConversation': 'Démarrez la conversation',
    'staffChat.endToEndEncrypted': 'Les messages sont chiffrés de bout en bout',
    'staffChat.aiAssistant': 'Assistant IA',
    'staffChat.autoBadge': 'auto',
    'staffChat.nudgeTitle': 'Envoyer un nudge !',
    'staffChat.sending': 'Envoi en cours...',
    'staffChat.messagePlaceholder': 'Écrire un message...',
    'staffChat.selectConversation': 'Sélectionnez une conversation',
    'staffChat.chooseFromList': 'Choisissez dans la liste à gauche',
    'warnDuplicateReference': 'Déjà en stock — +1 à l\'enregistrement',
    'warnDuplicateEan': 'EAN déjà en stock — +1 à l\'enregistrement',
    'warnCrossMagasin': 'Référence dans un autre magasin',
    'warnLowVision': 'Lecture photo incertaine',
    'warnPrixAchatManual': 'Prix achat à saisir manuellement',
    'warnLlmUnavailable': 'Vision IA indisponible (clés API)',
    'alertAddPhotoOrText': 'Ajoutez une photo ou collez le texte de l\'étiquette.',
    'errAnalyzePhoto': 'Erreur analyse photo',
    'alertEnterPrixAchat': 'Saisissez un prix achat pour recalculer le prix vente.',
    'errCalcPrice': 'Erreur calcul prix',
    'alertRefDesignationRequired': 'Référence et désignation requises.',
    'alertPrixVenteRequired': 'Prix de vente requis.',
    'noticeAddedToList': '+{{qty}} dans la liste : {{designation}} (total +{{total}})',
    'noticeStockUpdate': 'Mise à jour stock : {{designation}} (+{{qty}})',
    'noticeAdded': 'Ajouté : {{designation}} (×{{qty}})',
    'errServer': 'Erreur serveur',
    'alertChooseMagasin': 'Choisissez un magasin.',
    'errAnalyzeImpossible': 'Analyse impossible',
    'summaryTitle': 'Articles enregistrés',
    'summarySubtitle': '{{created}} créé(s) · {{updated}} mis à jour · {{labels}} étiquette(s) à imprimer',
    'printLabels': 'Imprimer étiquettes ({{count}})',
    'newSession': 'Nouvelle session',
    'colStatut': 'Statut',
    'colReference': 'Référence',
    'colDesignation': 'Désignation',
    'colPrixAchat': 'P. achat',
    'colPrixVente': 'P. vente',
    'colQtyAdded': 'Qté ajoutée',
    'badgeNew': 'Nouveau',
    'badgeAddStock': '+stock',
    'pageTitle': 'Analyser un produit',
    'pageSubtitle': 'Scannez plusieurs articles · validez chaque ligne · enregistrez tout en une fois',
    'pendingList': 'Liste en attente — {{count}} article(s) · {{pieces}} pièce(s)',
    'saveAll': 'Enregistrer tout ({{count}})',
    'badgeUpdate': 'Mise à jour',
    'depot': 'Dépôt',
    'boutique': 'Boutique',
    'stockAbbrev': 'stock B:{{boutique}} D:{{depot}}',
    'remove': 'Retirer',
    'photoSectionTitle': 'Photo produit',
    'productAlt': 'Produit',
    'photoHint': 'Galerie ou appareil photo — emballage ou étiquette (EAN visible)',
    'gallery': 'Galerie',
    'camera': 'Appareil photo',
    'analyzing': 'Analyse…',
    'analyze': 'Analyser',
    'aiVisionOption': 'Vision IA si étiquette illisible (OpenAI / Gemini)',
    'labelTextLabel': 'Texte étiquette (optionnel — si le code-barres est illisible)',
    'labelTextPlaceholder': 'Écran iPhone 8 OLED\nEAN 3701234567890\nRef IP8-LCD-001',
    'emptyHint': 'Lancez l\'analyse pour pré-remplir la fiche stock.',
    'analyzingHint': 'Lecture étiquette et recherche fournisseur…',
    'alreadyInStockPrefix': 'Déjà en stock ({{magasin}}) — enregistrement =',
    'alreadyInStockSuffix': '(boutique {{boutique}} · dépôt {{depot}})',
    'alreadyInListPrefix': 'Déjà dans la liste (×{{qty}}) — accepter =',
    'alreadyInListSuffix': 'dans la liste',
    'currentStockBoutique': '(stock actuel boutique : {{qty}})',
    'resultTitle': 'Résultat analyse',
    'readConfidence': 'Confiance lecture : {{pct}}%',
    'aiVision': 'IA vision',
    'matchLabel': 'correspondance',
    'fieldDesignation': 'Désignation *',
    'fieldReference': 'Référence *',
    'fieldCategorie': 'Catégorie',
    'fieldFournisseur': 'Fournisseur',
    'otherSupplierParts': 'Autres pièces fournisseur',
    'tarifsTitle': 'Tarifs',
    'fieldPrixAchat': 'Prix achat (€)',
    'autoSupplierCache': 'Auto cache fournisseur',
    'fieldPrixVente': 'Prix vente (€)',
    'recalcVente': 'Recalculer vente',
    'laborLabel': 'MO : {{amount}}',
    'detailTitle': 'Détail calcul Auto-Devis',
    'detailAchat': 'Achat :',
    'detailPort': 'Port :',
    'detailDouane': 'Douane :',
    'detailCoutPiece': 'Coût pièce :',
    'detailFinal': 'Final :',
    'qtyLocationTitle': 'Quantité & emplacement',
    'quantite': 'Quantité',
    'quit': 'Quitter',
    'acceptPlusOne': 'Accepter (+1)',
    'acceptLine': 'Accepter la ligne',
    'acceptHelp': 'Doublon liste ou stock = +1 automatique · puis « Enregistrer tout » · étiquettes à la fin.',
    'reviewTitleAccept': 'Cette ligne est-elle correcte ?',
    'reviewTitleBulk': 'Vérification avant enregistrement',
    'reviewSubtitleAccept': 'Validez pour ajouter à la liste, puis scannez l\'article suivant',
    'reviewBulkSubtitle': '{{count}} article(s) à enregistrer en stock',
    'avoirs.title': 'Avoirs',
    'avoirs.subtitle': 'Crédit client issu d’un ticket ou d’une facture — utilisable au POS',
    'avoirs.refresh': 'Actualiser',
    'avoirs.errorLoad': 'Erreur chargement avoirs',
    'avoirs.searchPlaceholder': 'Réf. avoir, client, ticket d’origine…',
    'avoirs.allStatuses': 'Tous les statuts',
    'avoirs.empty': 'Aucun avoir',
    'avoirs.colRef': 'Référence',
    'avoirs.colClient': 'Client',
    'avoirs.colOrigin': 'Origine',
    'avoirs.colInitial': 'Initial',
    'avoirs.colSolde': 'Solde',
    'avoirs.colStatut': 'Statut',
    'avoirs.colDate': 'Date',
    'avoirs.createdBy': 'Créé par',
    'avoirs.originLabel': 'Origine :',
    'avoirs.motifLabel': 'Motif :',
    'avoirs.clientLabel': 'Client :',
    'avoirs.printTicket': 'Imprimer ticket d’avoir',
    'avoirs.downloadPdf': 'Télécharger PDF',
    'avoirs.historyTitle': 'Historique des mouvements',
    'avoirs.cancelRemaining': 'Annuler le solde restant',
    'avoirs.confirmCancel': 'Annuler le solde restant de {{ref}} ?',
    'avoirs.close': 'Fermer',
    'avoirs.statutDisponible': 'Disponible',
    'avoirs.statutPartiel': 'Partiellement utilisé',
    'avoirs.statutUtilise': 'Utilisé',
    'avoirs.statutAnnule': 'Annulé',
    'stockMov.tab.dashboard': 'Tableau de bord',
    'stockMov.tab.movements': 'Mouvements',
    'stockMov.tab.imei': 'IMEI / Séries',
    'stockMov.tab.inventory': 'Inventaire',
    'stockMov.header.title': 'Stock avancé',
    'stockMov.header.subtitle': 'Mouvements · IMEI · sessions inventaire · tableau de bord',
    'stockMov.cancel': 'Annuler',
    'stockMov.save': 'Enregistrer',
    'stockMov.saving': 'Enregistrement...',
    'stockMov.loadError': 'Erreur de chargement',
    'stockMov.error': 'Erreur : {{detail}}',
    'stockMov.loading': 'Chargement…',
    'stockMov.pageOf': 'Page {{page}} / {{total}}',
    'stockMov.kpi.totalArticles': 'Total articles',
    'stockMov.kpi.qteBoutique': 'Qté Boutique',
    'stockMov.kpi.qteDepot': 'Qté Dépôt',
    'stockMov.kpi.ruptures': 'Ruptures',
    'stockMov.kpi.imeiEnStock': 'IMEI en stock',
    'stockMov.boutique': 'Boutique',
    'stockMov.depot': 'Dépôt',
    'stockMov.total': 'Total',
    'stockMov.valeurAchat': 'Valeur d\'achat',
    'stockMov.valeurVente': 'Valeur de vente',
    'stockMov.marge': 'Marge',
    'stockMov.margeTotale': 'Marge totale',
    'stockMov.stocksNegatifs': 'Stocks négatifs ({{count}})',
    'stockMov.aucunStockNegatif': 'Aucun stock négatif',
    'stockMov.articlesSousSeuil': 'Articles sous seuil ({{count}})',
    'stockMov.tousAuDessusSeuil': 'Tous les articles sont au-dessus de leur seuil d\'alerte',
    'stockMov.filter.all': 'Tous',
    'stockMov.filter.entrees': 'Entrées',
    'stockMov.filter.sorties': 'Sorties',
    'stockMov.magasinLabel': 'Magasin :',
    'stockMov.nouveauMouvement': 'Nouveau mouvement',
    'stockMov.col.date': 'Date',
    'stockMov.col.type': 'Type',
    'stockMov.col.motif': 'Motif',
    'stockMov.col.article': 'Article',
    'stockMov.col.magasin': 'Magasin',
    'stockMov.col.qte': 'Qté',
    'stockMov.col.stockAvant': 'Stock avant',
    'stockMov.col.stockApres': 'Stock après',
    'stockMov.col.imei': 'IMEI',
    'stockMov.col.par': 'Par',
    'stockMov.aucunMouvement': 'Aucun mouvement enregistré',
    'stockMov.type.transfert': 'Transfert',
    'stockMov.type.entree': 'Entrée',
    'stockMov.type.sortie': 'Sortie',
    'stockMov.modalNewMovement': 'Nouveau mouvement de stock',
    'stockMov.field.motif': 'Motif',
    'stockMov.field.article': 'Article',
    'stockMov.searchArticlePlaceholder': 'Rechercher un article...',
    'stockMov.refStock': '({{ref}}) Stock : {{qty}}',
    'stockMov.refShort': 'Réf : {{ref}}',
    'stockMov.field.quantite': 'Quantité',
    'stockMov.field.prixUnitaire': 'Prix unitaire',
    'stockMov.field.imeiOptional': 'IMEI / N° série (optionnel)',
    'stockMov.imeiPlaceholder': 'Ex : 353012345678901',
    'stockMov.field.noteOptional': 'Note (optionnel)',
    'stockMov.commentPlaceholder': 'Commentaire...',
    'stockMov.imeiRefRequired': 'IMEI et référence requis',
    'stockMov.refQtyRequired': 'Référence et quantité requises',
    'stockMov.registreTitle': 'Registre IMEI — traçabilité téléphones',
    'stockMov.registreDesc': 'Chaque appareil en stock doit avoir un IMEI unique. Permet de retrouver l\'historique (achat, vente POS, réparation).',
    'stockMov.nouveauTelephone': 'Nouveau téléphone',
    'stockMov.searchImeiPlaceholder': 'Rechercher IMEI, article...',
    'stockMov.tousLesStatuts': 'Tous les statuts',
    'stockMov.enregistrerImei': 'Enregistrer IMEI',
    'stockMov.col.imeiSerie': 'IMEI / N° Série',
    'stockMov.col.refDot': 'Réf.',
    'stockMov.col.magShort': 'Mag.',
    'stockMov.col.etat': 'État',
    'stockMov.col.statut': 'Statut',
    'stockMov.col.origine': 'Origine',
    'stockMov.aucunImei': 'Aucun IMEI — ajoutez un téléphone au stock puis enregistrez son numéro ici.',
    'stockMov.historique': 'Historique',
    'stockMov.historiqueImei': 'Historique · {{imei}}',
    'stockMov.byUser': 'par {{user}}',
    'stockMov.aucunMouvementImei': 'Aucun mouvement lié à cet IMEI.',
    'stockMov.modalRegisterImei': 'Enregistrer un IMEI / N° série',
    'stockMov.field.articleStockRef': 'Article stock (référence)',
    'stockMov.searchPlaceholder': 'Rechercher...',
    'stockMov.field.etat': 'État',
    'stockMov.field.origine': 'Origine',
    'stockMov.origine.achat': 'Achat',
    'stockMov.origine.reprise_client': 'Reprise client',
    'stockMov.origine.transfert': 'Transfert',
    'stockMov.etat.neuf': 'Neuf',
    'stockMov.etat.occasion': 'Occasion',
    'stockMov.etat.reconditionne': 'Reconditionné',
    'stockMov.etat.hs': 'HS',
    'stockMov.statut.en_stock': 'En stock',
    'stockMov.statut.vendu': 'Vendu',
    'stockMov.statut.reserve': 'Réservé',
    'stockMov.statut.en_reparation': 'En réparation',
    'stockMov.motif.achat_fournisseur': 'Achat fournisseur',
    'stockMov.motif.retour_client': 'Retour client',
    'stockMov.motif.correction_inventaire': 'Correction inventaire',
    'stockMov.motif.transfert_entrant': 'Transfert entrant',
    'stockMov.motif.reception_commande': 'Réception commande',
    'stockMov.motif.reintegration_reparation': 'Réintégration réparation',
    'stockMov.motif.vente_pos': 'Vente POS',
    'stockMov.motif.consommation_reparation': 'Consommation réparation',
    'stockMov.motif.perte_casse': 'Perte / casse',
    'stockMov.motif.retour_fournisseur': 'Retour fournisseur',
    'stockMov.motif.transfert_sortant': 'Transfert sortant',
    'stockMov.motif.ajustement_inventaire': 'Ajustement inventaire',
    'stockMov.sessionsInventaire': 'Sessions d\'inventaire',
    'stockMov.nouvelInventaire': 'Nouvel inventaire',
    'stockMov.aucuneSession': 'Aucune session d\'inventaire',
    'stockMov.parUser': 'Par {{user}}',
    'stockMov.articlesEcarts': '{{articles}} articles, {{ecarts}} écarts',
    'stockMov.status.enCours': 'En cours',
    'stockMov.status.valide': 'Validé',
    'stockMov.retourSessions': 'Retour aux sessions',
    'stockMov.statutColon': 'Statut :',
    'stockMov.validePar': 'Validé par {{user}}',
    'stockMov.validerSansCorrection': 'Valider sans correction',
    'stockMov.validerCorriger': 'Valider + corriger stock',
    'stockMov.comptagePhysique': 'Comptage physique',
    'stockMov.searchArticleShort': 'Rechercher article...',
    'stockMov.inv.bdShort': 'B:{{b}} D:{{d}}',
    'stockMov.stockSelectionne': 'Stock sélectionné :',
    'stockMov.dotBoutique': '· boutique {{q}}',
    'stockMov.dotDepot': '· dépôt {{q}}',
    'stockMov.qteComptee': 'Qté comptée',
    'stockMov.col.stockTheorique': 'Stock théorique',
    'stockMov.col.comptagePhysique': 'Comptage physique',
    'stockMov.col.ecart': 'Écart',
    'stockMov.col.comptePar': 'Compté par',
    'stockMov.aucunArticleCompte': 'Aucun article compté. Commencez le comptage ci-dessus.',
    'stockMov.modalNewSession': 'Nouvelle session d\'inventaire',
    'stockMov.field.titreOptional': 'Titre (optionnel)',
    'stockMov.titrePlaceholder': 'Ex : Inventaire mensuel mars 2026',
    'stockMov.creating': 'Création...',
    'stockMov.creer': 'Créer',
    'stockMov.confirmValidateApply': 'Valider ET appliquer les corrections de stock ?',
    'stockMov.confirmValidateNoApply': 'Valider SANS appliquer les corrections ?',
    'stockMov.sessionValidee': 'Session validée !',
    'stockMov.countSaved': 'Comptage enregistré : Stock théorique {{theorique}}, Physique {{physique}}, Écart {{ecart}}',
    'stock.err.templateDownload': 'Erreur lors du téléchargement du modèle',
    'stock.err.missingId': 'Erreur : identifiant de l\'article manquant',
    'stock.deleteSuccess': 'Article supprimé avec succès',
    'stock.err.delete': 'Erreur lors de la suppression',
    'stock.confirmDeleteMany': 'Supprimer {{count}} article(s) ?',
    'stock.err.update': 'Erreur lors de la mise à jour',
    'stock.err.transfer': 'Erreur lors du transfert',
    'stock.err.bulkTransfer': 'Erreur lors du transfert groupé',
    'stock.depotOnlyM1': 'Le dépôt est disponible uniquement sur M1 pour le moment.',
    'stock.sameSourceDest': 'La source et la destination sont identiques.',
    'stock.noLineToTransfer': 'Aucune ligne à transférer (quantités nulles ou magasin source = destination).',
    'stock.confirmBulkPublish': 'Mettre en vente en ligne {{count}} article(s) ?',
    'stock.confirmBulkUnpublish': 'Retirer de la vente en ligne {{count}} article(s) ?',
    'stock.confirmPublishOne': 'Mettre en vente en ligne « {{name}} » ?',
    'stock.confirmUnpublishOne': 'Retirer de la vente en ligne « {{name}} » ?',
    'stock.importDone': 'Import terminé',
    'stock.importCreated': 'créé(s)',
    'stock.importUpdated': 'mis à jour',
    'stock.importSkipped': 'ignoré(s)',
    'stock.importErrors': 'erreur(s)',
    'stock.importRetryHint': '{{count}} article(s) existai(en)t déjà — relancez en mode « Mettre à jour ».',
    'stock.importRetryBtn': 'Relancer en MAJ',
    'stock.importViewErrors': 'Voir les {{count}} erreur(s)',
    'stock.transferTitle': 'Transfert de stock',
    'stock.boutique': 'Boutique',
    'stock.depot': 'Dépôt',
    'stock.sourceStore': 'Magasin source',
    'stock.sourceLocation': 'Emplacement source',
    'stock.destStore': 'Magasin destination',
    'stock.destLocation': 'Emplacement destination',
    'stock.quantity': 'Quantité',
    'stock.availableAtSource': 'Disponible en source : {{count}}',
    'stock.cancel': 'Annuler',
    'stock.transferring': 'Transfert…',
    'stock.transfer': 'Transférer',
    'stock.bulkTransferTitle': 'Changer le magasin de {{count}} article(s)',
    'stock.location': 'Emplacement',
    'stock.bulkTransferR1Note': 'Le transfert respecte la règle R1 : le document source conserve une quantité de 0 s\'il est vidé, et un nouveau document est créé dans le magasin de destination.',
    'stock.colArticle': 'Article',
    'stock.colCurrentStore': 'Magasin actuel',
    'stock.colStock': 'Stock',
    'stock.colQtyToTransfer': 'Quantité à transférer',
    'stock.runTransfer': 'Lancer le transfert',
    'stock.resultSucceeded': 'réussis',
    'stock.resultFailed': 'échoués',
    'stock.resultUnitsTransferred': 'unités transférées',
    'stock.failuresLabel': 'Échecs :',
    'stock.done': 'Terminer',
    'stock.storeN': 'Magasin {{n}}',
    'stock.tab.view': 'Vue',
    'stock.tab.inventory': 'Inventaire',
    'stock.tab.analyze': 'Analyser produit',
    'stock.tab.history': 'Historique',
    'stock.tab.supplierOrders': 'Appro fournisseur',
    'stock.tab.invoiceImport': 'Import facture IA',
    'stock.tab.labels': 'Étiquettes',
    'stock.tab.advanced': 'Stock avancé',
    'stock.tab.reconciliation': 'Réconciliation',
    'stock.tab.config': 'Configuration',
    'posV2.remisePlafonneeMsg': 'Remise limitée à {{pct}} %. Au-delà, une validation de la direction est nécessaire.',
    'posV2.venteNonEnregRemiseRamenee': 'La vente n\'est PAS enregistrée — la remise a été ramenée au plafond, vérifiez le total puis encaissez à nouveau.',
    'posV2.remiseRameneeVerif': 'La remise a été ramenée au plafond — vérifiez le total puis encaissez.',
    'posV2.catalogUnavailable': 'Catalogue indisponible',
    'posV2.paymentRefusedTpe': 'Paiement refusé ou annulé sur le TPE — réessayez.',
    'posV2.caisseClosedOpenFirst': 'Caisse {{mag}} fermée — ouvrez-la avant d\'encaisser',
    'posV2.sumupCheckoutDesc': 'POS V2 · {{count}} ligne(s)',
    'posV2.sumupTerminalNotConnected': 'Terminal SumUp non connecté',
    'posV2.sumupSaleNotSaved': '{{msg}}. La vente n\'est PAS enregistrée (stock inchangé). Vérifiez que le TPE est allumé et connecté.',
    'posV2.cartEmpty': 'Panier vide',
    'posV2.lookupValidAvoir': 'Rechercher un avoir valide avant d\'encaisser',
    'posV2.printError': 'Erreur impression',
    'posV2.caisseClosedBanner': 'Caisse {{mag}} fermée.',
    'posV2.open': 'Ouvrir',
    'posV2.oneEncaissementMultiStock': '1 encaissement {{mag}} · stock multi-magasins',
    'posV2.catalog': 'Catalogue',
    'posV2.ficheButtonHint': 'Bouton Fiche → galerie photos',
    'posV2.all': 'Tous',
    'posV2.stockMag': 'Stock {{mag}}',
    'posV2.catalogPlaceholder': 'Catalogue…',
    'posV2.go': 'Go',
    'posV2.catalogMeta': '{{total}} réfs · {{scope}} · p.{{page}}/{{pages}}',
    'posV2.enterAvoirRefOrClient': 'Saisir une référence avoir ou un nom client',
    'posV2.avoirNotFound': 'Avoir introuvable',
    'posV2.productSheet': 'Fiche produit',
    'posV2.productSheetSub': 'Galerie · stock · ajouter au panier',
    'posV2.ticketCenter': 'Centre tickets',
    'posV2.ticketCenterSub': 'Tickets récents · réimpression',
    'posV2.savStation': 'Poste SAV réparation',
    'posV2.savStationSub': 'Recherche dossier · encaissement reste · acompte · panier',
    'posV2.horsStock': 'Hors stock',
    'posV2.horsStockSub': 'Vente article ad hoc · badge HORS STOCK · encaissement direct',
    'posV2.clientCenter': 'Centre Client',
    'posV2.clientCenterSub': 'Historique · fidélité · rattacher à l\'encaissement',
    'posV2.orders': 'Commandes',
    'posV2.ordersSub': 'Demande client · commande · acompte · panier',
    'openCaisse.denomBill': 'Billet',
    'openCaisse.denomCoin': 'Pièce',
    'openCaisse.cardTotal': 'Total',
    'openCaisse.successOpen': 'Caisse {{magasin}} ouverte avec succès.',
    'openCaisse.errorOpen': 'Erreur lors de l\'ouverture de la caisse',
    'openCaisse.backToDashboard': 'Retour au dashboard',
    'openCaisse.title': 'Ouverture de caisse {{magasin}}',
    'openCaisse.titleForce': 'Ouverture forcée de caisse {{magasin}}',
    'openCaisse.openingFund': 'Fond d\'ouverture',
    'openCaisse.openingFundHint': 'Saisis les billets et les pièces pour la caisse {{magasin}}.',
    'openCaisse.totalOpening': 'Total ouverture',
    'openCaisse.forceWarning': 'Cette action fermera la caisse ouverte du magasin cible puis recréera une nouvelle caisse avec ce montant.',
    'openCaisse.cancel': 'Annuler',
    'openCaisse.opening': 'Ouverture en cours...',
    'openCaisse.validateOpening': 'Valider l\'ouverture',
    'calcul.title': 'Outil de calcul de prix / devis',
    'calcul.subtitle': 'Interface identique au calcul PHP + génération PDF 80mm et A4.',
    'calcul.clientSection': 'Informations client',
    'calcul.clientName': 'Nom du client',
    'calcul.phone': 'Téléphone',
    'calcul.email': 'Email',
    'calcul.saveClient': 'Enregistrer le client',
    'calcul.deviceSection': 'Sélection appareil',
    'calcul.brand': 'Marque',
    'calcul.model': 'Modèle',
    'calcul.itemsSection': 'Articles',
    'calcul.itemDescription': 'Pièce / Désignation',
    'calcul.itemReference': 'Réf pièce',
    'calcul.itemPurchasePrice': 'Prix achat',
    'calcul.addLine': 'Ajouter une ligne',
    'calcul.paramsSection': 'Paramètres',
    'calcul.quantity': 'Quantité',
    'calcul.labor': 'Main d\'œuvre (€)',
    'calcul.partReference': 'Référence pièce',
    'calcul.supplier': 'Fournisseur',
    'calcul.docType': 'Type de document',
    'calcul.docTypeDevis': 'DEVIS',
    'calcul.docTypeFacture': 'FACTURE',
    'calcul.docTypeProforma': 'PROFORMA',
    'calcul.acceptOnlinePayment': 'Accepter paiement en ligne (SumUp)',
    'calcul.acceptOnlinePaymentHint': 'Le client pourra demander un lien de paiement SumUp',
    'calcul.saveTicket': '✅ Enregistrer le ticket',
    'calcul.saving': 'Enregistrement...',
    'calcul.preview': '👁️ Prévisualiser',
    'calcul.previewSection': 'Prévisualisation',
    'calcul.previewIframeTitle': 'Aperçu du ticket',
    'calcul.previewEmpty': 'Lancez un calcul pour afficher le ticket.',
    'calcul.printTicket': 'Imprimer ticket',
    'calcul.transformA4': 'Transformer en DEVIS A4',
    'calcul.totalArticles': 'Total articles',
    'calcul.totalPurchase': 'Total achat',
    'calcul.shippingFees': 'Frais envoi',
    'calcul.customsFees': 'Frais douane',
    'calcul.costPerPiece': 'Coût par pièce',
    'calcul.finalPrice': 'Prix final',
    'calcul.alertAllowPopups': 'Veuillez autoriser les popups pour imprimer.',
    'calcul.alertAddItem': 'Ajoutez au moins un article avec un prix d\'achat.',
    'calcul.ticketSaved': '✅ Ticket enregistré.',
    'calcul.errorGenerateTicket': 'Erreur lors de la génération du ticket',
    'calcul.errorPrintTicket': 'Erreur impression ticket',
    'calcul.errorGenerateA4': 'Erreur lors de la génération du devis A4',
    'caisseHist.errPrint': 'Erreur impression caisse',
    'caisseHist.errPrintGeneric': 'Erreur impression',
    'caisseHist.errLoadMonthly': 'Erreur chargement historique mensuel',
    'caisseHist.errExport': 'Erreur export comptable',
    'caisseHist.confirmForceClose': 'Fermer de force la caisse du {{date}} ? Cette action est irréversible.',
    'caisseHist.errForceClose': 'Erreur lors de la fermeture forcée',
    'caisseHist.title': 'Historique ouvertures / fermetures de caisse',
    'caisseHist.month': 'Mois',
    'caisseHist.store': 'Magasin',
    'caisseHist.allStores': 'Tous les magasins',
    'caisseHist.exportAccounting': 'Export comptable',
    'caisseHist.totalSales': 'Total ventes',
    'caisseHist.totalCash': 'Total espèces',
    'caisseHist.totalCard': 'Total CB',
    'caisseHist.withdrawals': 'Retraits',
    'caisseHist.totalTheoretical': 'Total théorique',
    'caisseHist.totalAccounting': 'Total comptable',
    'caisseHist.discrepancy': 'Écart',
    'caisseHist.validatedBy': 'Validé par',
    'caisseHist.validationDate': 'Date validation',
    'caisseHist.noValidatedCaisse': 'Aucune caisse validée.',
    'caisseHist.opening': 'Ouverture',
    'caisseHist.closing': 'Fermeture',
    'caisseHist.caisse': 'Caisse',
    'caisseHist.daySales': 'Ventes jour',
    'caisseHist.dateStart': 'Date début',
    'caisseHist.dateEnd': 'Date fin',
    'caisseHist.reset': 'Réinitialiser',
    'caisseHist.cashFloat': 'Fond caisse',
    'caisseHist.openedBy': 'Ouvert par',
    'caisseHist.closedBy': 'Fermé par',
    'caisseHist.noHistory': 'Aucun historique disponible',
    'caisseHist.closingProgress': 'Fermeture...',
    'caisseHist.forceClose': 'Fermer (forcé)',
    'caisseHist.forced': 'Forcée',
    'caisseHist.showMore': 'Voir plus ({{count}} ouvertures précédentes)',
    'caisseHist.showLess': 'Voir moins',
    'repairDetail.popupBlocked': 'Veuillez autoriser les popups pour imprimer.',
    'repairDetail.downloadError': 'Erreur lors du téléchargement',
    'repairDetail.statusUpdateError': 'Erreur lors de la mise à jour',
    'repairDetail.invalidAmount': 'Montant invalide',
    'repairDetail.genericError': 'Erreur',
    'repairDetail.filesAttached': '{{count}} fichier(s) joint(s)',
    'repairDetail.uploadProgress': 'Téléversement {{current}}/{{total}}…',
    'repairDetail.addNoteError': 'Erreur lors de l\'ajout de la note',
    'repairDetail.confirmDeleteNote': 'Supprimer cette note ?',
    'repairDetail.notFound': 'Réparation introuvable',
    'repairDetail.backToRepairs': 'Retour aux réparations',
    'repairDetail.photosTitle': 'Photos ({{count}})',
    'repairDetail.photoAlt': 'Photo {{index}}',
    'repairDetail.notesTitle': 'Notes ({{count}})',
    'repairDetail.notePlaceholder': 'Ajouter une note...',
    'repairDetail.visibilityPublic': 'Public',
    'repairDetail.visibilityInternal': 'Interne',
    'repairDetail.filesBtn': 'Fichiers',
    'repairDetail.sending': 'Envoi...',
    'repairDetail.add': 'Ajouter',
    'repairDetail.noNotes': 'Aucune note',
    'repairDetail.staffDefault': 'Staff',
    'repairDetail.printAcompteError': 'Erreur impression ticket acompte',
    'repairDetail.printAvoirError': 'Erreur impression ticket avoir',
    'repairDetail.downloadPdfError': 'Erreur téléchargement PDF',
    'repairDetail.changeStatus': 'Changer le statut',
    'repairDetail.noStatusChange': 'Aucun changement autorisé',
    'repairDetail.addDeposit': 'Ajouter un acompte',
    'repairDetail.amountLabel': 'Montant (€)',
    'repairDetail.paymentMode': 'Mode de paiement',
    'repairDetail.paymentCash': 'Espèces',
    'repairDetail.paymentCard': 'CB',
    'repairDetail.paymentTransfer': 'Virement',
    'repairDetail.paymentCheck': 'Chèque',
    'repairDetail.cancel': 'Annuler',
    'repairDetail.statusRecu': 'Reçu',
    'repairDetail.statusEnCours': 'En Cours',
    'repairDetail.statusAttentePieces': 'Attente Pièces',
    'repairDetail.statusPieceArrivee': 'Pièce Arrivée',
    'repairDetail.statusNonReparable': 'Non Réparable',
    'repairDetail.statusTermine': 'Terminé',
    'repairDetail.statusLivre': 'Livré',
    'repairDetail.statusAttenteDepot': 'En attente de dépôt',
    'closeCaisse.denomBillet': 'Billet',
    'closeCaisse.denomPiece': 'Pièce',
    'closeCaisse.countBadge': '× {{count}}',
    'closeCaisse.total': 'Total',
    'closeCaisse.errLoad': 'Erreur lors du chargement de la caisse',
    'closeCaisse.errPdf': 'Erreur lors de la génération du PDF',
    'closeCaisse.errConfirmCb': 'Veuillez confirmer les paiements CB avant de fermer la caisse',
    'closeCaisse.confirmEcart': 'Attention : écart de {{ecart}} détecté.\n\nTotal théorique : {{theorique}}\nTotal compté : {{compte}}\n\nVoulez-vous continuer ?',
    'closeCaisse.closeSuccess': 'Caisse {{magasin}} fermée avec succès.',
    'closeCaisse.errClose': 'Erreur lors de la fermeture de la caisse',
    'closeCaisse.backToDashboard': 'Retour au tableau de bord',
    'closeCaisse.journee': 'Journée {{date}}',
    'closeCaisse.openedBy': 'ouverte par {{name}}',
    'closeCaisse.refresh': 'Actualiser',
    'closeCaisse.summaryTitle': 'Résumé de la caisse',
    'closeCaisse.activitySummary': 'Activité du magasin {{magasin}} — {{ops}} opération(s) ({{pos}} ventes POS, {{acomptes}} acomptes).',
    'closeCaisse.fondOuverture': 'Fond d\'ouverture',
    'closeCaisse.ventesEspeces': 'Ventes espèces',
    'closeCaisse.ventesCb': 'Ventes CB',
    'closeCaisse.paiementsStripe': 'Paiements Stripe',
    'closeCaisse.acomptes': 'Acomptes',
    'closeCaisse.retraits': 'Retraits',
    'closeCaisse.totalTheorique': 'Total théorique',
    'closeCaisse.totalVentes': 'Total ventes : {{montant}}',
    'closeCaisse.activiteVendeur': 'Activité par vendeur',
    'closeCaisse.colVendeur': 'Vendeur',
    'closeCaisse.colOps': 'Ops',
    'closeCaisse.colEspeces': 'Espèces',
    'closeCaisse.colCb': 'CB',
    'closeCaisse.comptageEspeces': 'Comptage espèces',
    'closeCaisse.comptageSubtitle': 'Billets et pièces avec détail visuel pour la fermeture.',
    'closeCaisse.totalCompte': 'Total compté',
    'closeCaisse.ecart': 'Écart',
    'closeCaisse.ecartImportant': 'Écart important détecté',
    'closeCaisse.infosComplementaires': 'Informations complémentaires',
    'closeCaisse.montantCoffreLabel': 'Montant versé au coffre (EUR)',
    'closeCaisse.montantCoffreHint': 'Montant en espèces déposé dans le coffre.',
    'closeCaisse.cbConfirmLabel': 'J\'ai bien confirmé les paiements CB',
    'closeCaisse.cbConfirmHint': 'Vérifier que tous les paiements CB sont bien encaissés sur le terminal.',
    'closeCaisse.imprimerRapport': 'Imprimer le rapport',
    'closeCaisse.validerCaisse': 'Valider la caisse',
    'closeCaisse.onlyAdmin': 'Seul un administrateur peut valider la fermeture de caisse',
    'paiements.title': 'Paiements en ligne',
    'paiements.proofsToValidate': '{{count}} preuve(s) à valider',
    'paiements.pendingCount': '{{count}} en attente',
    'paiements.tabSumup': 'Paiements SumUp ({{count}})',
    'paiements.tabProofs': 'Preuves de paiement ({{count}})',
    'paiements.noProof': 'Aucune preuve de paiement',
    'paiements.orderDefault': 'Commande',
    'paiements.proofValidated': 'Validé',
    'paiements.proofPendingValidation': 'En attente de validation',
    'paiements.totalLabel': 'Total : ',
    'paiements.sentLabel': 'Envoyée : ',
    'paiements.byLabel': 'Par : ',
    'paiements.validatedByLabel': 'Validé par : ',
    'paiements.viewCapture': 'Voir la capture',
    'paiements.validatePayment': 'Valider paiement',
    'paiements.reject': 'Refuser',
    'paiements.confirmOrder': 'Confirmer commande',
    'paiements.filterAll': 'Tous',
    'paiements.filterPending': 'En attente',
    'paiements.filterConfirmed': 'Confirmés',
    'paiements.filterCancelled': 'Annulés',
    'paiements.noPayment': 'Aucun paiement',
    'paiements.amountLabel': 'Montant : ',
    'paiements.refLabel': 'Réf : ',
    'paiements.dateLabel': 'Date : ',
    'paiements.ticketPdf': 'Ticket PDF',
    'paiements.validate': 'Valider',
    'paiements.cancel': 'Annuler',
    'paiements.statusPaidApplied': 'Confirmé',
    'paiements.statusPaidPending': 'En attente',
    'paiements.statusPending': 'En cours',
    'paiements.statusCancelled': 'Annulé',
    'paiements.orderRepair': 'Réparation {{ref}}',
    'paiements.orderBoutique': 'Commande boutique',
    'paiements.alertConfirmed': 'Paiement confirmé et appliqué !',
    'paiements.errorConfirm': 'Erreur lors de la confirmation',
    'paiements.confirmCancel': 'Annuler ce paiement ?',
    'paiements.error': 'Erreur',
    'paiements.errorTicket': 'Erreur lors du téléchargement du ticket',
    'paiements.confirmValidateProof': 'Valider cette preuve de paiement ?',
    'paiements.alertProofValidated': 'Paiement validé !',
    'paiements.confirmRejectProof': 'Refuser cette preuve de paiement ?',
    'paiements.confirmConfirmOrder': 'Confirmer cette commande ?',
    'paiements.alertOrderConfirmed': 'Commande confirmée !',
    'repairForm.deviceNotFound': 'Appareil non trouvé',
    'repairForm.selectMagasinFirst': 'Choisis d\'abord le magasin de prise en charge de cette réparation.',
    'repairForm.saveError': 'Erreur lors de l\'enregistrement',
    'repairForm.conversionFromCommande': 'Conversion depuis commande',
    'repairForm.prefillNotice': 'Informations pré-remplies · acomptes ({{amount}}) transférés à la finalisation.',
    'repairForm.sectionMagasin': 'Magasin',
    'repairForm.magasinLabel': 'Magasin de prise en charge *',
    'repairForm.selectMagasinOption': '— Sélectionne un magasin —',
    'repairForm.sectionForcedEntry': 'Enregistrement forcé',
    'repairForm.forcedEntryHint': 'Pour un dépôt oublié : enregistre la réparation avec la date réelle du dépôt (pas la date du jour).',
    'repairForm.useBackdateLabel': 'Utiliser une date de dépôt antérieure',
    'repairForm.realDepotDateTime': 'Date et heure du dépôt réel',
    'repairForm.sectionClient': 'Client',
    'repairForm.clientName': 'Nom client *',
    'repairForm.phone': 'Téléphone *',
    'repairForm.email': 'Email',
    'repairForm.address': 'Adresse',
    'repairForm.sectionDevice': 'Appareil',
    'repairForm.brand': 'Marque *',
    'repairForm.model': 'Modèle *',
    'repairForm.problem': 'Problème',
    'repairForm.technician': 'Réparateur',
    'repairForm.selectOption': '— Sélectionner —',
    'repairForm.imeiSerial': 'IMEI / N° série',
    'repairForm.deviceLock': 'Code verrou',
    'repairForm.sectionParts': 'Pièces',
    'repairForm.defectivePartsHint': 'Pièces non fonctionnelles à la réception',
    'repairForm.phoneDoesntTurnOn': 'Tél. ne s\'allume pas',
    'repairForm.sectionStockParts': 'Pièces stock (optionnel)',
    'repairForm.stockPartsHint': 'Si la pièce existe en stock du magasin, elle sera décomptée à la création et le prix réparation recalculé sur les prix catalogue. Sinon, indiquez un prix manuel ci-dessous (devis théorique).',
    'repairForm.stockPartsTotal': 'Total pièces stock : {{amount}} — appliqué à la création si disponible.',
    'repairForm.sectionPricing': 'Tarifs',
    'repairForm.priceRepair': 'Prix réparation (€)',
    'repairForm.theoreticalQuote': '— devis théorique',
    'repairForm.priceDiagnostic': 'Prix diagnostic (€)',
    'repairForm.receptionNotes': 'Notes de réception',
    'repairForm.sectionPhotos': 'Photos',
    'repairForm.addPhoto': 'Ajouter',
    'repairForm.cancel': 'Annuler',
    'repairForm.save': 'Enregistrer',
    'repairForm.createRepair': 'Créer la réparation',
    'repairForm.parts.speaker': 'Haut-parleur',
    'repairForm.parts.lcd': 'Écran',
    'repairForm.parts.front_cam': 'Caméra avant',
    'repairForm.parts.back_cam': 'Caméra arrière',
    'repairForm.parts.microphone': 'Micro',
    'repairForm.parts.fingerprint': 'Empreinte',
    'repairForm.parts.home_button': 'Accueil',
    'repairForm.parts.volume_button': 'Volume',
    'repairForm.parts.power_button': 'Power',
    'repairForm.parts.signal_carrier': 'Signal',
    'repairForm.parts.battery': 'Batterie',
    'repairForm.parts.wifi_bt': 'Wi-Fi/Bluetooth',
    'repairForm.parts.ear_speaker': 'Écouteur',
    'repairForm.parts.charging_port': 'Port charge',
    'labels.barcodeAuto': 'EAN13 sera auto-généré',
    'labels.allowPopups': 'Veuillez autoriser les popups pour imprimer.',
    'labels.selectAtLeastOne': 'Sélectionnez au moins un produit',
    'labels.errorGenerate': 'Erreur génération étiquettes',
    'labels.infoNoEan': 'Info : {{count}} article(s) sans EAN — EAN13 interne auto-généré. Total : {{total}} étiquette(s).',
    'labels.jobCreated': 'Job d\'impression créé ({{count}} étiquettes).\nID : {{id}}...\nL\'agent Bixolon va récupérer ce lot.',
    'labels.jobNoEan': '\nNote : {{count}} sans EAN (auto-généré).',
    'labels.errorBatch': 'Erreur batch impression',
    'labels.generating': 'Génération...',
    'labels.generatePdf': 'Générer PDF ({{count}})',
    'labels.previewPdf': 'Aperçu PDF ({{count}})',
    'labels.printBixolon': 'Imprimer Bixolon ({{count}})',
    'labels.clear': 'Vider',
    'labels.format': 'Format',
    'labels.formatBixolon': 'Bixolon 50 × 30 mm (thermique)',
    'labels.formatA4': 'Planche A4 (legacy)',
    'labels.pageTitle': 'Étiquettes produits',
    'labels.pageSubtitle': 'Étiquettes produits configurables',
    'labels.config': 'Config',
    'labels.searchPlaceholder': 'Rechercher un produit...',
    'labels.boutique': 'Boutique',
    'labels.depot': 'Dépôt',
    'labels.deselectAll': 'Tout désélectionner',
    'labels.colProduct': 'Produit',
    'labels.colPrice': 'Prix',
    'labels.colBoutiqueShort': 'Bout.',
    'labels.colQtyToPrint': 'Qté à imprimer',
    'labels.noProduct': 'Aucun produit',
    'labels.autoShort': 'auto',
    'labels.previewTitle': 'Aperçu étiquette',
    'labels.refLabel': 'Réf. :',
    'labels.selectedProducts': 'Produits sélectionnés',
    'labels.totalLabels': 'Total étiquettes',
    'labels.autoGenAtPdf': 'Auto-généré au PDF',
    'labels.selectToPreview': 'Sélectionnez un produit pour prévisualiser',
    'labels.batchVeryLarge': 'Lot très important',
    'labels.batchConfirmTitle': 'Confirmer le gros lot',
    'labels.confirmBodyPrefix': 'Vous allez générer',
    'labels.confirmBodySuffix': 'étiquettes.',
    'labels.estRoll': '≈ {{meters}} m de rouleau (50×30mm)',
    'labels.estTime': '≈ {{minutes}} min d\'impression (~1,5 s/étiquette)',
    'labels.cancel': 'Annuler',
    'labels.confirmAnyway': 'Confirmer quand même',
    'labels.continue': 'Continuer',
    'rep.status.awaitingDeposit': 'En attente de dépôt',
    'rep.status.received': 'Reçu',
    'rep.status.inProgress': 'En cours',
    'rep.status.awaitingParts': 'Attente pièces',
    'rep.status.completed': 'Terminé',
    'rep.status.notRepairable': 'Non réparable',
    'rep.status.delivered': 'Livré',
    'rep.status.refused': 'Refusé',
    'rep.payCash': 'Espèces',
    'rep.payCard': 'Carte bancaire',
    'rep.payTransfer': 'Virement',
    'rep.payCheck': 'Chèque',
    'rep.accept': 'Accepter',
    'rep.addError': 'Erreur lors de l\'ajout',
    'rep.adminOnlyStatus': 'Seul un administrateur peut modifier ce statut.',
    'rep.allowPopups': 'Veuillez autoriser les popups pour imprimer.',
    'rep.chatTitle': 'Chat réparation {{ref}}',
    'rep.confirmArrivalAsk': 'Confirmer la réception de l\'appareil {{ref}} en boutique ?',
    'rep.confirmArrivalDone': 'Appareil confirmé ! La réparation est maintenant active.',
    'rep.confirmArrivalError': 'Erreur lors de la confirmation',
    'rep.created': 'Créé',
    'rep.currentStatus': 'Statut actuel :',
    'rep.deleteError': 'Erreur lors de la suppression',
    'rep.deleteRecordAsk': 'Supprimer cet enregistrement ?',
    'rep.deleteStatusAsk': 'Supprimer le statut « {{name}} » ?',
    'rep.depositAmountEuro': 'Montant acompte (€)',
    'rep.diagnosticPaid': 'Diagnostic payé',
    'rep.diagnosticRemaining': 'Diagnostic : {{amount}} restant',
    'rep.downloadError': 'Erreur lors du téléchargement',
    'rep.error': 'Erreur',
    'rep.invalidAmount': 'Montant invalide',
    'rep.newStatus': 'Nouveau statut',
    'rep.noDeposits': 'Aucun acompte versé',
    'rep.noOnlineRequests': 'Aucune demande en ligne en attente',
    'rep.onlineRequests': 'Demandes en ligne ({{count}})',
    'rep.or': 'ou',
    'rep.pointAtTicketQr': 'Pointez vers le QR code du ticket',
    'rep.printAcompteError': 'Erreur impression ticket acompte',
    'rep.qrPrintHint': 'Scannez pour suivre votre réparation',
    'rep.qrSearchPlaceholder': 'Ex : REM0094',
    'rep.qrTrackingHint': 'Le client scanne ce QR code pour suivre sa réparation en temps réel',
    'rep.qrTrackingTitle': 'QR Code de suivi',
    'rep.reference': 'Référence :',
    'rep.repair': 'Réparation',
    'rep.scanOrEnterRef': 'Scannez un QR code ou entrez la référence',
    'rep.scanWithCamera': 'Scanner avec la caméra',
    'rep.searchRepair': 'Rechercher une réparation',
    'rep.statusManagement': 'Gestion des statuts',
    'rep.ticket': 'Ticket',
    'rep.updateError': 'Erreur lors de la mise à jour',
    'rep.bulkNoteSentSingular': 'Note envoyée à {{count}} dossier{{skip}}.',
    'rep.bulkNoteSentPlural': 'Note envoyée à {{count}} dossiers{{skip}}.',
    'rep.bulkNoteSkippedSingular': '({{count}} ignorée)',
    'rep.bulkNoteSkippedPlural': '({{count}} ignorées)',
    'devisDepl.title': 'Devis Déplacement',
    'devisDepl.subtitle': 'Gestion des devis pour réparations à domicile',
    'devisDepl.newDevis': 'Nouveau devis',
    'devisDepl.exportCsv': 'Exporter CSV',
    'devisDepl.remindBtn': 'Relancer ({{count}})',
    'devisDepl.sending': 'Envoi...',
    'devisDepl.send': 'Envoyer',
    'devisDepl.cancel': 'Annuler',
    'devisDepl.errGeneric': 'Erreur',
    'devisDepl.confirmSendReminders': 'Envoyer un rappel aux {{count}} client(s) avec devis en attente depuis plus de 3 jours ?',
    'devisDepl.remindersSent': '{{count}} rappel(s) envoyé(s) !',
    'devisDepl.sentByEmail': 'Devis envoyé par email !',
    'devisDepl.errSend': 'Erreur d\'envoi',
    'devisDepl.confirmDelete': 'Supprimer ce devis ?',
    'devisDepl.searchPlaceholder': 'Rechercher par ref, nom, email...',
    'devisDepl.noResults': 'Aucun résultat',
    'devisDepl.empty': 'Aucun devis créé',
    'devisDepl.travelFeeLabel': 'Frais de déplacement',
    'devisDepl.invalidAmount': 'Montant invalide',
    'devisDepl.errPayment': 'Erreur paiement',
    'devisDepl.confirmStaffAccept': 'Valider ce devis ? Un bon de commande et une facture seront créés.',
    'devisDepl.errValidation': 'Erreur validation',
    'devisDepl.reminderSent': 'Relance envoyée',
    'devisDepl.errSendReminder': 'Erreur envoi relance',
    'devisDepl.confirmValidateBon': 'Valider le bon de commande ?',
    'devisDepl.errSendFacture': 'Erreur envoi facture',
    'devisDepl.confirmDetach': 'Détacher ce devis de la réparation {{ref}} ?',
    'devisDepl.status.pending': 'En attente',
    'devisDepl.status.accepted': 'Accepté',
    'devisDepl.status.refused': 'Refusé',
    'devisDepl.status.depositPaid': 'Acompte versé',
    'devisDepl.status.paid': 'Payé',
    'devisDepl.stats.total': 'Total',
    'devisDepl.stats.pending': 'En attente',
    'devisDepl.stats.accepted': 'Acceptés',
    'devisDepl.stats.refused': 'Refusés',
    'devisDepl.stats.revenue': 'Revenus',
    'devisDepl.filter.all': 'Tous les statuts',
    'devisDepl.requests.title': 'Demandes de devis entrantes',
    'devisDepl.requests.newCountSingular': '{{count}} nouvelle',
    'devisDepl.requests.newCountPlural': '{{count}} nouvelles',
    'devisDepl.requests.defaultTitle': 'Demande de devis',
    'devisDepl.requests.statusNew': 'Nouveau',
    'devisDepl.requests.statusInProgress': 'En cours',
    'devisDepl.requests.statusRefused': 'Refusé',
    'devisDepl.requests.statusTreated': 'Traité',
    'devisDepl.requests.client': 'Client',
    'devisDepl.requests.addressLabel': 'Adresse',
    'devisDepl.requests.createDevis': 'Créer devis',
    'devisDepl.requests.markTreated': 'Traité',
    'devisDepl.requests.refuse': 'Refuser',
    'devisDepl.requests.refuseMotifLabel': 'Motif du refus',
    'devisDepl.requests.refuseMotifPlaceholder': 'Raison du refus (optionnel)...',
    'devisDepl.requests.confirmRefuse': 'Confirmer le refus',
    'devisDepl.requests.refuseMotifShownLabel': 'Motif du refus :',
    'devisDepl.sumup.title': 'Demandes de lien SumUp',
    'devisDepl.sumup.pendingCount': '{{count}} en attente',
    'devisDepl.sumup.enterLinkAlert': 'Veuillez saisir le lien SumUp',
    'devisDepl.sumup.linkSentAlert': 'Lien SumUp envoyé au client par email !',
    'devisDepl.sumup.linkPlaceholder': 'Coller le lien SumUp ici...',
    'devisDepl.chart.title': 'Activité des 30 derniers jours',
    'devisDepl.chart.accepted': 'Acceptés',
    'devisDepl.chart.pending': 'En attente',
    'devisDepl.chart.refused': 'Refusés',
    'devisDepl.chart.noData': 'Pas de données pour cette période',
    'devisDepl.form.editTitle': 'Modifier le devis',
    'devisDepl.form.newTitle': 'Nouveau devis',
    'devisDepl.form.clientName': 'Nom client *',
    'devisDepl.form.searchPlaceholder': 'Tapez pour rechercher...',
    'devisDepl.form.phone': 'Téléphone',
    'devisDepl.form.email': 'Email *',
    'devisDepl.form.emailPlaceholder': 'email@exemple.com',
    'devisDepl.form.address': 'Adresse',
    'devisDepl.form.addressPlaceholder': 'Adresse du client',
    'devisDepl.form.descriptionLabel': 'Description de la réparation',
    'devisDepl.form.descriptionPlaceholder': 'Description du travail à effectuer...',
    'devisDepl.form.lines': 'Lignes du devis',
    'devisDepl.form.addLine': 'Ajouter',
    'devisDepl.form.designation': 'Désignation',
    'devisDepl.form.price': 'Prix',
    'devisDepl.form.travelFee': 'Frais de déplacement ({{amount}})',
    'devisDepl.form.acceptOnline': 'Accepter paiement en ligne (SumUp)',
    'devisDepl.form.acceptOnlineHint': 'Le client pourra demander un lien de paiement SumUp',
    'devisDepl.form.total': 'TOTAL',
    'devisDepl.form.submitEdit': 'Modifier',
    'devisDepl.form.submitCreate': 'Créer le devis',
    'devisDepl.form.nameEmailRequired': 'Nom et email client obligatoires',
    'devisDepl.form.atLeastOneLine': 'Ajoutez au moins une ligne avec désignation et prix',
    'devisDepl.detail.phone': 'Tél:',
    'devisDepl.detail.address': 'Adresse:',
    'devisDepl.detail.purchaseOrder': 'Bon de commande:',
    'devisDepl.detail.invoice': 'Facture:',
    'devisDepl.detail.emailSentOn': 'Email envoyé le {{date}}',
    'devisDepl.detail.reminderSentOn': 'Rappel envoyé le {{date}}',
    'devisDepl.table.designation': 'Désignation',
    'devisDepl.table.qty': 'Qté',
    'devisDepl.table.price': 'Prix',
    'devisDepl.table.total': 'Total',
    'devisDepl.actions.validateDevis': 'Valider le devis',
    'devisDepl.actions.sendByEmail': 'Envoyer devis par email',
    'devisDepl.actions.remindAcceptance': 'Relancer acceptation',
    'devisDepl.actions.edit': 'Modifier',
    'devisDepl.actions.validateBon': 'Valider bon de commande',
    'devisDepl.actions.bonValidated': 'Bon validé',
    'devisDepl.actions.remindPayment': 'Relancer paiement',
    'devisDepl.actions.pdfDevis': 'PDF Devis',
    'devisDepl.actions.pdfBon': 'PDF Bon de commande',
    'devisDepl.actions.pdfFacture': 'PDF Facture',
    'devisDepl.actions.sendFactureEmail': 'Envoyer facture par email',
    'devisDepl.actions.registerPayment': 'Enregistrer paiement',
    'devisDepl.actions.delete': 'Supprimer',
    'devisDepl.actions.linkedTo': 'Lié à {{ref}}',
    'devisDepl.actions.attachToRepair': 'Attacher à réparation',
    'devisDepl.payment.title': 'Enregistrer un paiement',
    'devisDepl.payment.devisLabel': 'Devis:',
    'devisDepl.payment.totalLabel': 'Total:',
    'devisDepl.payment.methodLabel': 'Mode de paiement',
    'devisDepl.payment.cash': 'Espèces',
    'devisDepl.payment.card': 'CB',
    'devisDepl.payment.transfer': 'Virement',
    'devisDepl.payment.mixed': 'Mixte',
    'devisDepl.payment.amount': 'Montant',
    'devisDepl.payment.noteLabel': 'Note (optionnel)',
    'devisDepl.payment.notePlaceholder': 'Ex: acompte, solde...',
    'devisDepl.payment.submit': 'Valider le paiement',
    'reviews.ratingFallback': 'Nos clients nous évaluent sur Google',
    'reviews.subtitle': 'Découvrez les retours de nos clients sur Google et partagez votre expérience.',
    'reviews.readCta': 'Lire nos avis sur Google',
    'reviews.writeCta': 'Laisser un avis',
    'acompteStart.title': 'Acompte de votre devis',
    'acompteStart.subtitle': 'Resurrection Mobile · paiement sécurisé SumUp',
    'acompteStart.loading': 'Préparation du paiement…',
    'acompteStart.redirecting': 'Redirection vers la page de paiement',
    'acompteStart.clickHere': 'Cliquez ici si rien ne se passe.',
    'acompteStart.paid': 'Cet acompte a déjà été réglé. Merci ! Votre commande est en cours de préparation.',
    'acompteStart.orderRef': 'Commande {{ref}}',
    'acompteStart.errTitle': 'Paiement en ligne momentanément indisponible',
    'acompteStart.retry': 'Réessayer',
    'acompteStart.whatsappPay': 'Régler par WhatsApp / nous contacter',
    'acompteStart.inStore': 'L\'acompte peut aussi être réglé directement en boutique.',
    'acompteStart.footer': 'Après paiement, votre commande de pièce est enregistrée automatiquement et un reçu vous est envoyé par e-mail.',
    'acompteStart.backToSite': 'Retour au site',
    'acompteStart.errLinkUnavailable': 'Lien de paiement indisponible.',
    'acompteStart.errOnlineUnavailable': 'Le paiement en ligne est momentanément indisponible.',
    'acompteStart.waMessage': 'Bonjour, je souhaite régler l\'acompte de mon devis ({{id}}).',
    'emailVerif.loadingTitle': 'Vérification en cours...',
    'emailVerif.loadingSub': 'Veuillez patienter',
    'emailVerif.successTitle': 'Compte activé !',
    'emailVerif.successDefault': 'E-mail vérifié avec succès !',
    'emailVerif.login': 'Se connecter',
    'emailVerif.errorTitle': 'Erreur de vérification',
    'emailVerif.errorDefault': 'Erreur de vérification',
    'emailVerif.invalidLink': 'Lien de vérification invalide.',
    'emailVerif.backLogin': 'Retour à la connexion',
    'emailVerif.expiredTitle': 'Lien expiré',
    'emailVerif.expiredDefault': 'Ce lien a expiré.',
    'emailVerif.backLoginResend': 'Retour à la connexion (renvoyer l\'e-mail)',
    'paySuccess.noPaymentToVerify': 'Aucun paiement à vérifier',
    'paySuccess.statusCheckFailed': 'Impossible de vérifier le statut. Le paiement sera traité automatiquement.',
    'paySuccess.verificationError': 'Erreur lors de la vérification du paiement',
    'paySuccess.completedTitle': 'Paiement réussi !',
    'paySuccess.completedDesc': 'Votre paiement a été confirmé et appliqué à votre dossier.',
    'paySuccess.failedTitle': 'Paiement échoué',
    'paySuccess.failedDesc': 'Le paiement n\'a pas pu être traité. Veuillez réessayer.',
    'paySuccess.pendingTitle': 'Paiement en cours de traitement',
    'paySuccess.pendingDesc': 'Votre paiement est en cours de vérification. Il sera appliqué automatiquement.',
    'paySuccess.verifying': 'Vérification du paiement en cours...',
    'paySuccess.errorTitle': 'Erreur',
    'paySuccess.amountLabel': 'Montant :',
    'paySuccess.repairLabel': 'Réparation :',
    'paySuccess.orderLabel': 'Commande :',
    'paySuccess.referenceLabel': 'Référence :',
    'paySuccess.noInfo': 'Aucune information de paiement disponible.',
    'paySuccess.backToSpace': 'Retour à mon espace',
    'devisChat.errStart': 'Impossible de démarrer le chat. Réessayez.',
    'devisChat.errSend': 'Erreur d\'envoi',
    'devisChat.errNetwork': 'Erreur réseau',
    'devisChat.hint': 'Demande ton devis par mail',
    'devisChat.fabAria': 'Demander un devis',
    'devisChat.fabLabel': 'Devis gratuit',
    'devisChat.panelTitle': 'Devis R.E.Mobiles',
    'devisChat.panelSubtitle': 'Envoi par e-mail après validation',
    'devisChat.close': 'Fermer',
    'devisChat.connecting': 'Connexion…',
    'devisChat.inputPlaceholder': 'Ex. écran iPhone 13…',
    'register.emailRequired': 'L\'email est obligatoire pour créer un compte.',
    'register.passwordMinLength': 'Le mot de passe doit contenir au moins 4 caractères.',
    'register.passwordMismatch': 'Les mots de passe ne correspondent pas.',
    'register.registerError': 'Erreur lors de l\'inscription',
    'register.verifyEmailTitle': 'Vérifiez votre email !',
    'register.confirmationSentTo': 'Un email de confirmation a été envoyé à :',
    'register.activateHint': 'Cliquez sur le lien dans l\'email pour activer votre compte. Vérifiez aussi vos spams si vous ne le voyez pas.',
    'register.goToLogin': 'Aller à la connexion',
    'register.clientSubtitle': 'Accédez au suivi de vos réparations',
    'register.namePlaceholder': 'Jean Dupont',
    'register.emailPlaceholder': 'email@exemple.com',
    'register.emailHint': 'Un email de confirmation sera envoyé pour activer votre compte',
    'register.addressPlaceholder': '123 Rue Exemple',
    'register.password': 'Mot de passe',
    'register.confirmPassword': 'Confirmer le mot de passe',
    'register.referralCode': 'Code de parrainage (optionnel)',
    'register.referredBy': 'Parrainé par {{nom}}',
    'register.invalidReferral': 'Code de parrainage invalide',
    'register.termsNotice': 'En créant un compte, vous acceptez nos conditions d\'utilisation',
    'login.googleDisabled': 'La connexion Google a été désactivée. Utilisez votre identifiant et mot de passe.',
    'login.invalid2FA': 'Code 2FA invalide',
    'login.tabStaff': 'Staff',
    'login.tabClient': 'Client',
    'login.tabBusiness': 'Entreprise',
    'login.frenchGuiana': 'Guyane Française',
    'login.emailNotVerifiedTitle': 'E-mail non vérifié',
    'login.emailNotVerifiedDesc': 'Vous devez confirmer votre e-mail avant de vous connecter.',
    'login.emailResent': 'E-mail renvoyé ! Vérifiez votre boîte mail.',
    'login.sending': 'Envoi en cours...',
    'login.resendVerification': 'Renvoyer l\'e-mail de confirmation',
    'login.back': 'Retour',
    'login.twoFATitle': 'Vérification 2FA',
    'login.twoFASubtitle': 'Entrez le code de votre application',
    'login.verifying': 'Vérification...',
    'login.verify': 'Vérifier',
    'login.passwordPlaceholder': 'Votre mot de passe',
    'login.allRightsReserved': 'Tous droits réservés.',
    'acompteSuccess.errorIncompleteLink': 'Lien de paiement incomplet.',
    'acompteSuccess.errorCannotConfirm': 'Impossible de confirmer le paiement pour le moment.',
    'acompteSuccess.whatsappMessage': 'Bonjour, j\'ai payé l\'acompte de mon devis (réf. {{ref}}). Pouvez-vous confirmer ma commande ?',
    'acompteSuccess.whatsappDefault': 'Nous écrire sur WhatsApp',
    'acompteSuccess.errorHint': 'Si votre paiement a bien été débité, votre commande sera enregistrée automatiquement dans les minutes qui suivent et vous recevrez un e-mail de confirmation.',
    'acompteSuccess.appliedTitle': 'Acompte reçu',
    'acompteSuccess.orderRegisteredLead': 'Merci. Votre commande pièce',
    'acompteSuccess.orderRegisteredTail': 'est enregistrée. Un reçu vous a été envoyé par e-mail ; vous recevrez le numéro de suivi dès expédition.',
    'acompteSuccess.staffPendingTitle': 'Paiement reçu',
    'acompteSuccess.staffPendingBody': 'Votre acompte est bien enregistré chez SumUp. Notre équipe finalise votre commande manuellement et vous confirme par e-mail très rapidement.',
    'acompteSuccess.whatsappQuestion': 'Une question ? WhatsApp',
    'acompteSuccess.sumupFailedTitle': 'Paiement non abouti',
    'acompteSuccess.sumupFailedBody': 'SumUp n\'a pas confirmé le paiement ({{status}}). Vous pouvez réessayer depuis le lien de votre e-mail de devis, ou nous contacter.',
    'acompteSuccess.timedOutTitle': 'Confirmation en cours',
    'acompteSuccess.timedOutBody': 'SumUp n\'a pas encore confirmé votre paiement. Pas d\'inquiétude : si le débit a eu lieu, votre commande sera créée automatiquement dans les minutes qui suivent et vous recevrez un e-mail de confirmation. Vous pouvez fermer cette page.',
    'acompteSuccess.recheckNow': 'Revérifier maintenant',
    'acompteSuccess.whatsappProof': 'Envoyer la preuve de paiement sur WhatsApp',
    'acompteSuccess.verifyingTitle': 'Vérification du paiement…',
    'acompteSuccess.verifyingBody': 'Merci de patienter quelques secondes.',
    'acompteSuccess.backHome': 'Retour à l\'accueil',
    'b2bDashboard.acceptRefuse': 'Accepter / Refuser',
    'b2bDashboard.actions': 'Actions',
    'b2bDashboard.addNotePlaceholder': 'Ajouter une note sur cette réparation...',
    'b2bDashboard.addPhoto': '+ Ajouter',
    'b2bDashboard.additionalInfoPlaceholder': 'Informations complémentaires...',
    'b2bDashboard.additionalNotes': 'Notes supplémentaires',
    'b2bDashboard.addressOptional': 'Adresse (optionnel)',
    'b2bDashboard.addressPlaceholder': 'Adresse pour déplacement si nécessaire',
    'b2bDashboard.alertDescribeRequest': 'Veuillez décrire votre demande',
    'b2bDashboard.amount': 'Montant',
    'b2bDashboard.awaitingReceptionStore': 'En attente de réception en boutique',
    'b2bDashboard.back': 'Retour',
    'b2bDashboard.backGlass': 'Vitre arrière',
    'b2bDashboard.backGlassBroken': 'Vitre arrière cassée',
    'b2bDashboard.backGlassIntact': 'Vitre arrière intacte',
    'b2bDashboard.brandModelRequired': 'Marque et modèle sont obligatoires',
    'b2bDashboard.broken': 'Cassée',
    'b2bDashboard.changePassword': 'Modifier le mot de passe',
    'b2bDashboard.chat': 'Discuter',
    'b2bDashboard.clear': 'Effacer',
    'b2bDashboard.clickNewRequestHint': 'Cliquez sur « Nouvelle demande » pour en créer une',
    'b2bDashboard.clickToAddPhotos': 'Cliquez pour ajouter des photos',
    'b2bDashboard.code': 'Code',
    'b2bDashboard.code6Digits': 'Code à 6 chiffres',
    'b2bDashboard.codeDigitsLetters': 'Code (chiffres/lettres)',
    'b2bDashboard.codeValidatedSuccess': 'Code validé avec succès !',
    'b2bDashboard.confirmOrderEmailPre': 'Un bon de commande avec un code de confirmation a été envoyé à votre e-mail. Saisissez ce code dans la section ',
    'b2bDashboard.confirmOrderEmailPost': ' pour valider votre commande.',
    'b2bDashboard.createdOn': 'Créée le',
    'b2bDashboard.customerProvidesPart': 'Je fournis la pièce',
    'b2bDashboard.date': 'Date',
    'b2bDashboard.delivery': 'Livraison',
    'b2bDashboard.delivery.pickup': 'Récupération',
    'b2bDashboard.delivery.postal': 'Envoi postal',
    'b2bDashboard.delivery.store': 'En boutique',
    'b2bDashboard.describeProblemPlaceholder': 'Décrivez le problème...',
    'b2bDashboard.designation': 'Désignation',
    'b2bDashboard.device': 'Appareil',
    'b2bDashboard.devisStatus.accepted': 'Accepté',
    'b2bDashboard.devisStatus.depositPaid': 'Acompte versé',
    'b2bDashboard.devisStatus.paid': 'Payé',
    'b2bDashboard.devisStatus.pending': 'En attente',
    'b2bDashboard.devisStatus.refused': 'Refusé',
    'b2bDashboard.diagRef': 'Réf diag :',
    'b2bDashboard.documentsWord': 'Documents',
    'b2bDashboard.downloadError': 'Erreur lors du téléchargement',
    'b2bDashboard.downloadPdf': 'Télécharger le PDF',
    'b2bDashboard.enter6DigitCode': 'Saisissez le code à 6 chiffres',
    'b2bDashboard.enterCodePerOrder': 'Saisissez le code reçu par e-mail pour valider chaque bon de commande.',
    'b2bDashboard.enterCodeToValidate': 'Entrez le code reçu par e-mail pour valider votre commande.',
    'b2bDashboard.enterPinPlaceholder': 'Saisir le code PIN, mot de passe...',
    'b2bDashboard.enterValidationCode': 'Veuillez entrer le code de validation',
    'b2bDashboard.error': 'Erreur',
    'b2bDashboard.filter.all': 'Toutes',
    'b2bDashboard.history': 'Historique',
    'b2bDashboard.imeiSerial': 'IMEI / N° série',
    'b2bDashboard.imeiSerialShort': 'IMEI / Série',
    'b2bDashboard.incorrectCode': 'Code incorrect',
    'b2bDashboard.invoiceLabel': 'Facture :',
    'b2bDashboard.invoiceType.combined': 'Comb',
    'b2bDashboard.invoiceType.diag': 'Diag',
    'b2bDashboard.invoiceType.repair': 'Répar',
    'b2bDashboard.invoices': 'Factures',
    'b2bDashboard.invoicesAppearWhenPriced': 'Les factures apparaissent dès que le prix est fixé par R.E.Mobiles',
    'b2bDashboard.latePayment': 'RETARD DE PAIEMENT - {{days}} jours',
    'b2bDashboard.lock': 'Verrou',
    'b2bDashboard.lockCode': 'Code de verrouillage',
    'b2bDashboard.mostRecent': 'Plus récentes',
    'b2bDashboard.nav.documents': 'Devis / Factures',
    'b2bDashboard.nav.quoteRequest': 'Demander un devis',
    'b2bDashboard.newQuoteRequest': 'Nouvelle demande de devis',
    'b2bDashboard.newRequest': 'Nouvelle demande',
    'b2bDashboard.noInvoiceAvailable': 'Aucune facture disponible',
    'b2bDashboard.noPhoto': 'Aucune photo',
    'b2bDashboard.noPosInvoice': 'Aucune facture d\'achat',
    'b2bDashboard.noQuoteRequest': 'Aucune demande de devis',
    'b2bDashboard.noTravelQuote': 'Aucun devis de déplacement',
    'b2bDashboard.nonFunctionalParts': 'Pièces non fonctionnelles',
    'b2bDashboard.noteSaveError': 'Erreur lors de la sauvegarde de la note',
    'b2bDashboard.notes': 'Notes',
    'b2bDashboard.oldest': 'Plus anciennes',
    'b2bDashboard.optional': 'Optionnel',
    'b2bDashboard.orderValidated': 'Bon de commande validé',
    'b2bDashboard.orderValidatedSuccess': 'Bon de commande validé !',
    'b2bDashboard.orderValidationCode': 'Code de validation du bon de commande',
    'b2bDashboard.paid': 'Payée',
    'b2bDashboard.paidLabel': 'Payé',
    'b2bDashboard.partProvidedByStore': 'La pièce sera fournie par R.E.Mobiles',
    'b2bDashboard.parts.backCam': 'Caméra arrière',
    'b2bDashboard.parts.backGlass': 'Vitre arrière',
    'b2bDashboard.parts.battery': 'Batterie',
    'b2bDashboard.parts.chargingPort': 'Port charge',
    'b2bDashboard.parts.earSpeaker': 'Écouteur',
    'b2bDashboard.parts.fingerprint': 'Empreinte',
    'b2bDashboard.parts.frontCam': 'Caméra avant',
    'b2bDashboard.parts.homeButton': 'Accueil',
    'b2bDashboard.parts.lcd': 'Écran',
    'b2bDashboard.parts.microphone': 'Micro',
    'b2bDashboard.parts.powerButton': 'Power',
    'b2bDashboard.parts.signal': 'Signal',
    'b2bDashboard.parts.speaker': 'Haut-parleur',
    'b2bDashboard.parts.volumeButton': 'Volume',
    'b2bDashboard.parts.wifiBt': 'Wi-Fi/BT',
    'b2bDashboard.pattern': 'Schéma',
    'b2bDashboard.pay': 'Payer',
    'b2bDashboard.payRemaining': 'Payer le reste ({{amount}})',
    'b2bDashboard.paymentCreateError': 'Erreur lors de la création du paiement',
    'b2bDashboard.paymentLinkUnavailable': 'Lien de paiement non disponible. Contactez R.E.Mobiles.',
    'b2bDashboard.pdfDownloadError': 'Erreur lors du téléchargement du PDF',
    'b2bDashboard.pdfInvoice': 'PDF Facture',
    'b2bDashboard.pdfPurchaseOrder': 'PDF Bon de commande',
    'b2bDashboard.pdfQuote': 'PDF Devis',
    'b2bDashboard.penaltiesLine': 'Pénalités : {{penalty}} + Indemnité : {{indemnity}}',
    'b2bDashboard.photos': 'Photos',
    'b2bDashboard.pickupAddress': 'Adresse de récupération',
    'b2bDashboard.pickupAddressPlaceholder': 'Adresse complète où récupérer le téléphone...',
    'b2bDashboard.pickupAddressRequired': 'Veuillez saisir l\'adresse de récupération',
    'b2bDashboard.pickupRequested': 'Récupération demandée - nous viendrons chercher l\'appareil',
    'b2bDashboard.posInvoices': 'Factures d\'achat (POS)',
    'b2bDashboard.price': 'Prix',
    'b2bDashboard.priceCol': 'Prix',
    'b2bDashboard.priceDiagnostic': 'Prix diagnostic',
    'b2bDashboard.pricePending': 'En attente - sera fixé par R.E.Mobiles',
    'b2bDashboard.priceRepair': 'Prix réparation',
    'b2bDashboard.problem': 'Problème',
    'b2bDashboard.problemDescription': 'Problème / Description',
    'b2bDashboard.purchaseOrderLabel': 'Bon de commande :',
    'b2bDashboard.quoteRequestTitle': 'Demande de devis',
    'b2bDashboard.refusalReason': 'Motif du refus :',
    'b2bDashboard.remaining': 'Reste',
    'b2bDashboard.repairAcceptedByStaff': 'Réparation acceptée par le staff',
    'b2bDashboard.repairRefusedByStaff': 'Réparation refusée par le staff',
    'b2bDashboard.repairTitle': 'Réparation {{ref}}',
    'b2bDashboard.requestDescription': 'Description de votre demande',
    'b2bDashboard.requestDescriptionPlaceholder': 'Décrivez ce que vous souhaitez : type de réparation, quantité, problèmes, etc.',
    'b2bDashboard.requestStatus.inProgress': 'En cours',
    'b2bDashboard.requestStatus.new': 'Nouveau',
    'b2bDashboard.requestStatus.processed': 'Traité',
    'b2bDashboard.requestStatus.refused': 'Refusé',
    'b2bDashboard.retentionInvoices': 'Les factures sont conservées sur nos serveurs pendant une durée de 18 mois.',
    'b2bDashboard.retentionQuotes': 'Les devis sont conservés sur nos serveurs pendant une durée de 1 mois.',
    'b2bDashboard.saveNote': 'Enregistrer la note',
    'b2bDashboard.saving': 'Enregistrement...',
    'b2bDashboard.searchPlaceholder': 'Rechercher...',
    'b2bDashboard.sendRequest': 'Envoyer ma demande',
    'b2bDashboard.sending': 'Envoi...',
    'b2bDashboard.status.awaitingParts': 'Att. Pièces',
    'b2bDashboard.status.awaitingPickup': 'Att. récupération',
    'b2bDashboard.status.awaitingReception': 'Att. réception',
    'b2bDashboard.status.completed': 'Terminé',
    'b2bDashboard.status.delivered': 'Livré',
    'b2bDashboard.status.inProgress': 'En Cours',
    'b2bDashboard.status.received': 'Reçu',
    'b2bDashboard.status.refused': 'Refusé',
    'b2bDashboard.statusCol': 'Statut',
    'b2bDashboard.submitError': 'Erreur lors de la soumission',
    'b2bDashboard.teamResponse': 'Réponse équipe :',
    'b2bDashboard.titleOptional': 'Titre (optionnel)',
    'b2bDashboard.titlePlaceholder': 'Ex : Réparation lot écrans Samsung',
    'b2bDashboard.total': 'Total',
    'b2bDashboard.totalDue': 'Total dû : {{amount}}',
    'b2bDashboard.trackingBadge': 'Suivi :',
    'b2bDashboard.trackingNumber': 'Numéro de suivi',
    'b2bDashboard.trackingPlaceholder': 'Ex : 1Z999AA10123456784',
    'b2bDashboard.trackingRequired': 'Veuillez saisir le numéro de suivi pour l\'envoi postal',
    'b2bDashboard.trackingShort': 'N° suivi',
    'b2bDashboard.travelFee': 'Frais de déplacement',
    'b2bDashboard.travelQuotes': 'Devis Déplacement',
    'b2bDashboard.uploadError': 'Erreur lors de l\'upload',
    'b2bDashboard.uploading': 'Upload...',
    'b2bDashboard.validate': 'Valider',
    'b2bDashboard.validationCodeConfirmed': 'Code de validation confirmé',
    'client.mySpace': 'Mon Espace',
    'client.invoiceDownloadError': 'Erreur lors du téléchargement de la facture',
    'client.invoiceViewError': 'Erreur lors de l\'affichage de la facture',
    'client.invoicePrintError': 'Erreur lors de l\'impression de la facture',
    'client.pinMustBe4': 'Le code PIN doit contenir 4 chiffres',
    'client.pinMismatch': 'Les codes PIN ne correspondent pas',
    'client.pinChanged': 'Code PIN modifié avec succès !',
    'client.pinChangeError': 'Erreur lors du changement de PIN',
    'client.describeRequest': 'Veuillez décrire votre demande',
    'client.error': 'Erreur',
    'client.enterValidationCode': 'Veuillez entrer le code de validation',
    'client.codeValidated': 'Code validé avec succès !',
    'client.codeIncorrect': 'Code incorrect',
    'client.sumupUrlUnavailable': 'Erreur : URL de paiement SumUp non disponible',
    'client.sumupCreateError': 'Erreur lors de la création du paiement SumUp',
    'client.fillRequired': 'Veuillez remplir tous les champs obligatoires',
    'client.invalidEmail': 'Adresse email invalide',
    'client.requestError': 'Erreur lors de la demande',
    'client.trackingSaved': 'Numéro de suivi enregistré !',
    'client.statusText.recu': 'Appareil reçu en atelier',
    'client.statusText.enCours': 'Réparation en cours',
    'client.statusText.attentePieces': 'En attente de pièces',
    'client.statusText.termine': 'Réparation terminée - À récupérer',
    'client.statusText.livre': 'Appareil récupéré',
    'client.statusText.demandeEnLigne': 'En attente de réception de l\'appareil',
    'client.statusText.nonReparable': 'Appareil non réparable',
    'client.statusLabel.recu': 'Reçu',
    'client.statusLabel.enCours': 'En cours',
    'client.statusLabel.attentePieces': 'Attente pièces',
    'client.statusLabel.termine': 'Terminé',
    'client.statusLabel.livre': 'Livré',
    'client.statusLabel.recupere': 'Récupéré',
    'client.statusLabel.demandeEnLigne': 'Demande en ligne',
    'client.statusLabel.nonReparable': 'Non réparable',
    'client.created': 'Créé',
    'client.technicianNotes': 'Notes du technicien',
    'client.noNotes': 'Aucune note pour le moment',
    'client.file': 'fichier',
    'client.files': 'fichiers',
    'client.navigation': 'Navigation',
    'client.devisFactures': 'Devis / Factures',
    'client.myAddresses': 'Mes adresses',
    'client.myAccount': 'Mon compte',
    'client.needHelp': 'Besoin d\'aide ?',
    'client.helpHours': 'Notre équipe est à votre écoute du lundi au samedi de 9h à 19h.',
    'client.contactUs': 'Nous contacter',
    'client.contactSupport': 'Contacter le support',
    'client.guideMe': 'Guide-moi',
    'client.logout': 'Déconnexion',
    'client.changePassword': 'Modifier le mot de passe',
    'client.addresses': 'Adresses',
    'client.requestRepair': 'Demander une réparation',
    'client.showDelivered': 'Voir livrés',
    'client.hideDelivered': 'Masquer livrés',
    'client.noRepairsInProgress': 'Aucune réparation en cours',
    'client.onlineRepairRequest': 'Demande de réparation en ligne',
    'client.diagFeeFormPre': 'Remplissez le formulaire ci-dessous. Des frais de diagnostic de',
    'client.diagFeeFormPost': 'seront à régler en ligne.',
    'client.repairReason': 'Motif de réparation',
    'client.repairReasonPlaceholder': 'Ex : Écran cassé, batterie...',
    'client.fullName': 'Nom et Prénom',
    'client.fullNamePlaceholder': 'Votre nom complet',
    'client.postalAddress': 'Adresse postale',
    'client.addressPlaceholder': 'Votre adresse',
    'client.emailAddress': 'Adresse email',
    'client.emailPlaceholder': 'email@exemple.com',
    'client.describeIssue': 'Décrivez la panne en détail',
    'client.describeIssuePlaceholder': 'Racontez comment le téléphone/tablette est tombé en panne, les symptômes observés...',
    'client.devicePhotos': 'Photos de l\'appareil',
    'client.addPhotos': 'Ajouter des photos',
    'client.cancel': 'Annuler',
    'client.sending': 'Envoi...',
    'client.sendRequest': 'Envoyer la demande',
    'client.requestSaved': 'Demande enregistrée : {{ref}}',
    'client.redirecting': 'Redirection...',
    'client.payDiagnosticSumup': 'Payer {{amount}} avec SumUp (diagnostic)',
    'client.diagFeePending': 'Votre demande est en attente. Pour lancer le diagnostic, veuillez régler les frais de',
    'client.depositOrSend': 'Déposez votre appareil en boutique ou envoyez-le par La Poste avec accusé de réception :',
    'client.trackingPlaceholder': 'Numéro de suivi postal',
    'client.save': 'Enregistrer',
    'client.postalDelayNotice': 'Si envoi postal : le délai passe à 20 jours avant expiration de la demande (40 jours pour suppression)',
    'client.close': 'Fermer',
    'client.progress': 'Progression',
    'client.deposits': 'Acomptes',
    'client.rest': 'Reste',
    'client.payWithSumup': 'Payer {{amount}} avec SumUp',
    'client.detailedTracking': 'Suivi détaillé',
    'client.chatRepair': 'Chat réparation {{ref}}',
    'client.contact': 'Contacter',
    'client.photosCount': 'Photos ({{count}})',
    'client.level': 'Niveau {{name}}',
    'client.tierOr': 'Or',
    'client.tierArgent': 'Argent',
    'client.tierBronze': 'Bronze',
    'client.totalPurchases': '{{count}} achat(s) au total',
    'client.nextLevel': 'Prochain niveau :',
    'client.purchasesToNext': '{{count}} achat(s) restant(s)',
    'client.rewardAvailable': 'Récompense disponible !',
    'client.reward10Reached': 'Félicitations, vous avez atteint {{count}} achats',
    'client.rewardPosDesc': 'sur votre prochain achat en magasin',
    'client.rewardRepairDesc': 'sur votre prochaine réparation',
    'client.loyaltyPoints': 'Points fidélité',
    'client.purchasesUntilReward': 'Plus que {{count}} achat(s) avant la récompense',
    'client.rewardReached': 'Récompense atteinte !',
    'client.rewardsHistory': 'Historique récompenses',
    'client.reward15Pos': '-15% POS',
    'client.reward10Repair': '-10% Réparation',
    'client.referralProgram': 'Programme de Parrainage',
    'client.referralSubtitle': 'Partagez votre code et gagnez des points bonus',
    'client.yourReferralCode': 'Votre code de parrainage',
    'client.copied': 'Copié !',
    'client.copy': 'Copier',
    'client.referralShare1': 'Partagez ce code à vos proches. Quand ils s\'inscrivent avec, vous gagnez',
    'client.referralBonusPoints': '+2 points',
    'client.referralShare2': 'de fidélité !',
    'client.copyReferralLink': 'Copier le lien d\'inscription',
    'client.referrals': 'Filleul(s)',
    'client.bonusPoints': 'Points bonus',
    'client.yourReferrals': 'Vos filleuls',
    'client.referralFallback': 'Filleul',
    'client.myDevis': 'Mes Devis',
    'client.newRequest': 'Nouvelle demande',
    'client.newDevisRequest': 'Nouvelle demande de devis',
    'client.titleOptional': 'Titre (optionnel)',
    'client.devisTitlePlaceholder': 'Ex : Réparation écran iPhone 15',
    'client.requestDescription': 'Description de votre demande',
    'client.devisDescPlaceholder': 'Décrivez ce que vous souhaitez : type de réparation, problème, etc.',
    'client.addressOptional': 'Adresse (optionnel, pour déplacement)',
    'client.devisAddressPlaceholder': 'Votre adresse si vous souhaitez un déplacement',
    'client.sendMyRequest': 'Envoyer ma demande',
    'client.myDevisRequests': 'Mes demandes de devis',
    'client.devisRequestTitle': 'Demande de devis',
    'client.devisReqNouveau': 'Nouveau',
    'client.devisReqEnCours': 'En cours',
    'client.devisReqRefuse': 'Refusé',
    'client.devisReqTraite': 'Traité',
    'client.teamResponse': 'Réponse équipe :',
    'client.refusalReason': 'Motif du refus :',
    'client.clickNewRequest': 'Cliquez sur « Nouvelle demande » pour en créer une',
    'client.designation': 'Désignation',
    'client.price': 'Prix',
    'client.travelFees': 'Frais de déplacement',
    'client.totalUpper': 'TOTAL',
    'client.paid': 'Payé',
    'client.purchaseOrder': 'Bon de commande',
    'client.invoice': 'Facture',
    'client.latePayment': 'RETARD DE PAIEMENT - {{days}} jours',
    'client.latePenaltyLabel': 'Pénalités de retard ({{rate}}% annuel)',
    'client.recoveryIndemnity': 'Indemnité forfaitaire de recouvrement',
    'client.totalWithPenalties': 'Total dû avec pénalités',
    'client.validationCodeTitle': 'Code de validation du bon de commande',
    'client.validationCodeDesc': 'Entrez le code reçu par email pour valider votre commande.',
    'client.code6digits': 'Code à 6 chiffres',
    'client.validate': 'Valider',
    'client.codeConfirmed': 'Code de validation confirmé',
    'client.pdfDevis': 'PDF Devis',
    'client.pdfPurchaseOrder': 'PDF Bon de commande',
    'client.pdfInvoice': 'PDF Facture',
    'client.payRest': 'Payer le reste ({{amount}})',
    'client.deposit50': 'Acompte 50%',
    'client.fullPayment': 'Paiement complet',
    'client.myInvoices': 'Mes Factures',
    'client.mostRecent': 'Plus récentes',
    'client.oldest': 'Plus anciennes',
    'client.noInvoices': 'Aucune facture disponible',
    'client.view': 'Voir',
    'client.print': 'Imprimer',
    'client.seeLess': 'Voir moins',
    'client.seeMoreInvoices': 'Voir plus ({{count}} factures)',
    'client.invoiceRetention': 'Les factures sont conservées sur nos serveurs pendant une durée de 18 mois.',
    'client.devisRetention': 'Les devis sont conservés sur nos serveurs pendant une durée de 1 mois.',
    'client.createCaricature': 'Je crée ma caricature',
    'client.copyrightBy': 'Copyright by',
    'client.notifications': 'Notifications',
    'client.markAllRead': 'Tout marquer lu',
    'client.noNotifications': 'Aucune notification',
    'client.pinChangeTitle': 'Changement de code PIN',
    'client.pinChangeDesc': 'Pour votre sécurité, veuillez choisir un nouveau code PIN à 4 chiffres.',
    'client.newPin': 'Nouveau code PIN',
    'client.confirmPin': 'Confirmer le PIN',
    'client.modifying': 'Modification...',
    'client.changePin': 'Changer mon code PIN',
    'client.proofSent': 'Preuve de paiement envoyée ! Le staff va la vérifier.',
    'client.sendError': 'Erreur lors de l\'envoi',
    'client.orderStatusEnAttente': 'En attente',
    'client.orderStatusPayee': 'Payée',
    'client.orderStatusProofUploaded': 'Preuve envoyée',
    'client.orderStatusConfirmee': 'Confirmée',
    'client.orderStatusPreparee': 'Préparée',
    'client.orderStatusExpediee': 'Expédiée',
    'client.orderStatusLivree': 'Livrée',
    'client.orderStatusAnnulee': 'Annulée',
    'client.trackingNumber': 'Numéro de suivi :',
    'client.trackingHint': 'Utilisez ce numéro pour suivre votre colis',
    'client.stepCommande': 'Commande',
    'client.proofSentLabel': 'Preuve de paiement envoyée',
    'client.sentOn': 'Envoyée le',
    'client.validatedByStaff': 'Validée par le staff',
    'client.payWithSumupPlain': 'Payer avec SumUp',
    'client.sendProof': 'Envoyer une preuve de paiement (capture)',
    'client.history': 'Historique',
    'client.chatOrder': 'Chat commande {{ref}}',
    'client.homeLabel': 'Domicile',
    'client.enterFullAddress': 'Veuillez saisir votre adresse complète.',
    'client.saveError': 'Erreur lors de l\'enregistrement',
    'client.addressLabelField': 'Libellé',
    'client.labelPlaceholder': 'Domicile, Bureau...',
    'client.phone': 'Téléphone',
    'client.phonePlaceholder': '06 94 ...',
    'client.recipient': 'Destinataire',
    'client.recipientPlaceholder': 'Nom du destinataire',
    'client.deliveryAddress': 'Adresse de livraison',
    'client.addressInputPlaceholder': 'Saisissez votre adresse complète',
    'client.freeAddressHint': 'Saisie libre : sélectionnez une suggestion si elle apparaît, sinon tapez simplement votre adresse.',
    'client.searching': 'Recherche...',
    'client.addressValidated': 'Adresse validée',
    'client.saving': 'Enregistrement...',
    'client.confirmDeleteAddress': 'Supprimer cette adresse ?',
    'client.manageAddressesSubtitle': 'Gérez vos adresses de livraison',
    'client.addAddress': 'Ajouter une adresse',
    'client.newAddress': 'Nouvelle adresse',
    'client.editAddress': 'Modifier l\'adresse',
    'client.default': 'Par défaut',
    'client.edit': 'Modifier',
    'client.delete': 'Supprimer',
    'client.setDefault': 'Définir par défaut',
    'client.selectAddress': 'Veuillez sélectionner ou ajouter une adresse de livraison.',
    'client.orderSuccess': 'Commande passée avec succès !',
    'client.orderError': 'Erreur lors de la commande',
    'client.ourAccessories': 'Nos accessoires',
    'client.expertSelection': 'Sélection testée par nos experts',
    'client.allCategories': 'Toutes les catégories',
    'client.cart': 'Panier',
    'client.noArticles': 'Aucun article disponible',
    'client.inStock': 'En stock',
    'client.unavailable': 'Indisponible',
    'client.add': 'Ajouter',
    'client.myCart': 'Mon panier',
    'client.articleSingular': 'article',
    'client.articlesPlural': 'articles',
    'client.cartEmpty': 'Votre panier est vide',
    'client.manage': 'Gérer',
    'client.processing': 'Traitement...',
    'client.payOnDelivery': 'Paiement à la livraison',
    'publicShop.status.en_attente': 'En attente',
    'publicShop.status.en_cours': 'En cours',
    'publicShop.status.termine': 'Terminé',
    'publicShop.status.pret': 'Prêt',
    'publicShop.status.livre': 'Livré',
    'publicShop.status.annule': 'Annulé',
    'publicShop.repairNotFound': 'Réparation non trouvée',
    'publicShop.shopNotFound': 'Boutique non trouvée',
    'publicShop.trackTitle': 'Suivre ma réparation',
    'publicShop.trackSubtitle': 'Entrez votre numéro de série ou code de suivi',
    'publicShop.trackPlaceholder': 'Numéro de série ou code de suivi...',
    'publicShop.trackButton': 'Suivre',
    'publicShop.labelDateEntree': 'Date d\'entrée:',
    'publicShop.labelSortiePrevue': 'Sortie prévue:',
    'publicShop.labelProbleme': 'Problème:',
    'publicShop.labelRemarques': 'Remarques:',
    'publicShop.poweredBy': 'Propulsé par {{brand}}',
    'invoiceRequest.subtitle': 'Demande de facture',
    'invoiceRequest.search.title': 'Rechercher votre achat',
    'invoiceRequest.search.hint': 'Saisissez le montant exact et l\'heure approximative.',
    'invoiceRequest.search.amountLabel': 'Montant payé (EUR)',
    'invoiceRequest.search.amountPlaceholder': 'Ex : 25.00',
    'invoiceRequest.search.timeLabel': 'Heure',
    'invoiceRequest.search.dateLabel': 'Date',
    'invoiceRequest.search.loading': 'Recherche…',
    'invoiceRequest.search.submit': 'Rechercher',
    'invoiceRequest.results.title': 'Sélectionnez votre achat',
    'invoiceRequest.results.paidLabel': 'Payé :',
    'invoiceRequest.itemsCount': '{{count}} article(s)',
    'invoiceRequest.back': 'Retour',
    'invoiceRequest.form.title': 'Vos informations',
    'invoiceRequest.form.purchase': 'Achat',
    'invoiceRequest.form.alreadyPaid': 'Déjà payé',
    'invoiceRequest.form.payment': 'Paiement',
    'invoiceRequest.form.remaining': 'Reste',
    'invoiceRequest.form.nameLabel': 'Nom complet',
    'invoiceRequest.form.namePlaceholder': 'Jean Dupont',
    'invoiceRequest.form.emailLabel': 'Adresse email',
    'invoiceRequest.form.emailPlaceholder': 'jean@exemple.com',
    'invoiceRequest.form.phoneLabel': 'Téléphone',
    'invoiceRequest.form.phonePlaceholder': '0694XXXXXX',
    'invoiceRequest.form.sending': 'Envoi en cours…',
    'invoiceRequest.form.submit': 'Envoyer la facture',
    'invoiceRequest.pending.title': 'Demande en attente',
    'invoiceRequest.pending.desc': 'Cette facture a déjà été envoyée à une autre adresse.',
    'invoiceRequest.pending.validationRequired': 'Validation requise',
    'invoiceRequest.pending.info': 'Votre demande a été transmise à notre équipe. Vous recevrez la facture à {{email}} une fois validée.',
    'invoiceRequest.newRequest': 'Nouvelle demande',
    'invoiceRequest.success.title': 'Facture envoyée !',
    'invoiceRequest.success.desc': 'Votre facture a été envoyée à {{email}}.',
    'invoiceRequest.success.accountCreated': 'Compte client créé !',
    'invoiceRequest.success.newAccountDesc': 'Vos identifiants de connexion ont été envoyés à {{email}}.',
    'invoiceRequest.success.sendingCredentials': 'Envoi…',
    'invoiceRequest.success.resendCredentials': 'Recevoir mes identifiants par mail',
    'invoiceRequest.success.credentialsSent': 'Identifiants envoyés à {{email}}',
    'invoiceRequest.success.trackRepairs': 'Suivre mes réparations',
    'invoiceRequest.footer': 'R.E.Mobiles — 102 Avenue Général de Gaulle, Porte 2, 97300 Cayenne',
    'invoiceRequest.errors.search': 'Erreur de recherche',
    'invoiceRequest.errors.notFound': 'Aucune vente trouvée pour ce montant et cette heure. Vérifiez les informations.',
    'invoiceRequest.errors.send': 'Erreur lors de l\'envoi',
    'invoiceRequest.errors.generic': 'Erreur',
    'storefront.notfound.title': 'Entreprise introuvable',
    'storefront.notfound.desc': 'Cette entreprise n\'existe pas ou n\'est plus active.',
    'storefront.notfound.back': 'Retour à l\'accueil',
    'storefront.tab.track': 'Suivre ma réparation',
    'storefront.tab.login': 'Espace client',
    'storefront.track.title': 'Suivi de réparation',
    'storefront.track.subtitle': 'Entrez votre référence pour suivre l\'avancement de votre réparation',
    'storefront.track.format': 'Format de référence :',
    'storefront.track.submit': 'Suivre',
    'storefront.track.not_found': 'Réparation introuvable',
    'storefront.track.ref': 'Référence',
    'storefront.track.device': 'Appareil',
    'storefront.track.problem': 'Problème',
    'storefront.track.date_in': 'Date d\'entrée',
    'storefront.track.date_out': 'Date de sortie prévue',
    'storefront.status.waiting': 'En attente',
    'storefront.status.in_progress': 'En cours',
    'storefront.status.done': 'Terminé',
    'storefront.status.delivered': 'Livré',
    'storefront.status.cancelled': 'Annulé',
    'storefront.status.unknown': 'Inconnu',
    'storefront.login.title': 'Connexion client',
    'storefront.login.subtitle': 'Connectez-vous à votre espace client chez {{name}}',
    'storefront.login.phone': 'Téléphone',
    'storefront.login.pin': 'Code PIN',
    'storefront.login.error_fields': 'Entrez votre téléphone et votre code PIN (4 ou 6 chiffres)',
    'storefront.login.error_invalid': 'Identifiants incorrects',
    'storefront.login.loading': 'Connexion...',
    'storefront.login.submit': 'Se connecter',
    'storefront.login.create_account': 'Pas encore de compte ? Créer un compte',
    'storefront.register.title': 'Créer un compte',
    'storefront.register.subtitle': 'Inscrivez-vous chez {{name}}',
    'storefront.register.name': 'Nom complet',
    'storefront.register.name_ph': 'Jean Dupont',
    'storefront.register.phone': 'Téléphone',
    'storefront.register.email': 'Email (optionnel)',
    'storefront.register.email_ph': 'email@exemple.com',
    'storefront.register.pin': 'Code PIN',
    'storefront.register.pin_confirm': 'Confirmer le PIN',
    'storefront.register.error_required': 'Nom et téléphone obligatoires',
    'storefront.register.error_pin_short': 'Le PIN doit contenir au moins 4 chiffres',
    'storefront.register.error_pin_mismatch': 'Les PIN ne correspondent pas',
    'storefront.register.error_generic': 'Erreur lors de la création du compte',
    'storefront.register.loading': 'Création...',
    'storefront.register.submit': 'Créer mon compte',
    'storefront.register.back_to_login': 'Déjà un compte ? Se connecter',
    'landing.svcScreenTitle': 'Écran cassé',
    'landing.svcScreenDesc': 'Remplacement écran iPhone, Samsung, Huawei',
    'landing.svcBatteryTitle': 'Batterie',
    'landing.svcBatteryDesc': 'Remplacement batterie toutes marques',
    'landing.svcConnectorTitle': 'Connecteur',
    'landing.svcConnectorDesc': 'Connecteur de charge, jack audio',
    'landing.svcCameraTitle': 'Caméra',
    'landing.svcCameraDesc': 'Caméra avant et arrière',
    'landing.svcOxidationTitle': 'Désoxydation',
    'landing.svcOxidationDesc': 'Téléphone tombé dans l’eau',
    'landing.svcDiagTitle': 'Diagnostic',
    'landing.svcDiagDesc': '35 à 80 € selon l’appareil · devis gratuit',
    'landing.tip1': '**Bonjour !** Je peux suivre votre réparation ou vous donner une estimation.',
    'landing.tip2': '**Garantie 6 mois** sur toutes nos réparations, pièces et main-d’œuvre.',
    'landing.tip3': '**Diagnostic** de 35 à 80 € selon l’appareil, annoncé avant de commencer.',
    'landing.tip4': 'Tombé dans l’eau ? **Éteignez-le** et venez vite : désoxydation en atelier.',
    'landing.tip5': 'Suivez votre réparation en direct avec votre référence **REM0001**.',
    'landing.tip6': '**Micro-soudure** et récupération de données, même si l’appareil ne s’allume plus.',
    'landing.tip7': 'Ouvert **lun–ven 9h–19h** et **sam 9h–14h**, dépôt sans rendez-vous.',
    'landing.tip8': '**Devis gratuit** en ligne, envoyé par e-mail après validation.',
    'landing.tip9': 'Professionnels : un **Espace Entreprise** dédié (portail B2B).',
    'landing.tip10': 'iPhone, Samsung, Huawei, Xiaomi, tablettes et **consoles** : on répare tout.',
    'landing.tipFromPrice': 'à partir de {{price}} — prix confirmé en boutique.',
    'landing.guideMe': 'Guide-moi',
    'landing.flashUntil': 'Jusqu’au {{date}}',
    'landing.cadbotTitle': 'CADBOT, votre assistant',
    'landing.cadbotDesc': 'Suivi de réparation, estimation de devis, horaires — il vous répond directement sur le site. Le prix définitif est toujours confirmé en boutique.',
    'landing.servicesTitle': 'Nos Services de Réparation',
    'landing.servicesDesc': 'Réparation express de smartphones et tablettes à Cayenne, Guyane Française',
    'landing.seeAllPrices': 'Voir tous nos tarifs',
    'landing.readBlog': 'Lire notre blog',
    'landing.diagTitle': 'Diagnostic en boutique',
    'landing.diagDesc': 'De 35 à 80 € selon l’appareil. Le tarif vous est annoncé avant de commencer. Le devis en ligne reste gratuit.',
    'landing.tierFrom': 'dès',
    'landing.tierUpTo': 'jusqu’à',
    'landing.tierEntryTitle': 'Entrée et milieu de gamme',
    'landing.tierEntryDesc': 'Panne simple et identifiée',
    'landing.tierRecentTitle': 'Smartphones récents',
    'landing.tierRecentDesc': 'Plusieurs symptômes à vérifier',
    'landing.tierComplexTitle': 'Cas complexes',
    'landing.tierComplexDesc': 'Dégât des eaux, micro-soudure, consoles, tablettes',
    'landing.enlarge': 'Agrandir',
    'landing.storePhotoAlt': 'Notre boutique Resurrection Mobile à Cayenne',
    'landing.storeTag': 'Notre boutique · Cayenne',
    'landing.enlargedPhoto': 'Photo agrandie',
    'landing.close': 'Fermer',
    'landing.storePhotoAltSimple': 'Boutique Resurrection Mobile',
    'landing.freeQuote': 'Devis gratuit',
    'privacy.title': 'Politique de confidentialité',
    'privacy.last_updated': 'Dernière mise à jour : 19 mars 2026',
    'privacy.intro.part1': 'La présente Politique de confidentialité décrit comment ',
    'privacy.intro.part2': ' (« nous », « notre », « nos ») collecte, utilise, conserve et protège les données personnelles des utilisateurs (« vous », « votre ») conformément au ',
    'privacy.intro.rgpd': 'Règlement Général sur la Protection des Données (RGPD — UE 2016/679)',
    'privacy.intro.part3': ' applicable en France et en Guyane française.',
    'privacy.s1.title': 'Responsable du traitement',
    'privacy.s1.company_label': 'Entreprise',
    'privacy.s1.status_label': 'Statut',
    'privacy.s1.controller_note': 'Le responsable du traitement est la personne ou l\'entité qui détermine les finalités et les moyens du traitement de vos données personnelles.',
    'privacy.s2.title': 'Données personnelles collectées',
    'privacy.s2.sub1_title': '2.1 Données d\'identification',
    'privacy.s2.sub1_b1': 'Nom et prénom',
    'privacy.s2.sub1_b2': 'Adresse postale',
    'privacy.s2.sub1_b3': 'Numéro de téléphone',
    'privacy.s2.sub1_b4': 'Adresse email',
    'privacy.s2.sub1_b5': 'Nom de l\'entreprise (si professionnel)',
    'privacy.s2.sub2_title': '2.2 Données liées aux services',
    'privacy.s2.sub2_b1': 'Informations sur les appareils confiés (marque, modèle, IMEI, numéro de série)',
    'privacy.s2.sub2_b2': 'Historique des réparations',
    'privacy.s2.sub2_b3': 'Commandes, devis et factures',
    'privacy.s2.sub2_b4': 'Signatures électroniques',
    'privacy.s2.sub3_title': '2.3 Données de paiement',
    'privacy.s2.sub3_b1': 'Informations de transaction',
    'privacy.s2.sub3_b2': 'Moyen de paiement utilisé',
    'privacy.s2.payment_important_label': 'Important :',
    'privacy.s2.payment_important_text': 'Nous ne stockons jamais vos données bancaires complètes. Les paiements sont traités par des prestataires sécurisés (Stripe).',
    'privacy.s2.sub4_title': '2.4 Données techniques',
    'privacy.s2.sub4_b1': 'Adresse IP',
    'privacy.s2.sub4_b2': 'Données de connexion',
    'privacy.s2.sub4_b3': 'Cookies et traceurs',
    'privacy.s2.sub4_b4': 'Données de navigation',
    'privacy.s3.title': 'Finalités du traitement',
    'privacy.s3.b1': 'Fournir nos services de réparation et de vente',
    'privacy.s3.b2': 'Gérer les commandes, devis et facturation',
    'privacy.s3.b3': 'Assurer le suivi client et le service après-vente',
    'privacy.s3.b4': 'Communiquer avec vous (SMS, email, téléphone)',
    'privacy.s3.b5': 'Respecter nos obligations légales et comptables',
    'privacy.s3.b6': 'Améliorer nos services et la sécurité',
    'privacy.s3.b7': 'Prévenir la fraude',
    'privacy.s4.title': 'Base légale du traitement',
    'privacy.s4.intro': 'Conformément au RGPD, les traitements reposent sur :',
    'privacy.s4.i1': 'L\'exécution d\'un contrat',
    'privacy.s4.i2': 'Le respect d\'obligations légales',
    'privacy.s4.i3': 'Votre consentement (ex : marketing)',
    'privacy.s4.i4': 'Notre intérêt légitime (sécurité, amélioration)',
    'privacy.s5.title': 'Destinataires des données',
    'privacy.s5.b1': 'Nos employés habilités',
    'privacy.s5.b2': 'Nos prestataires techniques (hébergement, paiement, SMS, email)',
    'privacy.s5.b3': 'Les autorités administratives ou judiciaires si la loi l\'exige',
    'privacy.s5.no_sale': 'Aucune donnée personnelle n\'est vendue à des tiers.',
    'privacy.s6.title': 'Transfert hors Union européenne',
    'privacy.s6.text': 'Si certains prestataires sont situés hors UE, nous nous assurons qu\'ils offrent un niveau de protection adéquat conforme au RGPD (clauses contractuelles types, décisions d\'adéquation, etc.).',
    'privacy.s7.title': 'Durée de conservation',
    'privacy.s7.r1_label': 'Données clients',
    'privacy.s7.r1_value': '5 ans après la dernière relation commerciale',
    'privacy.s7.r2_label': 'Données de facturation',
    'privacy.s7.r2_value': '10 ans (obligation légale)',
    'privacy.s7.r3_label': 'Données marketing',
    'privacy.s7.r3_value': 'Jusqu\'au retrait du consentement',
    'privacy.s7.r4_label': 'Cookies',
    'privacy.s7.r4_value': 'Maximum 13 mois',
    'privacy.s8.title': 'Sécurité des données',
    'privacy.s8.intro': 'Nous mettons en œuvre des mesures techniques et organisationnelles appropriées :',
    'privacy.s8.b1': 'Accès restreint aux données',
    'privacy.s8.b2': 'Hébergement sécurisé',
    'privacy.s8.b3': 'Chiffrement lorsque nécessaire',
    'privacy.s8.b4': 'Sauvegardes régulières',
    'privacy.s8.b5': 'Protection contre les accès non autorisés',
    'privacy.s9.title': 'Vos droits',
    'privacy.s9.intro': 'Conformément au RGPD, vous disposez des droits suivants :',
    'privacy.s9.r1': 'Droit d\'accès',
    'privacy.s9.r2': 'Droit de rectification',
    'privacy.s9.r3': 'Droit à l\'effacement (« droit à l\'oubli »)',
    'privacy.s9.r4': 'Droit à la limitation du traitement',
    'privacy.s9.r5': 'Droit d\'opposition',
    'privacy.s9.r6': 'Droit à la portabilité des données',
    'privacy.s9.r7': 'Droit de retirer votre consentement',
    'privacy.s9.exercise': 'Pour exercer vos droits, contactez-nous à :',
    'privacy.s9.complaint_before': 'Vous pouvez également introduire une réclamation auprès de la ',
    'privacy.s9.complaint_after': '.',
    'privacy.s10.title': 'Cookies',
    'privacy.s10.intro': 'Notre site peut utiliser des cookies pour :',
    'privacy.s10.b1': 'Assurer le fonctionnement du site',
    'privacy.s10.b2': 'Mesurer l\'audience',
    'privacy.s10.b3': 'Améliorer l\'expérience utilisateur',
    'privacy.s10.manage': 'Vous pouvez gérer vos préférences via votre navigateur ou notre bandeau cookies.',
    'privacy.s11.title': 'Données des mineurs',
    'privacy.s11.text': 'Nos services ne sont pas destinés aux mineurs sans autorisation parentale. Si des données d\'un mineur ont été collectées par erreur, veuillez nous contacter pour leur suppression.',
    'privacy.s12.title': 'Modifications de la politique',
    'privacy.s12.text': 'Nous pouvons modifier cette Politique à tout moment afin de refléter les évolutions légales ou techniques. La version en vigueur est celle publiée sur notre site.',
    'privacy.s13.title': 'Contact',
    'privacy.s13.intro': 'Pour toute question relative à cette Politique ou à vos données personnelles :',
    'privacy.footer': 'En utilisant nos services, vous reconnaissez avoir pris connaissance de la présente Politique de confidentialité.',
    'track.title': 'Suivre ma réparation',
    'track.label_ref': 'Référence',
    'track.label_device': 'Appareil',
    'track.label_received': 'Reçu le',
    'track.label_expected': 'Sortie prévue',
    'track.label_completed': 'Terminé le',
    'track.label_amount': 'Montant',
    'track.status_pending': 'En attente',
    'track.see_full': 'Voir le détail complet',
    'track.input_placeholder': 'Entrez votre référence (ex: REM0001)',
    'track.btn_track': 'Suivre',
    'track.scan_qr': 'Scanner le QR code de mon ticket',
    'track.err_invalid_ref': 'Référence invalide. Format attendu : REM0001',
    'track.err_not_found': 'Réparation introuvable',
    'chatWidget.statusStaffOnline': 'Équipe en ligne',
    'chatWidget.statusAiActive': 'IA active — réponse automatique',
    'chatWidget.statusOffline': 'Hors ligne — laissez un message',
    'chatWidget.launcherLabel': 'Chat & Aide',
    'chatWidget.tabStaff': 'Chat Support',
    'chatWidget.tabAi': 'Aide IA',
    'chatWidget.newMessage': 'Nouveau message',
    'chatWidget.loading': 'Chargement...',
    'chatWidget.noConversations': 'Aucune conversation',
    'chatWidget.emptyConvoHint': 'Cliquez sur « {{action}} » pour nous contacter',
    'chatWidget.conversationFallback': 'Conversation',
    'chatWidget.autoReplyTitle': 'Mode auto-réponse IA actif',
    'chatWidget.autoReplyDesc': 'L\'équipe est hors ligne. L\'IA répond en attendant.',
    'chatWidget.staffEmptyTitle': 'Envoyez un message à l\'équipe',
    'chatWidget.staffEmptyDesc': 'Nous vous répondons au plus vite',
    'chatWidget.aiAssistant': 'Assistant IA',
    'chatWidget.badgeAuto': 'auto',
    'chatWidget.badgeQuoteIndicative': 'devis indicatif',
    'chatWidget.badgeQuotePending': 'devis en préparation',
    'chatWidget.supportFallback': 'Support',
    'chatWidget.sending': 'Envoi en cours...',
    'chatWidget.staffInputPlaceholder': 'Votre message...',
    'chatWidget.interactiveGuides': 'Guides interactifs',
    'chatWidget.stepsCount': '{{count}} étapes',
    'chatWidget.faqTitle': 'Questions fréquentes',
    'chatWidget.back': 'Retour',
    'chatWidget.stepProgress': 'Étape {{current}} / {{total}}',
    'chatWidget.previous': 'Précédent',
    'chatWidget.next': 'Suivant',
    'chatWidget.finish': 'Terminer',
    'chatWidget.aiInputPlaceholder': 'Posez votre question...',
    'chatWidget.aiError': 'Désolé, une erreur est survenue.',
    'chatWidget.me': 'Moi',
    'chatWidget.newConversationSubject': 'Nouvelle conversation',
    'hours.title': 'Horaires d\'ouverture',
    'hours.rows.weekdays.label': 'Lundi - Vendredi',
    'hours.rows.weekdays.hours': '9h - 19h',
    'hours.rows.saturday.label': 'Samedi',
    'hours.rows.saturday.hours': '9h - 14h',
    'hours.rows.sunday.label': 'Dimanche',
    'hours.closed': 'Fermé',
    'hours.unit.hour': 'h',
    'hours.unit.minute': 'min',
    'hours.unit.second': 's',
    'hours.clock': 'il est {{time}} à Cayenne',
    'hours.ring.dayProgress': 'de la journée',
    'hours.ring.untilReopen': 'avant réouverture',
    'hours.state.openNow': 'Ouvert maintenant',
    'hours.state.closingSoon': 'Ferme bientôt',
    'hours.state.closed': 'Fermé',
    'hours.count.untilClose': 'avant la fermeture ({{hour}} h)',
    'hours.count.untilOpen': 'avant l’ouverture',
    'hours.sub.openSince': 'Ouvert depuis {{duration}}',
    'hours.sub.nextOpen': 'Prochaine ouverture : {{when}} à {{hour}} h',
    'hours.when.today': 'aujourd’hui',
    'hours.when.tomorrow': 'demain',
    'hours.mood.closingSoon': '⏳ Dernière ligne droite — on vous attend encore un peu !',
    'hours.mood.justOpened': '☕ On vient d’ouvrir — passez nous voir !',
    'hours.mood.open': '🟢 C’est ouvert, passez quand vous voulez !',
    'hours.mood.opensSoon': '🚪 On ouvre dans moins d’une heure — le rideau se lève bientôt !',
    'hours.mood.sundayRest': '🌴 Dimanche, c’est repos — on se retrouve lundi à 9 h !',
    'hours.mood.morning': '🌅 Bonjour ! On ouvre à {{hour}} h, préparez vos appareils.',
    'hours.mood.evening': '🌙 C’est fermé pour ce soir — à très vite !',
    'hours.dayName.0': 'dimanche',
    'hours.dayName.1': 'lundi',
    'hours.dayName.2': 'mardi',
    'hours.dayName.3': 'mercredi',
    'hours.dayName.4': 'jeudi',
    'hours.dayName.5': 'vendredi',
    'hours.dayName.6': 'samedi',
    'cadbot.welcome': 'Bonjour, je suis **CADBOT**, l\'assistant de Resurrection Mobile. Tapez votre référence **REM0001** pour suivre votre réparation, ou décrivez votre panne pour une estimation.',
    'cadbot.chip.status': 'Où en est ma réparation ?',
    'cadbot.chip.screen': 'Écran iPhone 11 cassé, combien ?',
    'cadbot.chip.battery': 'Batterie Galaxy S21, prix ?',
    'cadbot.chip.diagnostic': 'Le diagnostic coûte combien ?',
    'cadbot.chip.hours': 'Horaires et adresse ?',
    'cadbot.note': 'Les estimations sont indicatives et toujours confirmées en boutique. Le devis détaillé est envoyé par e-mail après validation par notre équipe.',
    'cadbot.status.online': 'en ligne',
    'cadbot.resume.label': 'Reprendre ma conversation',
    'cadbot.resume.title': 'Afficher la conversation commencée dans cet onglet',
    'cadbot.reset.label': 'Nouvelle conversation',
    'cadbot.reset.title': 'Effacer cette conversation et recommencer',
    'cadbot.input.label': 'Votre message',
    'cadbot.input.placeholderIdentity': 'Votre nom, téléphone ou e-mail…',
    'cadbot.input.placeholderDefault': 'REM0001, écran iPhone 13, batterie…',
    'cadbot.send.aria': 'Envoyer',
    'cadbot.local.greeting': 'Bonjour ! Je suis **CADBOT**. Je peux suivre votre réparation (référence REM0001), estimer un devis, ou vous donner nos horaires.',
    'cadbot.local.diagnostic': 'Le diagnostic en boutique va de {{min}} à {{max}} selon l\'appareil et la complexité. Le tarif vous est annoncé avant de commencer. Le devis en ligne, lui, est gratuit.',
    'cadbot.local.water': 'Éteignez-le et ne le rechargez pas, puis apportez-le au plus vite en boutique. La désoxydation est établie sur devis après diagnostic.',
    'cadbot.local.hoursLine': 'Nous sommes au **{{address}}**. Horaires : {{hours}}. {{state}}',
    'cadbot.local.hoursOpen': '**{{state}}** — {{time}} {{countLabel}}.',
    'cadbot.local.hoursClosed': '**Fermé** — {{sub}}.',
    'cadbot.local.closedLower': 'fermé',
    'cadbot.local.warranty': 'Toutes nos réparations sont garanties **6 mois**, pièces et main-d\'œuvre.',
    'cadbot.local.accounts': 'Les accès sont juste au-dessus : **Espace Client** (suivi de vos réparations), **Espace Entreprise** (portail B2B) et **Espace Staff**.',
    'cadbot.local.trackAsk': 'Indiquez votre référence au format **REM0001** (elle figure sur votre ticket de dépôt) et je vous donne l\'avancement.',
    'cadbot.local.quoteFollowup': 'Votre devis vous est envoyé par e-mail dès validation par notre équipe (pensez à vérifier les spams). Sans nouvelle sous 24 h, écrivez-nous sur WhatsApp au **{{phone}}**.',
    'cadbot.local.contact': 'Vous pouvez nous joindre au **{{phone}}** (appel & WhatsApp).',
    'cadbot.track.here': 'Voici le suivi de **{{ref}}** :',
    'cadbot.track.notFound': 'Je ne trouve pas la réparation **{{ref}}**. Vérifiez la référence sur votre ticket de dépôt.',
    'cadbot.track.unavailable': 'Le suivi est momentanément indisponible, réessayez dans un instant.',
    'cadbot.server.ackDefault': 'Merci, un technicien vous répond très vite.',
    'cadbot.error.rateLimit': 'Trop de demandes d\'un coup — patientez {{wait}} puis réessayez.',
    'cadbot.error.waitMinutes': '{{n}} min',
    'cadbot.error.waitFallback': 'une minute',
    'cadbot.error.server': 'Je n\'arrive pas à joindre le serveur. Écrivez-nous sur WhatsApp au **{{phone}}**.',
    // ── tarifs.* (pilote i18n 2026-09-12 — à relire) ──
    'tarifs.back': 'Accueil',
    'tarifs.searchPlaceholder': 'Rechercher un modèle ou un type de réparation…',
    'tarifs.loading': 'Chargement des tarifs…',
    'tarifs.updateTitle': 'Tarifs en cours d\'actualisation',
    'tarifs.updateDesc': 'Nos tarifs sont en cours de mise à jour. Contactez-nous pour un devis gratuit et personnalisé.',
    'tarifs.call': 'Appeler',
    'tarifs.callPrefix': 'Appeler : ',
    'tarifs.callNow': 'Appeler maintenant',
    'tarifs.noResult': 'Aucun résultat',
    'tarifs.soon': 'Tarifs bientôt disponibles',
    'tarifs.tryOther': 'Essayez avec d\'autres termes',
    'tarifs.contactFree': 'Contactez-nous pour un devis gratuit',
    'tarifs.repairBrand': 'Réparation {{brand}}',
    'tarifs.tariffsCount': '{{count}} tarif(s) disponible(s)',
    'tarifs.colModel': 'Modèle',
    'tarifs.colRepair': 'Réparation',
    'tarifs.colPrice': 'Tarif',
    'tarifs.colDelay': 'Délai',
    'tarifs.allModels': 'Tous modèles',
    'tarifs.whatsapp': 'WhatsApp',
    'tarifs.portal': 'Portail Client',
    'tarifs.faqTitle': 'Questions fréquentes',
    'tarifs.titleFallback': 'Tarifs Réparation Téléphone',
    'tarifs.subtitleFallback': 'Découvrez nos tarifs de réparation pour iPhone, Samsung, Huawei et plus. Réparation rapide et garantie à Cayenne, Guyane Française.',
    'tarifs.ctaTitleFallback': 'Besoin d\'un devis personnalisé ?',
    'tarifs.ctaDescFallback': 'Chaque réparation est unique. Contactez-nous pour un diagnostic gratuit et un devis précis adapté à votre situation.',
    _name: 'Français',
    _flag: '🇫🇷',
    // Nav
    'nav.dashboard': 'Dashboard',
    'nav.pos': 'Point de vente',
    'nav.calcul': 'Calcul Prix',
    'nav.devis': 'Devis / Factures',
    'nav.devisDeplacement': 'Devis Déplacement',
    'nav.commandes': 'Commandes',
    'nav.addDevice': 'Ajouter appareil',
    'nav.reparations': 'Réparations',
    'nav.clients': 'Clients',
    'nav.stock': 'Stock',
    'nav.addStock': 'Ajouter Stock',
    'nav.etiquettes': 'Étiquettes',
    'nav.users': 'Utilisateurs',
    'nav.clientPwd': 'MDP Clients',
    'nav.boutiqueOrders': 'Commandes Boutique',
    'nav.caisseHistory': 'Historique Caisse',
    'nav.database': 'Base de données',
    'nav.historique': 'Historique',
    'nav.paiements': 'Paiements en ligne',
    'nav.chatClients': 'Chat Clients',
    'nav.chat': 'Messagerie',
    'nav.notes': 'Notes',
    'nav.logout': 'Déconnexion',
    'nav.quit': 'Quitter',
    'nav.admin': 'Administration',
    'nav.navigation': 'Navigation',
    'nav.b2b': 'Gestion B2B',
    'nav.b2bPayments': 'Paiements B2B',
    'nav.brandsModels': 'Marques & Modèles',
    'nav.activityHub': 'Centre Activité',
    'nav.salesHistory': 'Historique des ventes',
    'nav.equipeMagasins': 'Équipe & magasins',
    'nav.usersLegacy': 'Utilisateurs (legacy)',
    // Common
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.search': 'Rechercher',
    'common.add': 'Ajouter',
    'common.close': 'Fermer',
    'common.confirm': 'Confirmer',
    'common.loading': 'Chargement...',
    'common.noData': 'Aucune donnée',
    'common.actions': 'Actions',
    'common.status': 'Statut',
    'common.date': 'Date',
    'common.total': 'Total',
    'common.print': 'Imprimer',
    'common.yes': 'Oui',
    'common.no': 'Non',
    'common.back': 'Retour',
    'common.next': 'Suivant',
    'common.validate': 'Valider',
    'common.ref': 'Référence',
    'common.client': 'Client',
    'common.phone': 'Téléphone',
    'common.email': 'Email',
    'common.price': 'Prix',
    'common.quantity': 'Quantité',
    'common.amount': 'Montant',
    'common.send': 'Envoyer',
    'common.download': 'Télécharger',
    'common.export': 'Exporter',
    'common.refresh': 'Actualiser',
    'common.filter': 'Filtrer',
    'common.all': 'Tous',
    'common.name': 'Nom',
    'common.address': 'Adresse',
    'common.description': 'Description',
    'common.payment': 'Paiement',
    'common.paid': 'Payé',
    'common.pending': 'En attente',
    'common.accepted': 'Accepté',
    'common.refused': 'Refusé',
    // Layout
    'layout.panel': 'Panel de gestion',
    // POS
    'pos.title': 'Point de Vente',
    'pos.scanner': 'Scanner',
    'pos.searchProduct': 'Rechercher un produit (réf, nom, code-barres)...',
    'pos.outOfStock': 'Hors stock',
    'pos.article': 'Article',
    'pos.unitPrice': 'Prix unit.',
    'pos.qty': 'Qté',
    'pos.emptyCart': 'Panier vide',
    'pos.checkout': 'Encaissement',
    'pos.clientOptional': 'Client (optionnel)',
    'pos.discount': 'Remise',
    'pos.subtotal': 'Sous-total',
    'pos.validateSale': 'Valider la vente',
    'pos.paymentMode': 'Mode de paiement',
    'pos.choosePayment': 'Choisissez le mode de paiement :',
    'pos.cash': 'Espèces',
    'pos.card': 'Carte Bancaire',
    'pos.mixed': 'Mixte',
    'pos.totalToCollect': 'Total à encaisser',
    'pos.change': 'Rendu monnaie',
    'pos.confirmPayment': 'Confirmer le paiement',
    'pos.validating': 'Validation...',
    'pos.lastTicket': 'Dernier ticket',
    'pos.caisseClosed': 'La caisse est fermée. Veuillez l\'ouvrir depuis le Dashboard pour effectuer des ventes.',
    'pos.insufficientCash': 'Montant espèces insuffisant',
    'pos.insufficientCard': 'Montant CB insuffisant',
    'pos.mixedMustEqual': 'Le paiement mixte doit être égal au total',
    'pos.emptyCartAlert': 'Panier vide',
    'pos.selectPayment': 'Veuillez choisir un mode de paiement',
    'pos.saleValidated': 'Vente validée!',
    'pos.adminOverride': 'Validation administrateur',
    'pos.outOfStockProduct': 'Produit en rupture',
    'pos.adminId': 'Identifiant admin',
    'pos.adminCode': 'Code admin',
    'pos.manualAdd': 'Ajouter un article hors stock',
    'pos.designation': 'Désignation',
    'pos.stockInsufficient': 'Stock insuffisant',
    // Devis
    'devis.title': 'Devis & Factures',
    'devis.subtitle': 'Documents issus du calcul prix (convertibles en commande).',
    'devis.noDoc': 'Aucun document trouvé',
    'devis.type': 'Type',
    'devis.convertConfirm': 'Transformer ce devis en commande ?',
    'devis.orderCreated': 'Commande créée',
    'devis.deleteConfirm': 'Supprimer ce document ?',
    'devis.deleted': 'Document supprimé',
    // Devis Déplacement
    'devDep.title': 'Devis Déplacement',
    'devDep.subtitle': 'Gestion des devis pour réparations à domicile',
    'devDep.new': 'Nouveau devis',
    'devDep.edit': 'Modifier le devis',
    'devDep.clientName': 'Nom client',
    'devDep.clientPhone': 'Téléphone',
    'devDep.clientEmail': 'Email',
    'devDep.clientAddress': 'Adresse',
    'devDep.repairDesc': 'Description de la réparation',
    'devDep.lines': 'Lignes du devis',
    'devDep.addLine': 'Ajouter',
    'devDep.travelFee': 'Frais de déplacement',
    'devDep.sendByEmail': 'Envoyer par email',
    'devDep.sending': 'Envoi...',
    'devDep.pdfDevis': 'PDF Devis',
    'devDep.pdfBon': 'PDF Bon de commande',
    'devDep.pdfFacture': 'PDF Facture',
    'devDep.searchPlaceholder': 'Rechercher par ref, nom, email...',
    'devDep.allStatuses': 'Tous les statuts',
    'devDep.pending': 'En attente',
    'devDep.accepted': 'Accepté',
    'devDep.refused': 'Refusé',
    'devDep.depositPaid': 'Acompte versé',
    'devDep.fullyPaid': 'Payé',
    'devDep.stats': 'Statistiques',
    'devDep.revenues': 'Revenus',
    'devDep.activity30d': 'Activité des 30 derniers jours',
    'devDep.remind': 'Relancer',
    'devDep.remindConfirm': 'Envoyer un rappel aux clients avec devis en attente depuis plus de 3 jours ?',
    'devDep.noDevis': 'Aucun devis créé',
    'devDep.noResults': 'Aucun résultat',
    'devDep.bon': 'Bon de commande',
    'devDep.facture': 'Facture',
    'devDep.emailSent': 'Email envoyé le',
    'devDep.reminderSent': 'Rappel envoyé le',
    // Reparations
    'rep.title': 'Réparations',
    'rep.search': 'Rechercher une réparation...',
    'rep.new': 'Nouvelle réparation',
    'rep.deviceRef': 'Réf. appareil',
    'rep.brand': 'Marque',
    'rep.model': 'Modèle',
    'rep.problem': 'Problème',
    'rep.technician': 'Technicien',
    'rep.timeline': 'Chronologie',
    // Commandes
    'cmd.title': 'Commandes',
    'cmd.search': 'Rechercher une commande...',
    'cmd.piece': 'Pièce',
    'cmd.supplier': 'Fournisseur',
    'cmd.deposit': 'Acompte',
    'cmd.remaining': 'Reste à payer',
    // Clients
    'clients.title': 'Clients',
    'clients.search': 'Rechercher un client...',
    'clients.name': 'Nom',
    'clients.address': 'Adresse',
    'clients.addClient': 'Nouveau client',
    // Stock
    'stock.title': 'Gestion du Stock',
    'stock.search': 'Rechercher un article...',
    'stock.addArticle': 'Ajouter article',
    'stock.category': 'Catégorie',
    'stock.buyPrice': 'Prix achat',
    'stock.sellPrice': 'Prix vente',
    'stock.available': 'Disponible',
    // Dashboard
    'dash.title': 'Tableau de bord',
    'dash.openCaisse': 'Ouvrir la caisse',
    'dash.closeCaisse': 'Fermer la caisse',
    'dash.todaySales': 'Ventes du jour',
    'dash.monthSales': 'Ventes du mois',
    'dash.activeRepairs': 'Réparations actives',
    'dash.pendingOrders': 'Commandes en attente',
    // Login
    'login.title': 'Connexion',
    'login.username': 'Identifiant',
    'login.password': 'Code d\'accès',
    'login.submit': 'Se connecter',
    'login.clientAccess': 'Accès client',
    'login.staffAccess': 'Accès personnel',
    // Language
    'lang.select': 'Langue',
    // Client Portal
    'client.space': 'Espace Client',
    'client.repairs': 'Réparations',
    'client.boutique': 'Boutique',
    'client.orders': 'Commandes',
    'client.messages': 'Messages',
    'client.devis': 'Devis',
    'client.trackRepairs': 'Suivi de vos réparations',
    'client.noRepairs': 'Aucune réparation en cours',
    'client.trackOrders': 'Suivi de vos commandes',
    'client.noOrders': 'Aucune commande en cours',
    'client.shop': 'Boutique en ligne',
    'client.noProducts': 'Aucun produit disponible',
    'client.addToCart': 'Ajouter au panier',
    'client.yourMessages': 'Vos messages',
    'client.noMessages': 'Aucun message',
    'client.send': 'Envoyer',
    'client.brand': 'Marque',
    'client.model': 'Modèle',
    'client.problem': 'Problème',
    'client.status': 'Statut',
    'client.deposit': 'Acompte',
    'client.remaining': 'Reste à payer',
    'client.total': 'Total',
    'client.timeline': 'Chronologie',
    'client.noDevis': 'Aucun devis pour le moment',
    'client.acceptRefuse': 'Accepter / Refuser',
    'client.pay': 'Payer',
    // Landing
    'landing.mobileRepair': 'Réparation mobile en Guyane',
    'landing.staffSpace': 'ESPACE STAFF',
    'landing.staffDesc': 'Accès équipe technique',
    'landing.clientSpace': 'ESPACE CLIENT',
    'landing.clientDesc': 'Suivi de réparation',
    'landing.businessSpace': 'ESPACE ENTREPRISE',
    'landing.businessDesc': 'Portail B2B',
    'landing.contact': 'Contact',
    'landing.callWhatsapp': 'Appel & WhatsApp',
    'landing.writeUs': 'Écrivez-nous directement',
    'landing.hours': "Horaires d'ouverture",
    'landing.legal': 'Informations légales',
    'landing.capital': 'au capital de',
    'landing.headquarters': 'Siège',
    'landing.allRights': 'Tous droits réservés',
    'landing.heroSubtitle': 'Votre spécialiste réparation mobile en Guyane',
    'landing.mondayFriday': 'Lundi - Vendredi',
    'landing.saturday': 'Samedi',
    'landing.sunday': 'Dimanche',
    'landing.closed': 'Fermé',
    'landing.companyType': 'Société par Actions Simplifiée (SAS)',
    'landing.openMaps': 'Ouvrir dans Maps',
    'landing.rcs': 'RCS',
    'landing.siret': 'SIRET',
    'landing.euid': 'EUID',
    'landing.shopAddress': 'Point de vente',
    // Login extra
    'login.clientSpace': 'Espace Client',
    'login.businessSpace': 'Espace Entreprise',
    'login.staffSpace': 'Espace Staff',
    'login.connectYou': 'Connectez-vous',
    'login.phoneNumber': 'Numéro de téléphone',
    'login.proEmail': 'Email professionnel',
    'login.pin': 'Code PIN (4 ou 6 chiffres)',
    'login.pinHint': 'Saisissez votre code via le clavier ou le pavé numérique.',
    'login.connecting': 'Connexion...',
    'login.connect': 'Se connecter',
    'login.noAccount': 'Pas encore de compte ?',
    'login.createAccount': 'Créer un compte',
    'login.forgotPwd': 'Mot de passe oublié ?',
    'login.notRegistered': 'Pas encore inscrit ?',
    'login.businessRegister': 'Inscription entreprise',
    'login.secure': 'Connexion sécurisée',
    'login.caricature': 'Je crée ma caricature',
    'login.backHome': "Retour à l'accueil",
    'login.wrongCredentials': 'Identifiants incorrects',
    'login.pinError': 'Le code PIN doit contenir 4 ou 6 chiffres',
    'login.b2bPassword': 'Mot de passe',
    'login.b2bPlaceholder': 'Votre mot de passe',
    'login.yourId': 'Votre identifiant',
    // Dashboard extra
    'dash.hello': 'Bonjour',
    'dash.loggedAs': 'Connecté en tant que',
    'dash.caisseOpen': 'Caisse ouverte',
    'dash.closeCaisseReminder': 'Pensez à fermer la caisse',
    'dash.noCaisse': 'Aucune caisse ouverte',
    'dash.openCaisseTitle': 'Ouvrir la caisse',
    'dash.openTotal': 'Total ouverture',
    'dash.opening': 'Ouverture...',
    'dash.open': 'Ouvrir',
    'dash.searchPlaceholder': 'Rechercher par référence, client, téléphone...',
    'dash.noResults': 'Aucun résultat trouvé',
    'dash.today': "Aujourd'hui",
    'dash.thisMonth': 'Ce mois',
    'dash.completed': 'Terminées',
    'dash.repairsSub': 'réparations',
    'dash.inProgress': 'En cours',
    'dash.waitingParts': 'attente pièces inclus',
    'dash.registeredMonth': 'enregistrées ce mois',
    'dash.statsTitle': 'Statistiques & Analytics',
    'dash.statsDesc': 'CA, réparations, B2B, clients',
    'dash.brandsModelsLabel': 'Marques & Modèles',
    'dash.brandsModelsDesc': 'Gérer le catalogue des appareils',
    'dash.b2bPaymentsLabel': 'Paiements B2B',
    'dash.b2bPaymentsDesc': 'Suivi des factures et paiements',
    'dash.stockAlerts': 'Alertes Stock',
    'dash.lowStock': 'produits en stock faible',
    'dash.outOfStock': 'en rupture de stock',
    'dash.recentRepairs': 'Dernières réparations',
    'dash.noClient': 'Sans client',
    'dash.unclosedTitle': 'Caisse non fermée',
    'dash.unclosedNotClosed': "n'a pas été fermée",
    'dash.contactAdmin': 'Veuillez contacter un administrateur pour la fermer avant de continuer.',
    'dash.mustClose': 'Vous devez la fermer avant de pouvoir continuer à travailler.',
    'dash.forceClose': 'Fermeture forcée',
    'dash.closing': 'Fermeture...',
    'dash.closeNormal': 'Fermer normalement',
    'dash.noCaisseToday': "Aucune caisse n'est ouverte pour aujourd'hui.",
    'dash.openQuestion': 'Souhaitez-vous ouvrir la caisse maintenant ?',
    'dash.dontOpen': 'Ne pas ouvrir (continuer)',
    'dash.salesBlocked': "Les ventes seront bloquées tant que la caisse n'est pas ouverte.",
    'dash.calculation': 'Calcul',
    'dash.repairs': 'Réparations',
    'dash.addDevice': 'Ajouter',
    'dash.clients': 'Clients',
    'dash.openedBy': 'ouverte par',
    'dash.unknown': 'inconnu',
    'dash.forceCloseConfirm': 'Fermer de force la caisse du',
    'dash.errorForceClose': 'Erreur lors de la fermeture forcée',
    'dash.errorOpenCaisse': "Erreur lors de l'ouverture de la caisse",
    // Devis Accept
    'devisAccept.error': 'Erreur',
    'devisAccept.notFound': 'Devis non trouvé',
    'devisAccept.refused': 'Devis refusé',
    'devisAccept.refusedMsg': 'Vous avez refusé le devis',
    'devisAccept.thanks': 'Merci de nous avoir informé.',
    'devisAccept.accepted': 'Devis accepté !',
    'devisAccept.acceptedMsg': "Merci d'avoir accepté le devis",
    'devisAccept.bonCommande': 'Bon de commande',
    'devisAccept.facture': 'Facture',
    'devisAccept.emailSent': 'Un email avec votre bon de commande, le code de validation et vos identifiants de connexion a été envoyé.',
    'devisAccept.proceedPayment': 'Procéder au paiement',
    'devisAccept.paymentMsg': 'Pour finaliser votre commande, veuillez verser un acompte ou le paiement complet :',
    'devisAccept.deposit50': 'Acompte 50%',
    'devisAccept.fullPayment': 'Paiement complet',
    'devisAccept.alreadyAccepted': 'Ce devis a déjà été accepté.',
    'devisAccept.alreadyRefused': 'Ce devis a été refusé.',
    'devisAccept.statusMsg': 'Statut du devis',
    'devisAccept.payDeposit': 'Payer acompte 50%',
    'devisAccept.homeRepairQuote': 'Devis de réparation à domicile',
    'devisAccept.hello': 'Bonjour',
    'devisAccept.findBelow': 'Veuillez trouver ci-dessous le détail de votre devis :',
    'devisAccept.designation': 'Désignation',
    'devisAccept.travelFee': 'Frais de déplacement',
    'devisAccept.tvaNote': 'TVA non applicable, art. 293B du CGI. Devis valable 30 jours.',
    'devisAccept.refuse': 'Refuser',
    'devisAccept.accept': 'Accepter le devis',
    'devisAccept.confirmRefuse': 'Êtes-vous sûr de vouloir refuser ce devis ?',
    // Payment
    'payment.secure': 'Paiement sécurisé',
    'payment.error': 'Erreur',
    'payment.backToDevis': 'Retour au devis',
    'payment.notAccepted': 'Devis non accepté',
    'payment.mustAcceptFirst': "Vous devez d'abord accepter le devis avant de procéder au paiement.",
    'payment.viewDevis': 'Voir le devis',
    'payment.fullyPaid': 'Facture entièrement payée',
    'payment.alreadyPaid': 'est déjà entièrement payé.',
    'payment.accessClient': 'Accéder à votre espace client',
    'payment.deposit50': 'Acompte 50%',
    'payment.fullPayment': 'Paiement complet',
    'payment.devis': 'Devis',
    'payment.client': 'Client',
    'payment.totalDevis': 'Total du devis',
    'payment.alreadyPaidAmount': 'Déjà payé',
    'payment.remaining': 'Reste à payer',
    'payment.depositPercent': 'Acompte (50%)',
    'payment.amountToPay': 'Montant à payer',
    'payment.pay': 'Payer',
    'payment.redirecting': 'Redirection vers Stripe...',
    'payment.securedBy': 'Paiement sécurisé par Stripe',
    'payment.urlNotAvailable': 'URL de paiement non disponible',
    'payment.creationError': 'Erreur lors de la création du paiement',
    // Payment success
    'paySuccess.confirmed': 'Paiement confirmé !',
    'paySuccess.paymentFor': 'Votre paiement pour le devis',
    'paySuccess.registered': 'a été enregistré avec succès.',
    'paySuccess.depositRegistered': 'Acompte enregistré !',
    'paySuccess.depositFor': 'Votre acompte pour le devis',
    'paySuccess.depositDone': 'a été enregistré.',
    'paySuccess.checking': 'Vérification en cours...',
    'paySuccess.pleaseWait': 'Nous vérifions votre paiement, veuillez patienter.',
    'paySuccess.waitingConfirm': 'En attente de confirmation',
    'paySuccess.processing': 'Votre paiement est en cours de traitement. Vous recevrez un email de confirmation.',
    'paySuccess.totalInvoice': 'Total facture',
    'paySuccess.amountPaid': 'Montant payé',
    'paySuccess.remaining': 'Reste à payer',
    'paySuccess.payRemaining': 'Payer le reste',
    'paySuccess.loginClient': 'Connectez-vous à votre espace client',
    // Registration
    'register.clientTitle': 'Créer un compte client',
    'register.fullName': 'Nom complet',
    'register.phone': 'Téléphone',
    'register.email': 'Email (optionnel)',
    'register.address': 'Adresse (optionnel)',
    'register.pin': 'Code PIN (4 ou 6 chiffres)',
    'register.confirmPin': 'Confirmer le code PIN',
    'register.creating': 'Création en cours...',
    'register.createAccount': 'Créer mon compte',
    'register.alreadyAccount': 'Déjà un compte ?',
    'register.login': 'Se connecter',
    'register.backHome': "Retour à l'accueil",
    'register.pinError': 'Le code PIN doit contenir 4 ou 6 chiffres',
    'register.pinNoMatch': 'Les codes PIN ne correspondent pas',
    'register.pinMinLength': 'Le code PIN doit contenir au moins 4 chiffres',
    // B2B Registration
    'b2bRegister.title': 'Inscription Entreprise',
    'b2bRegister.subtitle': 'Créez votre compte professionnel',
    'b2bRegister.companyName': "Nom de l'entreprise",
    'b2bRegister.managerName': 'Nom du gérant',
    'b2bRegister.proEmail': 'Email professionnel',
    'b2bRegister.phone': 'Téléphone',
    'b2bRegister.address': 'Adresse',
    'b2bRegister.siret': 'SIRET',
    'b2bRegister.password': 'Mot de passe',
    'b2bRegister.confirmPassword': 'Confirmer le mot de passe',
    'b2bRegister.kbis': 'Extrait KBIS (PDF)',
    'b2bRegister.kbisDesc': 'Téléchargez votre extrait KBIS ou tout document justificatif (PDF)',
    'b2bRegister.dropFile': 'Cliquez ou déposez votre fichier ici',
    'b2bRegister.creating': 'Inscription en cours...',
    'b2bRegister.submit': "S'inscrire",
    'b2bRegister.success': 'Inscription réussie !',
    'b2bRegister.successMsg': 'Votre compte entreprise est en cours de validation. Vous recevrez un email de confirmation.',
    'b2bRegister.goLogin': 'Aller à la connexion',
    'b2bRegister.fillAll': 'Veuillez remplir tous les champs obligatoires',
    'b2bRegister.siretError': 'Le SIRET doit contenir 14 chiffres',
    'b2bRegister.pwdNoMatch': 'Les mots de passe ne correspondent pas',
    'b2bRegister.pwdMinLength': 'Le mot de passe doit contenir au moins 6 caractères',
    'b2bRegister.kbisRequired': 'Veuillez télécharger votre extrait KBIS',
    'b2bRegister.alreadyAccount': 'Déjà inscrit ?',
    // Reset password
    'reset.forgotTitle': 'Mot de passe oublié',
    'reset.forgotDesc': 'Recevez un lien de réinitialisation par email',
    'reset.enterEmail': 'Veuillez saisir votre email',
    'reset.emailSent': 'Email envoyé',
    'reset.emailSentMsg': 'Si un compte existe avec cette adresse, vous recevrez un email avec un lien pour réinitialiser votre mot de passe.',
    'reset.linkValid': 'Le lien est valable pendant 1 heure.',
    'reset.backLogin': 'Retour à la connexion',
    'reset.clientEmail': 'Adresse email de votre compte',
    'reset.sending': 'Envoi en cours...',
    'reset.sendLink': 'Envoyer le lien de réinitialisation',
    'reset.newPwdTitle': 'Nouveau mot de passe',
    'reset.newPwdDesc': 'Choisissez votre nouveau mot de passe',
    'reset.newPwd': 'Nouveau mot de passe',
    'reset.confirmPwd': 'Confirmer le mot de passe',
    'reset.resetting': 'Réinitialisation...',
    'reset.resetPwd': 'Réinitialiser le mot de passe',
    'reset.pwdReset': 'Mot de passe réinitialisé',
    'reset.pwdResetMsg': 'Votre mot de passe a été modifié avec succès.',
    'reset.pwdMinLength': 'Le mot de passe doit contenir au moins 4 caractères',
    'reset.pwdNoMatch': 'Les mots de passe ne correspondent pas',
    'reset.error': 'Une erreur est survenue',
    // B2B Dashboard
    'b2b.welcome': 'Bienvenue',
    'b2b.newRepair': 'Nouvelle réparation',
    'b2b.registerDevice': 'Enregistrer un appareil',
    'b2b.myRepairs': 'Mes réparations',
    'b2b.viewAll': 'Voir toutes les réparations',
    'b2b.recentRepairs': 'Dernières réparations',
    'b2b.noRepairs': 'Aucune réparation',
    'b2b.repairRegistered': 'Réparation enregistrée',
    'b2b.reference': 'Référence',
    'b2b.viewDetails': 'Voir les détails',
    'b2b.anotherRepair': 'Nouvelle réparation',
    'b2b.deviceInfo': 'Informations appareil',
    'b2b.brand': 'Marque',
    'b2b.model': 'Modèle',
    'b2b.backGlass': 'Vitre arrière',
    'b2b.backGlassBroken': 'Vitre arrière cassée',
    'b2b.backGlassOk': 'Vitre arrière intacte',
    'b2b.providePart': 'Je fournis la pièce',
    'b2b.partByShop': 'La pièce sera fournie par R.E.Mobiles',
    'b2b.lockCode': 'Code de verrouillage',
    'b2b.lockTypeCode': 'Code (chiffres/lettres)',
    'b2b.lockTypeSchema': 'Schéma',
    'b2b.problem': 'Problème / Description',
    'b2b.brokenParts': 'Pièces non fonctionnelles',
    'b2b.deliveryMethod': 'Mode de livraison',
    'b2b.inStore': 'En boutique',
    'b2b.inStoreDesc': 'Dépôt au magasin',
    'b2b.postal': 'Envoi postal',
    'b2b.postalDesc': 'Avec numéro de suivi',
    'b2b.pickup': 'Récupération',
    'b2b.pickupDesc': 'On vient chercher',
    'b2b.trackingNumber': 'Numéro de suivi',
    'b2b.pickupAddress': 'Adresse de récupération',
    'b2b.devicePhotos': "Photos de l'appareil",
    'b2b.addPhotos': 'Cliquez pour ajouter des photos',
    'b2b.additionalNotes': 'Notes supplémentaires',
    'b2b.submitting': 'Envoi en cours...',
    'b2b.submitRepair': 'Enregistrer la réparation',
    'b2b.brandModelRequired': 'Marque et modèle sont obligatoires',
    'b2b.noRepairFound': 'Aucune réparation trouvée',
    'b2b.allStatus': 'Toutes',
    'b2b.documents': 'Documents & Factures',
    'b2b.documentsDesc': 'Validez vos bons de commande et téléchargez vos factures',
    'b2b.pendingValidation': 'Bons de commande à valider',
    'b2b.enterCode': 'Saisissez le code reçu par email pour valider chaque bon de commande.',
    'b2b.validate': 'Valider',
    'b2b.invoices': 'Factures',
    'b2b.noInvoices': 'Aucune facture disponible',
    'b2b.device': 'Appareil',
    'b2b.amount': 'Montant',
    'b2b.date': 'Date',
    'b2b.actions': 'Actions',
    'b2b.paid': 'Payée',
    'b2b.repairAccepted': 'Réparation acceptée par le staff',
    'b2b.repairRefused': 'Réparation refusée par le staff',
    'b2b.orderValidated': 'Bon de commande validé',
    'b2b.noPhotos': 'Aucune photo',
    'b2b.history': 'Historique',
    'b2b.repairPrice': 'Prix réparation',
    'b2b.diagPrice': 'Prix diagnostic',
    'b2b.priceWaiting': 'En attente - sera fixé par R.E.Mobiles',
    'b2b.createdOn': 'Créée le',
    'b2b.clear': 'Effacer',
    'b2b.thisMonth': 'Ce mois-ci',
    'b2b.waitingReception': 'Att. réception',
    'b2b.received': 'Reçu',
    'b2b.inProgress': 'En Cours',
    'b2b.waitingParts': 'Att. Pièces',
    'b2b.completed': 'Terminé',
    'b2b.delivered': 'Livré',
    // B2B Devis
    'b2bDevis.title': 'Devis Déplacement',
    'b2bDevis.pending': 'en attente',
    'b2bDevis.noDevis': 'Aucun devis',
    'b2bDevis.noDevisDesc': "Vous n'avez aucun devis de déplacement pour le moment.",
    'b2bDevis.travelFee': 'Frais de déplacement',
    'b2bDevis.validationCode': 'Code de validation',
    'b2bDevis.codeHint': 'Saisissez le code à 6 chiffres reçu par email.',
    'b2bDevis.acceptFirst': 'Veuillez d\'abord accepter le devis pour pouvoir le valider.',
    'b2bDevis.payDeposit': 'Payer acompte 50%',
    'b2bDevis.payFull': 'Payer le total',
    'b2bDevis.payRemaining': 'Payer le reste',
    'b2bDevis.alreadyPaid': 'Déjà payé',
    'b2bDevis.remaining': 'Reste à payer',
    'b2bDevis.invoiceDownload': 'Télécharger la facture',
    'b2bDevis.orderDownload': 'Télécharger le bon de commande',
    'b2bDevis.quoteDownload': 'Télécharger le devis',
    // Admin Site Settings
    'adminSettings.title': "Page d'accueil",
    'adminSettings.preview': 'Aperçu',
    'adminSettings.saving': 'Sauvegarde...',
    'adminSettings.save': 'Sauvegarder',
    'adminSettings.saved': 'Sauvegardé !',
    'adminSettings.error': 'Erreur',
    'adminSettings.heroSection': 'Hero / En-tête',
    'adminSettings.mainTitle': 'Titre principal',
    'adminSettings.subtitle': 'Sous-titre',
    'adminSettings.accentColor': 'Couleur accent (hex)',
    'adminSettings.bgImage': 'Image de fond',
    'adminSettings.change': 'Changer',
    'adminSettings.companyInfo': 'Informations entreprise',
    'adminSettings.companyName': 'Nom entreprise',
    'adminSettings.companyType': 'Type (SAS, SARL...)',
    'adminSettings.capital': 'Capital',
    'adminSettings.rcs': 'RCS',
    'adminSettings.siret': 'SIRET',
    'adminSettings.euid': 'EUID',
    'adminSettings.headquarters': 'Siège social',
    'adminSettings.salesPoint': 'Point de vente',
    'adminSettings.contactHours': 'Contact & Horaires',
    'adminSettings.phone': 'Téléphone',
    'adminSettings.whatsapp': 'WhatsApp',
    'adminSettings.email': 'Email',
    'adminSettings.googleMaps': 'Google Maps query',
    'adminSettings.gallery': 'Galerie photos',
    'adminSettings.addImage': 'Ajouter une image',
    // Admin Database
    'adminDb.title': 'Administration Base de Données',
    'adminDb.subtitle': 'Export, import et gestion des données',
    'adminDb.accessDenied': 'Accès refusé',
    'adminDb.adminOnly': 'Cette page est réservée aux administrateurs',
    'adminDb.clients': 'Clients',
    'adminDb.users': 'Utilisateurs',
    'adminDb.repairs': 'Réparations',
    'adminDb.stockArticles': 'Articles Stock',
    'adminDb.exportTitle': 'Export Base de Données',
    'adminDb.exportDesc': 'Exporter toutes les données (clients, utilisateurs, stock, réparations, ventes) en fichier JSON.',
    'adminDb.exportConfirm': 'Exporter toute la base de données ?',
    'adminDb.exportBtn': 'Exporter la base complète',
    'adminDb.exportSuccess': 'Export réussi !',
    'adminDb.exportError': "Erreur lors de l'export",
    'adminDb.importTitle': 'Import Base de Données',
    'adminDb.importDesc': 'Importer un fichier JSON pour restaurer ou migrer les données.',
    'adminDb.fileSelected': 'Fichier sélectionné',
    'adminDb.uploading': 'Upload du fichier...',
    'adminDb.importDone': 'Import terminé !',
    'adminDb.importSuccess': 'Import réussi !',
    'adminDb.importError': "Erreur lors de l'import",
    'adminDb.importClientsBtn': 'Importer Clients',
    'adminDb.importFullBtn': 'Import Complet',
    'adminDb.importWarning': "L'import complet remplacera les données existantes",
    'adminDb.importConfirm': 'ATTENTION: Cette action va remplacer les données existantes. Continuer ?',
    'adminDb.importClientsConfirm': 'Importer les clients ? Les comptes seront créés avec le numéro de téléphone comme identifiant.',
    'adminDb.selectFile': 'Veuillez sélectionner un fichier',
    'adminDb.selectFileClients': 'Veuillez sélectionner un fichier JSON avec les clients',
    'adminDb.logsTitle': 'Journal des opérations',
    'adminDb.noLogs': 'Aucune opération enregistrée',
    // Admin B2B
    'adminB2b.title': 'Gestion B2B',
    'adminB2b.home': 'Accueil',
    'adminB2b.monthlyRecap': 'Récap Mensuel',
    'adminB2b.sending': 'Envoi...',
    'adminB2b.search': 'Rechercher...',
    'adminB2b.recapTitle': 'Résultat du récapitulatif mensuel',
    'adminB2b.recapSent': 'Envoyé',
    'adminB2b.recapSkipped': 'Aucune réparation',
    'adminB2b.recapError': 'Erreur',
    'adminB2b.companies': 'Entreprises',
    'adminB2b.b2bRepairs': 'Réparations B2B',
    'adminB2b.paymentHistory': 'Historique Paiements',
    'adminB2b.all': 'Toutes',
    'adminB2b.pending': 'En attente',
    'adminB2b.validated': 'Validées',
    'adminB2b.refused': 'Refusées',
    'adminB2b.suspended': 'Suspendues',
    'adminB2b.noCompany': 'Aucune entreprise trouvée',
    'adminB2b.phone': 'Téléphone',
    'adminB2b.siret': 'SIRET',
    'adminB2b.address': 'Adresse',
    'adminB2b.registeredOn': 'Inscrit le',
    'adminB2b.validatedBy': 'Validé par',
    'adminB2b.downloadKbis': 'Télécharger KBIS',
    'adminB2b.validate': 'Valider',
    'adminB2b.refuse': 'Refuser',
    'adminB2b.suspend': 'Suspendre',
    'adminB2b.confirmValidate': 'Voulez-vous valider cette entreprise ?',
    'adminB2b.confirmRefuse': 'Voulez-vous refuser cette entreprise ?',
    'adminB2b.confirmSuspend': 'Voulez-vous suspendre cette entreprise ?',
    'adminB2b.pendingReception': 'En attente de réception',
    'adminB2b.confirmReception': 'Confirmer réception',
    'adminB2b.ref': 'Réf',
    'adminB2b.company': 'Entreprise',
    'adminB2b.brandModel': 'Marque / Modèle',
    'adminB2b.problem': 'Problème',
    'adminB2b.delivery': 'Livraison',
    'adminB2b.price': 'Prix',
    'adminB2b.status': 'Statut',
    'adminB2b.actions': 'Actions',
    'adminB2b.noRepairs': 'Aucune réparation B2B trouvée',
    'adminB2b.postal': 'Postal',
    'adminB2b.pickup': 'Récup.',
    'adminB2b.inStore': 'Boutique',
    'adminB2b.changeStatus': 'Changer le statut',
    'adminB2b.setPrice': 'Fixer le prix',
    'adminB2b.repairPrice': 'Prix réparation',
    'adminB2b.diagPrice': 'Prix diagnostic',
    'adminB2b.locked': 'Verrouillé (payé)',
    'adminB2b.total': 'Total',
    'adminB2b.existingInvoices': 'Factures existantes',
    'adminB2b.diagnostic': 'Diagnostic',
    'adminB2b.repair': 'Réparation',
    'adminB2b.combined': 'Combinée',
    'adminB2b.paidMethod': 'Payée',
    'adminB2b.awaitingPayment': 'En attente',
    'adminB2b.markPaid': 'Payé',
    'adminB2b.finalize': 'Finaliser la facturation',
    'adminB2b.backGlassBroken': 'Vitre arr. cassée',
    'adminB2b.clientPart': 'Pièce client',
    'adminB2b.bcValidated': 'BC validé',
    'adminB2b.invoiceCancelled': 'Facture annulée',
    'adminB2b.monthPrompt': 'Mois (1-12) ? Laissez vide pour le mois précédent :',
    'adminB2b.yearPrompt': 'Année ?',
    'adminB2b.paymentMethodPrompt': 'Mode de paiement ?',
    'adminB2b.filterCompany': 'Entreprise',
    'adminB2b.filterDateStart': 'Date début',
    'adminB2b.filterDateEnd': 'Date fin',
    'adminB2b.filter': 'Filtrer',
    'adminB2b.clearFilter': 'Effacer',
    'adminB2b.totalCollected': 'Total encaissé',
    'adminB2b.payments': 'paiement(s)',
    'adminB2b.payHistoryTitle': 'Historique des paiements B2B',
    'adminB2b.noPayments': 'Aucun paiement B2B enregistré',
    'adminB2b.invoice': 'Facture',
    // Users Management
    'users.title': 'Gestion des utilisateurs',
    'users.count': 'utilisateur(s)',
    'users.new': 'Nouvel utilisateur',
    'users.edit': "Modifier l'utilisateur",
    'users.username': "Nom d'utilisateur",
    'users.password': 'Mot de passe',
    'users.newPassword': 'Nouveau mot de passe (laisser vide pour ne pas changer)',
    'users.role': 'Rôle',
    'users.roleAdmin': 'Administrateur',
    'users.roleUser': 'Commercial',
    'users.roleTech': 'Technicien',
    'users.status': 'Statut',
    'users.active': 'Actif',
    'users.inactive': 'Inactif',
    'users.createdAt': 'Créé le',
    'users.noUsers': 'Aucun utilisateur',
    'users.accessDenied': 'Accès réservé aux administrateurs',
    'users.deleteConfirm': 'Supprimer cet utilisateur ?',
    // Clients (extra keys)
    'clients.manage': 'Gestion des Clients',
    'clients.total': 'clients au total',
    'clients.add': 'Ajouter',
    'clients.noClients': 'Aucun client trouvé',
    'clients.type': 'Type',
    'clients.discount': 'Remise',
    'clients.account': 'Compte',
    'clients.sent': 'Envoyé',
    'clients.activeAccount': 'Actif',
    'clients.noEmail': "Pas d'email",
    'clients.editClient': 'Modifier le client',
    'clients.newClient': 'Nouveau client',
    'clients.company': 'Société',
    'clients.clientType': 'Type de client',
    'clients.individual': 'Particulier',
    'clients.business': 'Entreprise',
    'clients.discountPct': 'Remise (%)',
    'clients.deleteConfirm': 'Supprimer ce client ?',
    'clients.page': 'Page',
    // Stats
    'stats.title': 'Statistiques & Analytics',
    'stats.revenue': 'Chiffre d\'affaires',
    'stats.repairs': 'Réparations',
    'stats.b2b': 'B2B',
    'stats.clients': 'Clients',
    'stats.back': 'Retour',
    'stats.monthlyRevenue': 'CA Mensuel',
    'stats.revenueByType': 'CA par type',
    'stats.revenueByPayment': 'CA par mode de paiement',
    'stats.totalRevenue': 'CA Total (12 mois)',
    'stats.repairsByStatus': 'Par statut',
    'stats.repairsByBrand': 'Par marque',
    'stats.topModels': 'Top modèles',
    'stats.monthly': 'Évolution mensuelle',
    'stats.totalRepairs': 'Total réparations',
    'stats.avgRepairTime': 'Durée moyenne',
    'stats.completionRate': 'Taux achèvement',
    'stats.b2bCompanies': 'Entreprises B2B',
    'stats.b2bRepairs': 'Réparations B2B',
    'stats.b2bRevenue': 'CA B2B',
    'stats.b2bByCompany': 'Par entreprise',
    'stats.totalClients': 'Total clients',
    'stats.newThisMonth': 'Nouveaux ce mois',
    'stats.withAccount': 'Avec compte',
    'stats.clientsByType': 'Par type',
    'stats.registrations': 'Inscriptions mensuelles',
    'stats.noData': 'Aucune donnée',
    // Reparations (extra)
    'rep.manage': 'Gestion des Réparations',
    'rep.noRepairs': 'Aucune réparation trouvée',
    'rep.allStatuses': 'Tous les statuts',
    'rep.imei': 'IMEI / Série',
    'rep.client': 'Client',
    'rep.phone': 'Tél',
    'rep.date': 'Date',
    'rep.deposit': 'Acompte',
    'rep.printFiche': 'Imprimer fiche',
    'rep.printEtiquette': 'Imprimer étiquette',
    'rep.deleteConfirm': 'Supprimer cette réparation ?',
    'rep.addDeposit': 'Ajouter acompte',
    'rep.depositAmount': 'Montant acompte',
    'rep.paymentMode': 'Mode de paiement',
    'rep.depositHistory': 'Historique acomptes',
    'rep.totalDeposits': 'Total acomptes',
    'rep.changeStatus': 'Changer le statut',
    'rep.notes': 'Notes internes',
    'rep.sendChat': 'Envoyer message',
    'rep.noTimeline': 'Aucun événement',
    // Commandes (extra)
    'cmd.manage': 'Gestion des Commandes',
    'cmd.noOrders': 'Aucune commande trouvée',
    'cmd.allStatuses': 'Tous les statuts',
    'cmd.ordered': 'Commandée',
    'cmd.received': 'Reçue',
    'cmd.cancelled': 'Annulée',
    'cmd.status': 'Statut',
    'cmd.ref': 'Réf',
    'cmd.addOrder': 'Nouvelle commande',
    'cmd.editOrder': 'Modifier la commande',
    'cmd.deleteConfirm': 'Supprimer cette commande ?',
    // Stock (extra)
    'stock.manage': 'Gestion du Stock',
    'stock.noItems': 'Aucun article trouvé',
    'stock.barcode': 'Code-barres',
    'stock.reference': 'Référence',
    'stock.alert': 'Alerte',
    'stock.lowStockAlert': 'Stock faible',
    'stock.addForm': 'Ajouter un article',
    'stock.editForm': "Modifier l'article",
    'stock.deleteConfirm': 'Supprimer cet article ?',
    // Historique
    'hist.title': 'Historique des ventes',
    'hist.search': 'Rechercher une vente...',
    'hist.noSales': 'Aucune vente trouvée',
    'hist.ref': 'Réf.',
    'hist.client': 'Client',
    'hist.amount': 'Montant',
    'hist.payment': 'Paiement',
    'hist.date': 'Date',
    'hist.articles': 'Articles',
    'hist.refund': 'Rembourser',
    'hist.refundConfirm': 'Rembourser cette vente ?',
    // Paiements
    'pay.title': 'Paiements en ligne',
    'pay.search': 'Rechercher...',
    'pay.noPayments': 'Aucun paiement trouvé',
    'pay.ref': 'Référence',
    'pay.client': 'Client',
    'pay.amount': 'Montant',
    'pay.status': 'Statut',
    'pay.date': 'Date',
    'pay.type': 'Type',
    // Caisse
    'caisse.title': 'Historique des Caisses',
    'caisse.noCaisse': 'Aucune caisse trouvée',
    'caisse.openedBy': 'Ouverte par',
    'caisse.openingAmount': 'Montant ouverture',
    'caisse.closingAmount': 'Montant fermeture',
    'caisse.sales': 'Ventes',
    'caisse.openDate': 'Ouverture',
    'caisse.closeDate': 'Fermeture',
    // Notes
    'notes.title': 'Notes',
    'notes.new': 'Nouvelle note',
    'notes.noNotes': 'Aucune note',
    'notes.deleteConfirm': 'Supprimer cette note ?',
    // Etiquettes
    'labels.title': 'Étiquettes',
    'labels.search': 'Rechercher...',
    'labels.print': 'Imprimer',
    'labels.selectAll': 'Tout sélectionner',
    'labels.noLabels': 'Aucune étiquette',
    // Calcul Prix
    'calc.title': 'Calcul Prix',
    'calc.searchDevice': 'Rechercher un appareil...',
    'calc.selectRepair': 'Sélectionner une réparation',
    'calc.generateQuote': 'Générer un devis',
    'calc.generateInvoice': 'Générer une facture',
    // Boutique
    'boutique.title': 'Commandes Boutique',
    'boutique.noOrders': 'Aucune commande',
    'boutique.orderRef': 'Réf. commande',
    'boutique.clientName': 'Client',
    'boutique.total': 'Total',
    'boutique.status': 'Statut',
    // Chat
    'chat.title': 'Messagerie',
    'chat.noConversations': 'Aucune conversation',
    'chat.typeMessage': 'Tapez votre message...',
    // Brands & Models
    'brands.title': 'Marques & Modèles',
    'brands.addBrand': 'Ajouter une marque',
    'brands.addModel': 'Ajouter un modèle',
    'brands.noBrands': 'Aucune marque',
    'brands.deleteConfirm': 'Supprimer cette marque ?',
    // Remcaches
    'remcaches.title': 'Remises en Cache',
    'remcaches.noItems': 'Aucun article',
    // Close Caisse
    'closeCaisse.title': 'Fermeture de Caisse',
    'closeCaisse.countCoins': 'Comptage des espèces',
    'closeCaisse.theoreticalTotal': 'Total théorique',
    'closeCaisse.actualTotal': 'Total réel',
    'closeCaisse.difference': 'Écart',
    'closeCaisse.close': 'Fermer la caisse',
    'closeCaisse.closing': 'Fermeture...',
    // Client Passwords
    'clientPwd.title': 'Mots de Passe Clients',
    'clientPwd.search': 'Rechercher un client...',
    'clientPwd.noClients': 'Aucun client trouvé',
    'clientPwd.generatePin': 'Générer PIN',
    'clientPwd.sendByEmail': 'Envoyer par email',
    // B2B Payments
    'b2bPay.title': 'Paiements B2B',
    'b2bPay.noPayments': 'Aucun paiement',
    // Reparation Form
    'repForm.title': 'Ajouter un appareil',
    'repForm.editTitle': 'Modifier la réparation',
    'repForm.brand': 'Marque',
    'repForm.model': 'Modèle',
    'repForm.imei': 'IMEI / N° de série',
    'repForm.lockCode': 'Code de verrouillage',
    'repForm.problem': 'Problème constaté',
    'repForm.client': 'Client',
    'repForm.technician': 'Technicien assigné',
    'repForm.price': 'Prix de la réparation',
    'repForm.submit': 'Enregistrer',
    'repForm.submitting': 'Enregistrement...',
    // SumUp payment link
    'sumup.acceptOnlinePayment': 'Accepter paiement en ligne (SumUp)',
    'sumup.acceptOnlinePaymentDesc': 'Le client pourra demander un lien de paiement SumUp',
    'sumup.requestLink': 'Demande de lien de paiement SumUp',
    'sumup.requestSent': 'Demande envoyée ! Vous recevrez le lien par email sous peu.',
    'sumup.alreadyRequested': 'Demande déjà en cours.',
    'sumup.onlinePayment': 'Paiement en ligne SumUp',
    'sumup.receiveLink': 'Recevez un lien de paiement sécurisé par email',
    'sumup.linkRequested': 'Lien demandé',
    'sumup.pendingRequests': 'Demandes de lien SumUp',
    'sumup.pending': 'en attente',
    'sumup.pasteLinkHere': 'Coller le lien SumUp ici...',
    'sumup.send': 'Envoyer',
    'sumup.linkSent': 'Lien SumUp envoyé au client par email !',
  };

export default fr;
